export default {
  lobby: {
    theme34_dz: {
      promote: 'Indique\nGratuiamente\\nEganhe',
      events: 'Promoções\ne Bônus'
    },
    theme27_dz: {
      home: {
        promoteTitle: 'Ganhe um milhão por mês',
        popular: 'Popular',
        total: 'Tudo',
        distancial: 'Restantes',
        recebido: 'Recebido',
        totalAmount: 'Montante fixo',
        invite: 'Convidar',
        player: 'Jogador',
        open: 'Abrir',
        justWin: 'Acabei de ganhar',
        jackpotTitle: 'Jogue gratuitamente e ganhe prêmios incríveis!',
        downloadTips:
          'Velocidade extrema e estabilidade, tudo na ponta dos seus dedos para você desfrutar'
      },
      header: { inviteFriends: 'Convidar amigos' }
    },
    theme19_dz: { search: 'Pesquisar' },
    theme33_dz: {
      search: 'procurar',
      discount: 'Promoção',
      jackpot: 'Conjunto de jackpot',
      helpCenter: 'Centro de ajuda',
      popular: 'Popular',
      pgTop: 'PG Slots',
      jiliLucky: 'JILI Slots',
      ppSlot: 'PP Slots',
      feature: 'JDB Slots',
      featuredGames: 'Jogos em destaque',
      feast: 'Festa de entretenimento',
      galore: 'Festa de entretenimento',
      downloadTitle: 'Melhores aplicativos de jogos de aposta mobile',
      downloadContent:
        'Baixe o aplicativo móvel e experimente os jogos mais emocionantes da internet: caça-níqueis, pesca, jogos de cartas, jogos ao vivo, apostas esportivas e blockchain. Com tela 5D, você desfruta de uma experiência de jogo incrível a qualquer hora e em qualquer lugar.',
      googleText: 'Get it on Google Play',
      appText: 'Get it on the App store',
      centerWallet: 'Carteira\nprincipal',
      withdrawalManagement33: 'Gestão\nretiradas',
      accountDetails33: 'Conta',
      bettingRecord33: 'Apostas\nregistro',
      security33: 'Segurança',
      feedback33: 'Feedback\npremiado',
      messageCenter33: 'Mensagens\ncentro'
    },
    theme14_dz: {
      home: {
        downloadAppTxt:
          'Baixe o aplicativo para o seu telefone agora para uma ter uma experiência melhor e mais segura de jogar. O aplicativo suporta todos os produtos: jogos, tiro ao peixe, cassino, jogos de cartas.',
        footer: {
          license: '',
          protect: '',
          followUs: '',
          playResponsibly: '',
          tgLink: 'https://t.me/aabr88',
          youtubeLink: 'https://www.youtube.com/',
          fbLink: 'https://www.facebook.com/aabrcom'
        },
        welcome: 'Bem-vindo',
        h5: '<p>Acesso direto ao</p><h1>AAbr.com</h1>'
      }
    },
    theme12_dz: {
      header: { tool_tips_hot: 'Popular' },
      platform: { start_game: 'Começar o jogo' },
      download: {
        h1: 'Baixe o aplicativo',
        h3: 'Faça login para pegar um clique com <span> 7 real </span>',
        ios: 'Baixar iOS',
        android: 'Baixe Android'
      },
      card: 'Cartas',
      real: 'Ao Vivo',
      events: 'Eventos',
      popular: 'Popular',
      discount: 'Promoção'
    },
    theme15_dz: {
      download: {
        h1: 'Melhor App de apostas para celular',
        h3: 'O melhor App de apostas do mercado',
        p: 'Aproveite a qualquer momento, em qualquer lugar! Aqui, temos uma grande variedade de slots, xadrez, cartas, pescaria, jogos ao vivo, esportes, e-sports e loterias.',
        app: 'Baixar App',
        downloading: 'Baixando',
        nodeNeed: 'Não é necessário baixar',
        domin: 'best777.com'
      },
      more: 'Mais',
      header: { servider: 'Ao Vivo', suporte: 'Demo' },
      headerNav: {
        menu0: 'Resgatar',
        promote: 'Saque normal',
        download: 'Baixar App',
        collected: 'Pendente',
        collectedRecord: 'Histórico'
      },
      asideList: {
        game: 'Clube',
        club: 'Promoção',
        discount: 'Promoção',
        customerService: 'Linha de switch',
        checkLine: 'Jogos',
        aboutUs: ''
      },
      tabLable: {
        Ajuda: 'Central De Ajuda',
        Sugestao: 'Bônus de Sugestão',
        FAQ: 'FAQ',
        Sobre: 'Agente'
      },
      bran: {
        cli: { label: 'Baixar aplicativo', label1: 'Mais' },
        Comite: {
          label: 'Melhor aplicativo de apostas mobile',
          label1: 'O melhor aplicativo de jogo mobile da indústria'
        },
        Filipinas: {
          label:
            'Aproveite a qualquer hora, em qualquer lugar! Aqui está a maior coleção de jogos de slot, cartas, pesca, cassino, esportes e loteria da web. ',
          label1: 'Baixar aplicativo'
        },
        Certificacao: {
          label: 'Baixando',
          label1: 'Não há necessidade de baixar'
        }
      },
      footerText: 'Registrar'
    },
    theme13_dz: {
      header: {
        week: {
          day0: 'Segunda-feira',
          day1: 'Terça-feira',
          day2: 'Quarta-feira',
          day3: 'Quinta-feira',
          day4: 'Sexta-feira',
          day5: 'Sábado',
          day6: 'Domingo'
        },
        onlineService: 'Sábado',
        welcome: 'Domingo',
        balance: 'Saldo'
      },
      home: {
        partInfo: {
          safeTitle: 'MARCA RENOMADA',
          safeTxt:
            'Marca respeitada, líder no mercado de depósito e saque de bilhões em dinheiro, não precisa mais se preocupar.',
          varietyTitle: 'PRODUTOS DIVERSIFICADOS',
          varietyTxt:
            'Máquinas caça -níqueis, cartões, pesca. Vários produtos para você escolher.',
          topupTitle: 'SEGURANÇA E PROTEÇÃO',
          topupTxt:
            'Métodos de pagamento diversos, garantindo segurança e proteção das informações.',
          fastTitle: 'TRANSAÇÕES RÁPIDAS',
          fastTxt:
            'Envie dinheiro para processamento imediato ao recebê-lo. Saque dinheiro de forma simples e rápida.',
          playNow: 'Jogue Agora'
        },
        winner: 'Seja um Vencedor',
        downloadAppTxt:
          'Baixe o aplicativo para o seu telefone agora para uma maneira melhor e mais segura de jogar. O aplicativo executa todos os produtos: slots, blockchain, pesca, jogos ao vivo.',
        h5: '<p>Acesso direto ao</p><h1>win55.com</h1>'
      }
    },
    error: {
      lostTo404: 'Oh não, isso não deveria acontecer',
      backToHome: 'Retorne à Página Inicial',
      demoAccountTips: 'A conta streamer não tem permissão.',
      networkTimeout:
        'Tempo de espera da rede, por favor, tente novamente mais tarde. Se a solicitação falhar continuamente, entre em contato com o Atendimento ao Cliente para obter assistência. ',
      networkTimeout2: 'Tempo limite da rede, por favor',
      networkTimeout3: 'Tempo limite, tente novamente',
      networkError: 'A rede não está disponível. Verifique sua conexão de rede',
      upgraded: 'A página atual expirou',
      upgradedMsg:
        'Nós atualizamos! Para sua melhor experiência, atualize para a versão mais recente!',
      upgradedBtn: 'Atualize imediatamente',
      guide2Reload:
        'Você está inativo há um tempo. Por favor, atualize a página!',
      channelErrorText:
        'Visite utilizando o canal gerado ou o link de convite, caso contrário, a vinculação não será possível!',
      loadingError:
        'Excedeu o tempo limite. Por favor {retry} ou {reload} página!',
      updatePage:
        'O conteúdo da página atual expirou. Atualize a página e tente novamente!',
      update: 'Atualize agora',
      friendlyReminder: 'Lembrete'
    },
    common: {
      number: {
        '1': '<span>1</span>',
        '2': '<span>2</span>',
        '3': '<span>3</span>',
        '4': '<span>4</span>',
        '5': '<span>5</span>',
        '6': '<span>6</span>',
        '7': '<span>7</span>'
      },
      formRules: {
        required: '{requiredItem} campo não pode estar vazio',
        requiredWithoutItem: 'Campo não pode estar vazio',
        username: '{range} caracteres, suporta letras/números',
        userpass:
          '{range} caracteres, incluindo pelo menos duas letras/números/símbolos',
        userpassSpecial:
          'Símbolos não são suportados. Por favor, insira somente os seguintes símbolos  !@#$%^&*_=+-,./?()',
        usercpf: 'Introduza o CPF',
        paypass: '{length} números puros',
        numberRequired: '{type} deve ser composto apenas por números',
        itemRequired: 'Ainda tem informações essenciais a serem completadas',
        withdrawalPass:
          'Por favor, insira {length} caracteres. Suporta números, letras e símbolos',
        atLeast: '　Caracteres. Deve incluir pelo menos　',
        digit: 'dígitos',
        lowercase: 'Minúsculas',
        uppercase: 'Maiúsculas',
        num: 'Números',
        special: 'Símbolos',
        psswdstrength: 'Força'
      },
      tips: {
        paste: 'Colar',
        copy: 'Copiado com sucesso',
        return: 'Retornar',
        next: 'Seguintes',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        skip: 'Pular',
        validating: 'Revisando...',
        loadingTip: 'Carregando, por favor espere',
        customerNotEnabled:
          'O Atendimento ao Cliente online não está disponível',
        downloadAppPageNotEnabled:
          'A função de transferência do aplicativo ainda não está ativada',
        month: 'Mês'
      },
      supports: {
        simple: '<span>Suporte</span>',
        notBind:
          'Conta anormal. Entre em contato com <span> o Atendimento ao Cliente</span>',
        accountException:
          'Conta anormal. Entre em contato com <span>o Atendimento ao Cliente</span>',
        forgotPwd:
          'Esqueceu a Senha? <span>Entre em contato com o Atendimento ao Cliente</span>',
        forgotSecrecyQuestion:
          'Esqueceu a pergunta de segurança? <span>Entre em contato com o Atendimento ao Cliente</span>',
        authUnavailable:
          'O método acima não está disponível? <span>Entre em contato conosco</span>',
        notBindVaild:
          'O item de verificação não está vinculado, <span>entre em contato com o atendimento ao cliente</span>',
        accountError:
          'A conta não existe, <span>entre em contato com o atendimento ao cliente</span>'
      },
      pagination: {
        prev: 'Página anterior',
        next: 'Página seguinte',
        total: '{0} entradas no total',
        goto: 'Prosseguir',
        page: 'Página',
        select: '{0} peças/página'
      },
      components: {
        auth: {
          contactUS: 'Suporte',
          othersVerify: 'Outros Métodos de Verificação',
          ga: {
            title: 'Verificação pelo Google',
            label: 'Código de verificação do Google',
            inputTips: 'Insira o código de verificação do Google'
          },
          email: {
            inputTips: 'Insira seu e-mail',
            current: 'E-mail Vinculado Atual',
            title: 'Verificação por e-mail',
            label: 'E-mail',
            success: 'E-mail correto',
            error: 'Erro no e-mail',
            formatError: 'Erro no formato do e-mail. Introduza novamente',
            required:
              'Para segurança da sua conta, indique o endereço de e-mail do meio',
            requiredNew:
              'Por favor, forneça um e-mail completo para receber o código de verificação'
          },
          phone: {
            current: 'Número de Celular Atualmente Vinculado',
            title: 'Verificação Móvel',
            label: 'Celular',
            success: 'Número do Celular Correto',
            error: 'Número do celular incorreto. Insira novamente',
            required:
              'Para garantir a segurança da sua conta, por favor, complete os {length} dígitos do número de celular.',
            requiredNew:
              'Por favor, forneça um número de telefone completo para receber o código de verificação (ou seja, insira os {length} dígitos do meio)',
            requiredOfActivity:
              'Introduza um número de celular completo com {x} dígitos',
            sendSuccess: 'Código de verificação obtido com sucesso!',
            toBindPhone: 'Número de celular ainda não vinculado,',
            toBindPhoneBtn: 'Vincular'
          },
          withdrawal: {
            title: 'Verificação da Senha de Saque',
            label: 'Verificar Senha de Saque',
            forgot: 'Esqueceu a senha?'
          },
          question: {
            name: 'Segurança',
            title: 'Pergunta de Segurança',
            label: 'Pergunta de Segurança',
            label2: 'Resposta',
            inputTips: 'Digite a Resposta da Pergunta de Segurança'
          }
        },
        geetest: {
          clickToValid: 'Clique no botão para verificar',
          success: 'Verificação aprovada',
          error:
            'Não foi possível obter a verificação, atualize a página e tente novamente'
        },
        datePicker: {
          error: 'Preencha a data correta',
          YYYY: 'Ano',
          MM: 'Mês',
          DD: 'Dia'
        }
      },
      upload: {
        error: {
          fileSize: 'Tamanho de arquivo não suportado',
          fileSize2MB: 'Apenas  nos formatos PNG e JPG, não excedendo 2MB',
          fileType: 'Tipo de arquivo não suportado',
          fileNull: 'Falha ao obter o arquivo. Tente novamente'
        },
        text: 'Carregar o arquivo'
      },
      deviceContext: {
        betterExperience: 'Para garantir uma boa experiência de jogo',
        rotateToPortrait: 'Coloque o celular/tablet no modo vertical'
      },
      loading: {
        click: 'Clicado',
        retry: 'Tente novamente',
        reload: 'Insira novamente'
      }
    },
    saveShortcut: {
      btn: '<span>Adicione</span> à tela principal ',
      guideModalTitle: 'Adicionar à tela inicial',
      guideModalTitleAndriod: 'Adicionar à tela inicial',
      guideModalStep1:
        '1. Toque no ícone "Mais" e, em seguida, toque em "Adicionar à tela principal"',
      guideModalStep2: '2. Clique em "Adicionar" e selecione “Adicionar”',
      label1: 'Partilhar',
      label2: 'Procurar na página web',
      label3: 'Website de computador',
      label4: 'Adicionar ao lembrete rápido',
      label5: 'Encontrar na página',
      label6: 'Marcador',
      label7:
        'Será adicionado um ícone à sua página inicial para garantir o acesso rápido a este site',
      cancle: 'Cancelar',
      add: 'Adicionar',
      useH5: 'Continue a usar',
      click: 'Clicar',
      openmenu: 'Abrir barra de menu',
      select: 'Selecionar',
      addHome: 'Adicionar à tela inicial'
    },
    rightBar: {
      reward: '+',
      backHome: 'Inicio',
      backTop: 'Topo',
      downloadTitleFromClickGame:
        'Para melhorar sua experiência de usuário, você deve baixar o APP nativo para jogar!',
      downloadApp: 'Download do Aplicativo',
      downloadAppTitle: 'Faça download do aplicativo',
      downloadAndroidApp: 'Android',
      downloadIosApp: 'iOS',
      onlineCustomer: 'Suporte Online 24/7',
      scanQR: 'Escaneie o QRCode',
      downloadAppSpeed: 'Versão rápida',
      downloadAppNormal: 'Versão normal',
      downloadAppComplete: 'Versão completa',
      downloadDevice: 'Baixe o cliente móvel',
      redPocketEnd: 'Concluído',
      noDownApp: 'Endereço de download ainda não configurado~',
      downloadAppTips:
        'Faça o download e use o aplicativo para participar de mais atividades e desfrutar de mais descontos!',
      useH5: 'Continue a usar o H5',
      titleFromChannel: 'Lembrete importante',
      channelTip1: 'Você deve baixar e usar o APP para jogar!',
      channelTip2: 'Ao mesmo tempo, o sistema lhe dará informações adicionais',
      channelTip3: 'Bônus!',
      channelTip4:
        'Você deve baixar e usar o atalho H5 na área de trabalho para jogar!',
      saveShortcutMessage: 'Atalho H5 na área de trabalho',
      channelTip5: '(Apenas para membros depositados pela primeira vez)'
    },
    tabbar: {
      home: 'Inicio',
      menu: 'Menu',
      event: 'Eventos',
      service: 'Suporte',
      download: 'Baixar App',
      discount: 'Promoção',
      recharge: 'Depósito',
      withDraw: 'Saque',
      register: 'Registro',
      login: 'Login',
      mine: 'Perfil',
      balance_dz: 'Saldo'
    },
    dz_5159: { tarbar: { service: '' } },
    mine: {
      vip: {
        tips: {
          deposit: 'Valor restante para depósito',
          bet: 'Valor restante para aposta'
        }
      },
      share: {
        tips: 'Promova',
        yesterdayMembers: 'O número de pessoas ontem (válido)',
        yesterdayTotalDirectBets: 'Desempenho direto de ontem',
        yesterdayTotalDirectCommissionse: 'Comissão não reivindicada'
      },
      itemList: {
        netWorkStatus: 'Status da Rede',
        selectLanguage: 'Idioma',
        switchMode: 'Alterar Modo',
        currentMode: 'Modo atual {modo}',
        versionUpdate: 'Atualizar registros',
        versionContent: 'Conteúdo da versão',
        gotVersionUpdate: 'Nova versão encontrada',
        club: 'Clube',
        music: 'Música'
      }
    },
    header: {
      account: 'Conta',
      messages: 'Mensagens',
      withdraw: 'Saque',
      recharge: 'Depositar',
      personalCenter: 'Perfil',
      menu: 'Menu',
      loginout: 'Sair',
      onlineService_dz: '',
      welcome_dz: '',
      menus: {
        messageCenter: 'Centro de mensagens',
        accountDetails: 'Conta',
        bettingRecord: 'Apostas',
        personalStatement: 'Relatório',
        personalStatementCyanBlue: 'Relatório',
        withdrawalManagement: 'Gestão de saque',
        promote: 'Agente {content}',
        defaultPromoteAdvertise: 'Ganhe até um milhão por mês',
        settings: 'Dados',
        security: 'Segurança',
        music: 'Música',
        feedback: 'Bônus de Sugestão',
        about: 'Sobre',
        logout: 'Sair'
      },
      logoutTips: 'Você se retira da conta corrente?',
      logoutOkText: 'Confirmar saída',
      logoutCancelText: 'Cancelar',
      moneyInGame: 'A utilizar atualmente no jogo',
      officeDomain: 'Nome do domínio oficial'
    },
    modal: {
      noData: 'Sem dados disponíveis',
      notOpen: 'Em breve',
      verify_user_password_text:
        'O número da sua conta e a senha são apresentados abaixo. Não perca estes dados!',
      importantReminder: 'dica importante',
      reset_withdraw_password:
        'Por favor, altere a senha de saque antes de fazer depósitos/saques',
      force: {
        understood: 'Entendido',
        main_not_show_again_today: 'Não mostrar novamente hoje',
        serviceUpgrade: 'Interrompa o serviço e atualize'
      },
      title: { error: 'Lembrete importante' },
      forceUpdate: {
        content:
          'Sua versão atual é muito baixa, você precisa atualizar para a versão mais recente antes de poder operá-la.',
        okText: 'Atualize imediatamente'
      },
      search: { placeholder: 'Pesquisar' },
      login: {
        label: 'Login',
        otherWayLogin: 'Outros métodos de login',
        type: { casino: 'Acesse o Cassino', club: 'Acesse o Clube' },
        googleInitError:
          'Este método de login está atualmente sob manutenção. Tente mais tarde ou entre em contato com o Atendimento ao Cliente.',
        passwordHint:
          'Sua senha atual é fraca, altere a senha o mais rápido possível.',
        form: {
          smsCode: {
            label: 'Código',
            placeholder: 'Código de verificação por e-mail',
            counting: 'Reenviar em {seconds}s',
            send: 'Receber código',
            required: 'O código de verificação não pode ficar em branco',
            getCode: 'Obtenha o código de verificação por SMS primeiro',
            emailCode: 'Obtenha primeiro o código de verificação de e-mail'
          },
          phone: {
            label: 'Número do Celular',
            placeholder: 'Número do Celular',
            required: 'Número de celular incorreto. Insira novamente!',
            viError:
              'Números começando com 0 não precisam do 0. Por exemplo, para 0123456789, basta digitar 123456789.'
          },
          username: {
            label: 'Nome de Usuário',
            labelShort: 'Nome de Usuário',
            placeholder: 'Inserir nome de usuário'
          },
          realName: {
            label: 'Nome real',
            labelShort: 'Nome',
            placeholder: 'Introduza o seu nome real',
            realNameTips:
              "Suporta a entrada de letras, texto, espaço e símbolos especiais’'·",
            realNameTips2:
              "Letras/texto/espaços de suporte e símbolos especiais’'·",
            realNameTips3: "Letras/espaços de suporte e símbolos especiais’'·"
          },
          userpass: { label: 'Senha' },
          stakeusername: { placeholder: 'Inserir nome de usuário' },
          stakepassword: { placeholder: 'Insira a senha' }
        },
        placeholder: {
          platformId: 'Nome de Usuário',
          platformId3:
            'Por favor, insira o caractere {minmax} para suportar inglês/números',
          passwd: 'Inserir Senha',
          passwd3:
            'Por favor, insira o bit {minMax}, pelo menos os símbolos em inglês/números/símbolos',
          passwdConfirm: 'Confirme a senha novamente, o mesmo que a senha!',
          passwdConfirm3:
            'Por favor, insira o bit {minMax}, pelo menos os símbolos em inglês/números/símbolos',
          mobilePhoneNumber: 'Insira o número de celular',
          verificationCode:
            'Por favor, insira o código de verificação do celular',
          verificationCode3: 'Insira o código de verificação',
          email: 'Insira a conta da caixa de correio',
          emailCode: 'Por favor insira o código de verificação de e-mail',
          emailCode3: 'Insira o código de verificação',
          realName:
            'Preencha o nome verdadeiro e torne -o conveniente para a retirada posterior!',
          realName31: 'Introduza o seu nome real',
          realName32:
            'Por favor, insira seu nome real (somente em letras maiúsculas)',
          cpfCode:
            'Preencha o CPF e torne -o conveniente para a retirada posterior!',
          currency: 'Escolha a moeda',
          inviterId: 'Por favor, insira seu código de convite',
          inviterId3: 'Insira o código de recomendação'
        },
        tabs: {
          accountLogin: 'Login',
          accountRegister: 'Registre sua conta',
          phoneLogin: 'Login pelo celular',
          phoneRegister: 'Registo telefónico',
          phoneSubTitle:
            'Esse campo é apenas para cadastro ou login, não para vinculações!',
          emailLogin: 'Login pelo e-mail',
          emailRegister: 'Cadastro por e-mail',
          emailSubTitle:
            'Esse campo é apenas para cadastro ou login, não para vinculações!'
        },
        operate: {
          rememberPwd: 'Lembrar Senha',
          forgotPwd: 'Esqueceu a Senha?',
          registerAccount: 'Cadastre-se agora',
          smsLogin: 'Login via SMS',
          accountLogin: 'Login',
          tryItFree: 'Jogar Demo',
          registerGive: 'Registrar +',
          bindingGive: 'Ligação +',
          accountRegister: 'Registre sua conta',
          modify: 'Editar',
          clickLogin: 'Login'
        }
      },
      currency: {
        chinese: 'Chinês',
        english: 'Inglês',
        USD: 'USD',
        CNY: 'CNY',
        HKD: 'HK$',
        THB: 'THB',
        VND: 'VND',
        IDR: 'IDR',
        INR: 'INR',
        AUD: 'AUD',
        GBP: 'GBP',
        KRW: 'KRW',
        JPY: 'JPY',
        BRL: 'BRL',
        MXN: 'MXN',
        EUR: 'EUR',
        RUB: 'RUB',
        MMK: 'MMK',
        AED: 'Dirham',
        PHP: 'PHP',
        KHR: 'Riel Cambojano',
        USDT: 'USDT（Para conversão em USD）',
        USDT7_1: 'USDT 1:7 (Para converter em CNY)',
        USDC: 'USDC (Para converter em USD)',
        USDC7_1: 'USDC 1:7 (Para converter em CNY)',
        BTC: 'BTC',
        BTC100000_1: 'BTC 1:100000  (Para converter em CNY)',
        BTC10000_1: 'BTC 1:10000 (Para converter em USD)',
        ETH: 'ETH',
        ETH10000_1: 'ETH 1:10000 (Para converter em CNY)',
        ETH1000_1: 'ETH 1:1000 (Para converter em USD)',
        KPW: 'KPW',
        PRK: 'PKR',
        NPR: 'NPR',
        BDT: 'BDT',
        MUR: 'MUR',
        NGN: 'Naira',
        TRX: 'Tron',
        TRY: 'Lira turca',
        MAD: 'Dirham marroquino'
      },
      register: {
        readed: 'Li e Compreendi',
        label: 'Registro',
        thirdLabel: 'Configurar Conta',
        thirdAccountLabel: '{thirdWay} Conta',
        imageVerificationCode: 'Código',
        successTips: 'Registrado com sucesso! Vamos jogar agora~',
        successRegister: 'Registrado com sucesso',
        available: 'Conta disponível',
        existed: 'Conta existente',
        notMatch: 'Senha incorreta, digite novamente!',
        passwdConfirm: 'Confirme a senha',
        inviterAccount: 'Código de convite (opcional)',
        selectCountry: 'Escolha a moeda',
        realNameError: 'São permitidas apenas letras maiúsculas',
        cpfError: 'Suporta até 11 números. Caracteres especiais suportados: .-',
        selectCountryError:
          'A moeda determina os jogos de terceiros e os métodos de pagamento, e não pode ser modificada!',
        selectCurrencyTips:
          'A vinculação falhará se a moeda do convite não for igual à sua',
        submitCurrencyError:
          'A moeda vinculada no momento não coincide com a do código de convite. Insira novamente',
        invitetAccountRequired: 'Insira o código de recomendação',
        saveAccountPwd: 'Salvar Foto',
        modifyNow: '',
        confirm: 'Cadastrar',
        rangeNumber: '{range} dígitos',
        editAccountTips: 'Importante: A conta só pode ser editada desta vez.',
        agreementRequiredTips:
          'Por favor, marque primeiro o acordo do usuário.',
        userAgreement:
          'Tenho 18 anos, li e concordo com <span data-user-agreement = "true"> 《Contrato do usuário》<span/>',
        inviterAccount1: '',
        inviterCode: 'Código de Convite',
        close: 'Fechar',
        accountInfo: 'Informação da conta',
        successCallback: 'Parabéns pelo seu cadastro bem-sucedido!',
        saveAccountInfo:
          'Sua conta e senha são as seguintes. Guarde-as com cuidado para evitar problemas de login. ',
        saveAccountTips:
          'Atenção: Nunca compartilhe suas informações de login com ninguém para evitar perdas! '
      },
      forgotPassword: {
        title: 'Esqueceu a Senha',
        step1: 'Verificação de ID',
        step2: 'Redefinição de Senha',
        step3: 'Terminar',
        newPassword: 'Nova Senha',
        backHome: 'Retorne à Página Inicial',
        loginNow: 'Login Agora',
        resetSuccess: 'A sua senha foi alterada com êxito',
        systembusy: 'Servidor ocupado. Tente mais tarde'
      },
      task: {
        reward: {
          '8': 'Recompensa pelo primeiro depósito {reward}',
          '11': '{reward}+',
          '17': 'Faça o primeiro depósito para obter {reward}',
          default: '+{reward}'
        },
        amount: 'Bônus',
        activity: 'Nível ativo',
        title: 'Missão',
        activityRate: 'Nível Atual da Atividade',
        activityBoxTip:
          'Contém prêmio de {reward} <span>{reward}</span>.<br />É necessário apostar <span>{x}</span>para sacar.',
        activityBoxReceiveTip:
          'O bônus de {reward} só pode ser sacado depois que for apostado <span>{x}</span> vezes.',
        reactiveTime: 'Tempo para resetar o nível da atividade：',
        reactiveTime1: '{h}:{m}:{s}',
        reactiveTime2: '{d} Dias {h}:{m}:{s}',
        newbieBenefit: 'Benefícios para novos jogadores',
        daily: 'Missão Diária',
        weekly: 'Missão Semanal',
        threeDays: 'Missão de 3 Dias',
        arcane: 'Missões Misteriosas',
        collectAll: 'Resgatar Tudo',
        applyAll: 'Aplicação com um clique',
        receiveDiscount: 'Aplicar Para Ofertas',
        receiveRecord: 'Registros de Aplicação',
        receiveDiscountRequired: 'Insira a resposta',
        receiveDiscountSuccess: 'Inscrição enviada com sucesso!',
        collect: 'Resgatar',
        processing: 'Em andamento',
        forward: 'Prosseguir',
        applyAward: 'Solicitar recompensas',
        collected: 'Resgatado',
        waitReview: 'Revisão pendente',
        applied: 'Aplicado',
        distributed: 'Distribuído',
        noStart: 'Não Começou',
        expired: 'Expirou',
        cancel: 'Cancelado',
        invalid: 'Ainda não foi ativado',
        dayCount: 'Dia {x}',
        finishTreeDay:
          'Complete a tarefa por 3 dias consecutivos para receber o prêmio final!',
        threeDaysTips: 'Depois de resgatar, ganhe <br /><span>{x}</span> bônus',
        threeDaysSuccessTips: '<span>{x}</span> Bônus resgatado',
        taskUnstart: 'A missão ainda não começou',
        describe: {
          '0': 'Tarefa de longo prazo',
          '1': 'Tarefa de longo prazo (reseta todos os dias às 00:00)',
          '2': 'Tarefa de longo prazo (reseta todas as segundas-feiras às 00:00)',
          '3': 'Tarefa de longo prazo (atualiza todos os dias às 00:00)',
          time: 'Hora da tarefa',
          condition: 'Condições da tarefa',
          content: 'Conteúdo da tarefa',
          rule: 'Regras'
        },
        rulesDes:
          'As recompensas deste evento exigem {times} apostas válidas para saque.',
        receiveSussessTip: 'Resgatado com Sucesso! ',
        thisTimeNotShow: 'Não mostrar novamente nesta sessão',
        noMorePoptoday: 'Não estou mais aparecendo hoje',
        neverPrompt: 'Nunca avisar (verifique no Centro de Tarefas)',
        neverPop: 'Ocultar permanentemente',
        rewardWaitApprove:
          'A recompensa precisa ser auditada antes de ser creditada',
        saveUrl: {
          title: 'Salvar o URL do Tutorial de Ambiente de Trabalho',
          computer: 'Computador',
          savingURLToGo:
            '1. Clique no botão "Prosseguir" para guardar o website',
          clickTheMore:
            '2. Clique no ícone“{x}” no canto superior direito do navegador',
          createShortcuts:
            'Em seguida, clique em > Mais ferramentas > Criar um atalho',
          clickToCreate: '3. Clique em “Criar”',
          returnToTheDesktop:
            '4. Volte ao ambiente de trabalho. Clique no atalho do ambiente de trabalho e abra o site para obter recompensas',
          chrome: 'Navegador Google Mobile',
          clickMoreIcon: '2. Clique no ícone "{x}”',
          clickAdd: 'Em seguida, clique em “Adicionar à tela principal”',
          selectAdd: '3. Clique em “Adicionar” e selecione “Adicionar”',
          safari: 'Navegar Safari',
          clickEnjoy:
            '2. Clique no botão de compartilhar no lado inferior da tela',
          selectToAdd: '3. Selecione “Adicionar à tela principal”'
        },
        timeNotArrived: {
          expiryTime: '{x} anulado',
          tomorrow:
            'A recompensa dessa tarefa só pode ser resgatada no dia seguinte',
          weekWhole:
            'A recompensa dessa tarefa só pode ser resgatada na semana seguinte',
          monthWhole:
            'A recompensa dessa tarefa só pode ser resgatada na semana seguinte',
          weekNext: 'Disponível para resgate na próxima semana',
          monthNext: 'Disponível para resgate no próximo mês'
        },
        only: 'Limitado apenas a:',
        onlyGame: 'Limitado apenas a jogos',
        onlyRecharge: 'Limitado apenas a depósitos',
        contact: 'Informação do Contato',
        close: 'Fechar',
        rechargeAtLeastOnce: 'Você precisa completar 1 recarga para recebê-lo!'
      },
      event: {
        payAfter: 'Resumo das atividades de recarga',
        moreActivities: 'Mais eventos'
      },
      smartPay: {
        edit: 'Editar',
        closeButtonTips: 'Fechar em{s}s',
        balance: 'Saldo atual',
        recommendAmount: 'Quantidade de depósito recomendado',
        recommendChannel: 'Canal de pagamento recomendado',
        give: 'Bônus',
        payedAmount: 'Chegada esperada'
      },
      pay: {
        retry: 'Repetir',
        bobiBalance: 'Saldo de WAVES',
        buyBobi: 'Comprar WAVES',
        title: 'Depósito',
        title2: 'Adicionar ponto',
        onceTips: 'Clique para mudar. Insira o valor do depósito',
        artificial: 'Suporte ao cliente manual',
        record: 'Registro de Depósito',
        accountTotal: 'Saldo da Conta',
        payBtn: 'Deposite Agora',
        bindBtn: 'Vincule agora',
        openNow: 'Ativar agora',
        openBobi: 'Ative a carteira WAVES agora',
        expand: 'Expandir',
        required: 'Obrigatório ',
        putAway: 'Passar',
        payMoney: 'Depósito',
        giveTip: 'Explicação do evento de bônus',
        giveInfo:
          'Deposite de acordo com o valor recomendado para receber o bônus correspondente. O valor do bônus acumula com o bônus de depósito.',
        payScore: 'Adicione a quantia de pontos',
        mark: 'Lembrete',
        placeholder: 'Mínimo ${a}, Máximo ${b}',
        suffix: 'Último número {no}',
        lastNo: '**** {no}',
        firstNo: '{no} ****',
        channelLimit: 'Limite ({a}-{b})',
        give: '{num} ',
        give2: 'Enviar {num}%',
        copy: 'Copiar',
        chatPay: 'Depósito Bate-papo',
        accountNo: 'Conta: {no}',
        noBindUrlError:
          'Erro na mensagem de configuração. Entre em contato com o Atendimento ao Cliente',
        artificialError:
          'Erro de configuração no serviço de atendimento ao cliente de depósito',
        silverMerchantError:
          'Erro de configuração do endereço de recarga da corretora',
        realName: 'Nome real do pagador',
        realNameRequired: 'O nome não pode estar em branco',
        cpfRemark:
          '(Preencha corretamente as informações: O CPF da conta que requisitou este pagamento para ser creditada normalmente)',
        cpfPlaceholder: 'Introduza o número de CPF',
        realNameRemark:
          '(Por favor, preencha corretamente: o nome real da conta de pagamento para este pedido para garantir um recibo normal)',
        realNamePlaceholder: 'Introduza o nome real do jogador',
        payEmpty1:
          'Atualmente, não existe um método de pagamento adequado para si.',
        payEmpty2: 'Ver mais',
        realNameFreezePlaceholder:
          'Introduza o seu nome real (não pode ser alterado posteriormente) ',
        walletAddress: 'Endereço da carteira do pagador',
        walletAddressRequired:
          'O endereço da carteira do pagador não pode estar vazio',
        walletAddressRemark:
          '(Preencha corretamente o endereço da carteira do pagador para uma transição bem sucedida)',
        walletAddressPlaceholder: 'Insira o endereço da carteira do pagador',
        personalInfo: 'Informação de verificação do pagador',
        personalInfoRemark:
          '(Preencha corretamente: a informação do pagador, para que seja corretamente creditado na conta)',
        personalPhoneInfoPlaceholder:
          'Introduza o número de celular do pagador',
        personalEmailInfoPlaceholder: 'Introduza o e-mail do pagador',
        personalPhoneInfoRequired:
          'O número do telefone celular não pode ficar em branco',
        personalEmailInfoRequired: 'O e-mail não pode ficar em branco',
        personalEmailInfoError: 'Erro no formato de e-mail',
        walletRecommendMoneyNone:
          'O formulário de saque não está disponível no momento. Por favor, selecione novamente.',
        walletRecommendMoneyNone1: 'Nenhum valor alto',
        walletRecommendMoneyNone2: 'Nenhum valor mediano',
        walletRecommendMoneyNone3: 'Nenhum valor baixo',
        bindQianNengWalletSuccess: 'Vinculado com sucesso',
        qianNengTitle: 'Saldo da carteira Qian Neng',
        toBuyQianNeng: 'Saldo de compra',
        noWallet: 'Cada um tem um bônus entre <span>01 e 3,3%</span>',
        errorMoneyMsg1:
          'O saldo da carteira atual é insuficiente. Efetue uma compra primeiro ou selecione outro método de pagamento!',
        errorMoneyMsg2:
          'O saldo de USDT atual é insuficiente. Selecione outro método de pagamento!',
        errorMoneyMsg3:
          'O saldo de arbitragem atual é insuficiente. Selecione outro método de pagamento!',
        notBindQianNeng:
          'Você ainda não se registrou ou vinculou uma carteira Qian Neng',
        qianNengBindTip:
          '(Por favor, preencha as informações corretas: nome real e número de celular para vincular normalmente)',
        download: 'Aplicativo No Wallet',
        noWalletID: 'Número da conta da carteira',
        max: 'Max',
        about: 'Sobre',
        exchangeRate: 'Taxa de câmbio',
        phonePlaceholder: 'Digite o Número do Celular',
        walletTooltips: 'Bônus {num}%',
        notBindUPAYWallet: 'Crie uma conta UPAY automaticamente com um clique',
        bindUPAYBtn: 'Use imediatamente',
        UPAYBalance: 'Saldo UPAY',
        buyUPAYBtn: 'Compre U Coins',
        bindUPAYSuccess: 'Cadastrado e vinculado com sucesso',
        total: 'Depósito Total',
        rate: 'Taxa de câmbio',
        fee: 'Taxa',
        feeRate: 'Taxa de processamento',
        realFee: 'Taxa de processamento efetiva',
        deduction: 'Redução',
        realScore: 'Valor real',
        feeErrorToast:
          'O valor do saque deve ser superior à taxa de transação ({x})',
        gameWalletBalance: 'No saldo da carteira',
        usdtBalance: 'Saldo em USDT',
        brickBalance: 'Sem saldo móvel',
        notBindNoWallet: 'A conta já existe. Pode fazer login e vincular',
        notSettingPayPassword:
          'É a sua primeira vez? É necessário apenas configurar a senha de pagamento',
        setting: 'Configurar agora',
        notBindBobiWallet:
          'Ainda não se registrou nem vinculou uma carteira WAVES',
        notBindGoubaoWallet: 'Você ainda não vinculou a carteira de jogos',
        goubaoBalance: 'Saldo da carteira de jogos',
        goubaoStep2:
          'Passo 2: Clique para receber e preencha o código de verificação SMS.',
        goubaoStep1:
          'Passo 1: Use a carteira do jogo para escanear este código QR e vincular a conta;',
        goubaoQrCode: 'QR Code da carteira de jogos',
        payPwdRequired: 'A senha de pagamento não pode estar em branco',
        goubaoPayPwdPlayceholder:
          'Por favor, insira a senha de pagamento da carteira de jogos',
        qrcodeExpired: 'O QR Code expirou. Por favor, atualize',
        qrcodeTime: 'Tempo válido do QR Code',
        bindNoWalletBtnText: 'Registre-se ou vincule agora',
        balanceInsufficientText: 'Escolha comprar ou transferir diretamente.',
        balanceInsufficientText2:
          'O saldo atual da carteira <b>NO é insuficiente</b>. Quer comprar agora?',
        thinkAgain: 'Deixe-me pensar',
        balanceCancelText: 'Comprar agora',
        offlineTransferText: 'Transferência direta',
        rechargeSuccessful: 'Depósito Bem-sucedido',
        refreshSuccessful: 'Atualizado com êxito',
        refreshFailed: 'A atualização falhou',
        allCurrency: 'Todas as moedas',
        combination: {
          mobile: 'Número do Celular',
          walletAddress: 'Endereço da carteira',
          email: 'Endereço de e-mail',
          name: 'Nome real',
          cardNo: 'Número do cartão',
          cardNoRequired: 'O número do cartão não pode estar vazio',
          cardNoPlaceholder: 'Introduza o número do cartão',
          cardPass: 'Número serial',
          cardPassRequired: 'O número serial não pode estar em branco',
          cardPassPlaceholder: 'Introduza o número serial',
          networkMerch: 'Operadora',
          networkMerchRequired: 'A operadora não pode estar em branco',
          networkMerchPlaceholder: 'Selecione a operadora',
          onlineBank: 'Selecionar banco',
          onlineBankRequired: 'O banco não pode estar em branco',
          onlineBankPlaceholder: 'Selecione um banco'
        },
        table: {
          time: 'Horário',
          method: 'Método de Depósito',
          amount: 'Quantia',
          status: 'Estado',
          action: 'Operar',
          details: 'Detalhes'
        },
        details: {
          title: 'Detalhes do Depósito',
          name: 'Nome da Conta Bancária',
          no: 'Conta bancária',
          bankName: 'Nome do Banco',
          qrCode: 'QR Code do Pagamento',
          channel: 'Canais de depósito',
          method: 'Método de Depósito',
          transaction: 'Tipo de transação',
          createTime: 'Hora de Criação',
          payedTime: 'Hora de transação',
          transferCertificate: 'Transferir voucher',
          orderNo: 'Número do Pedido',
          tripartiteWallet: 'Carteira de terceiros',
          checkWallet: 'Checar carteira de terceiros',
          frontRemark: 'Observações da transferência',
          senderName: 'Nome do remetente',
          placeHolder: 'Introduza o nome do remetente',
          senderName2: 'Nome Real do Pagador',
          placeHolder2: 'Introduza o nome real do jogador',
          transferRemk: 'Observações da transferência',
          transferRemkTip:
            '(Introduza as observações de transferência para que possamos atualizar rapidamente o seu saldo)',
          transferRemkToast: 'Introduza as observações da transferência',
          transferRemarkZFBPayTip: '(Opcional)',
          transferRemarkZFBPayPlaceholder:
            'Insira comentários na transferência, usando um máximo de 255 palavras',
          transferRemkPlaceholder:
            'Introduza o número/Token/TxID da encomenda para verificação do depósito',
          UTR: 'UTR',
          UTRPlaceholder: 'Insira o número de UTR',
          UTRToast: 'Introduza os últimos {num} dígitos do UTR',
          UTRPlaceholderLast4: 'Por favor, insira os 4 dígitos após a UTR',
          UTRPlaceholderLast6: 'Por favor, insira 6 dígitos após a UTR',
          UTRRemark:
            '(Introduza o número de UTR correto para que possamos atualizar rapidamente o seu limite)',
          UTRRemarkLast4:
            '(Insira os 4 dígitos após a UTR, você pode atualizar o valor rapidamente)',
          UTRRemarkLast6:
            '(Digite 6 dígitos após a UTR, você pode atualizar rapidamente o limite para você)',
          uploadTransferCertificate: 'Enviar o recibo do depósito',
          uploadTransferCertificateRemark1:
            'Clique no botão à esquerda para enviar o recibo do depósito',
          uploadTransferCertificateRemark2:
            'O tamanho da imagem não pode exceder 5MB',
          uploadTransferCertificateRemark3:
            'Não é possível modificar depois de carregar',
          uploadTransferCertificateRemark4:
            'Clique no botão para enviar novamente a imagem do comprovante',
          uploadTransferCertificateRequired: 'Envie o recibo do depósito',
          cancelOrderContent1: 'Deseja mesmo cancelar o pedido?',
          cancelOrderContent2:
            'O cancelamento do pedido o tornará inválido. Você pode criar um novo pedido de depósito novamente~',
          mark: '* Para um recebimento rápido, por favor, insira o nome correto do pagador.',
          confirm: 'Eu transferi',
          confirmRemark:
            'Submetido após {seconds} segundos. Ir para transferência)',
          auditBtn: 'Em análise',
          toPayBtn: 'Falha no saque',
          cancel: 'Cancelar um pedido',
          usdtText: 'USDT',
          usdtType: 'Moeda',
          proto:
            'Protocolo de rede principal (ou seja, canal de rede; isto é muito importante)',
          address: 'Endereço do Pagamento',
          usdtRemark1:
            '1.Por favor, garanta que o valor correto seja creditado após a dedução da taxa de saque (ou seja, o valor correto creditado). Caso contrário, o depósito não será creditado.',
          usdtRemark2:
            '2. Por favor, confirme se o protocolo da rede principal da sua transferência/recarga corresponde ao protocolo da rede principal selecionado; caso contrário, a recarga/transferência não será creditada ou será reembolsada.',
          usdtRemark3:
            '3. Aceita apenas USDT. Não transfira outras moedas para este endereço.',
          cpf: 'CPF do destinatário',
          cnpj: 'CNPJ do destinatário',
          accountType: 'Tipo de conta',
          noWalletRemark: 'Pedidos pendentes. Acesse a carteira para verificar',
          goToWallet: 'Ir para a carteira',
          downloadQRCode: ' Salvar',
          transferRemark: 'Posfácio de transferência',
          countdownText1: 'Por favor',
          countdownText2: 'Complete o depósito'
        },
        toast: {
          moneyIncorrect: 'Insira o valor correto',
          payFailed:
            'O depósito falhou. Entre em contato com o Atendimento ao Cliente! ',
          payZFBError:
            'Tipo de aplicativo Alipay. Entre em contato com o Atendimento ao Cliente para modificar o tipo de canal.',
          chargeMoneyQiannengError:
            'O valor de recarga não pode exceder o saldo de Qian Neng',
          chargeMoneyBobiError:
            'O valor de recarga não pode exceder o saldo de WAVES',
          chargeMoneyUPAYError:
            'O valor do depósito não pode exceder o saldo do UPAY'
        },
        backHome: 'Voltar para o Lobby',
        payDomainErrorToast:
          'Entre em contato com o Atendimento ao Cliente para configurar o nome de domínio'
      },
      payQRCode: {
        tips1:
          'Abra seu aplicativo de pagamento e digitalize ou copie e cole o código QR abaixo para concluir sua compra;',
        tips2:
          'Este código QR só pode ser pago uma vez. Se precisar pagar novamente, volte e recarregue;',
        tips3:
          'Após o pagamento ser bem-sucedido, você pode retornar ao lobby do jogo e aguardar a adição de pontos!',
        effectiveTime: 'Tempo efetivo',
        copyQRCode: 'Copiar código QR',
        orderStatus: 'Status do pedido',
        createdTime: 'Hora de Criação',
        orderNo: 'Número do Pedido',
        qrCodeUrl: 'Endereço do código QR',
        merchantOrderNo: 'Número do pedido do comerciante',
        timeoutTips: 'O código QR expirou',
        timeoutTips2:
          'Por favor, retorne ao lobby para fazer um pedido novamente. A página atual será fechada em 10 segundos.',
        successTips: 'Recebido com sucesso',
        successTips2: 'O sistema atribuiu automaticamente uma pontuação a você',
        successTips3: 'A página atual será fechada após 10 segundos',
        chose: 'Selecionar',
        or: 'Ou',
        close: 'Fechar agora',
        checkOrder: 'verificar pedido',
        status: {
          wait: 'Registros de Auditoria',
          timeout: 'Tempo esgotado',
          success: 'Pagamento bem sucedido'
        }
      },
      passModal: {
        defaultTitle: 'Inserir PIN',
        withdraw: 'Senha de Saque',
        remark: 'Para a segurança da sua conta, introduza a senha para saque',
        forget: 'Esqueceu a Senha?',
        ok: 'Confirmar',
        next: 'Seguintes'
      },
      forceChangePwd: {
        title: 'Alterar Senha',
        tips: 'Este é o seu primeiro login ou sua senha foi redefinida. Por questões de segurança, por favor, altere sua senha.',
        successTips: 'Senha modificada com sucesso'
      },
      forceBindPhone: {
        title: 'Vincule o número de celular após login',
        tips: 'Observação: verifique o celular para entrar nos jogos',
        successTips: 'Número de celular vinculado com sucesso'
      }
    },
    finance: {
      noUrlErrorTip:
        'O link da configuração do download está incorreto. Por favor, entre em contato com o Atendimento ao Cliente! ',
      getInfoError: 'Ainda não recebemos o status de membro, tente mais tarde',
      withdraw: {
        title: 'Saque',
        tabs: {
          withdraw: 'Solicitar saque',
          withdrawRecord: 'Registro de Saques',
          heaven_record: 'Tarefas de apostas',
          account: 'Contas a receber'
        },
        maintain: {
          closeTitle: 'O canal de saque foi fechado',
          closeTime: 'Hora de encerramento',
          customer: 'Suporte'
        },
        checkDetails: 'Detalhes',
        query: 'Consulta de saque',
        schedule: 'Progresso do saque',
        orderSell: 'Lista a venda',
        total: 'Saldo',
        yuebao: 'Juros',
        remark: 'Você precisa apostar {num} sacar dinheiro',
        betRequired: 'Você precisa apostar',
        toWithdraw: 'sacar dinheiro',
        btn1: 'Saque Padrão',
        btn2: 'Saque No Wallet',
        btn3: 'Saque com Criptomoeda',
        account: 'Conta para Saque',
        addAccount: 'Adicionar Conta para Saque',
        accountPlaceholder: 'Selecione a conta para saque',
        accountRequired: 'Adicione primeiro a conta de saque',
        withdrawAmount: 'Valor do Saque',
        pleaseEnterWithdrawAmount: 'Por favor, insira o valor do saque',
        withdrawAmountPlaceholder: 'Mínimo{a}, Máximo{b}',
        withdrawNoAccountPlaceholder:
          'Por favor, selecione uma conta para saque primeiro',
        selectAccountPlaceholder:
          'Por favor, primeiro adicione a conta para saque',
        all: 'Tudo',
        noRemark: 'Cada uma tem um subsídio entre <span>1 e 2,1%</span>',
        download: 'Aplicativo No Wallet',
        withdrawPass: 'Senha de Saque',
        ok: 'Confirmar',
        give: 'Subsídio {number}',
        give2: 'Obter subsídios {number}%',
        yearRate: 'Anual{number}%',
        exchangeRate: 'Taxa de câmbio de liquidação$1:{chart}{rate}',
        rate: 'Taxa de câmbio',
        bankLessNo: '(****{no})',
        bankLess2No: '****{no}',
        alipayTransfer: 'Transferência Alipay',
        wechatTransfer: 'Transferência de WeChat',
        alipayQR: 'Escanear QRCode do Alipay',
        wechatQR: 'Escanear QRCode do WeChat',
        crypto: 'Criptomoeda',
        withdrawSuccess:
          'Saque em análise. Por favor, verifique o saldo da conta',
        show: 'Mostrar',
        hidden: 'Ocultar',
        noAuditText: 'Lista de jogos não auditados',
        noAuditListText: 'Lista de jogos não incluídos na auditoria',
        noAuditSearchPlaceholder: 'Introduza o nome da plataforma ou do jogo',
        noAuditExplain:
          'Explicação: O volume de apostas nas seguintes plataformas ou jogos não é contado para o valor da auditoria; ele é automaticamente excluído.',
        noAuditTip:
          'Lembrete: se tiver alguma dúvida, entre em contato com o Atendimento ao Cliente',
        freeNotice: 'Sem taxa de manuseio desta vez',
        verifyAmount: 'Insira o valor correto',
        table: {
          time: 'Horário',
          method: 'Método de Saque',
          amount: 'Valor',
          status: 'Estado',
          type: 'Tipo',
          action: 'Operar',
          details: 'Detalhes',
          total: 'Total de Saques',
          heaven: 'Total pendente de auditoria'
        },
        details: {
          title: 'Detalhes dos Saques',
          method: 'Método de Saque',
          createTime: 'Hora de Criação',
          orderNo: 'Número do Pedido',
          transaction: 'Tipo de transação',
          address: 'Endereço do Saque',
          net: 'Acordo',
          usdtMethod: 'Método de Saque',
          completeTime: 'Tempo de Conclusão',
          usdt: 'Saque',
          usdtText: 'USDT',
          noWalletRemark: 'Pedidos pendentes. Acesse a carteira para verificar',
          goToWallet: 'Ir para a carteira',
          cancelReason: 'Motivo do cancelamento',
          rejectReason: 'Motivo da rejeição',
          remark: 'Observação'
        },
        auditRecordDetails: {
          title: 'Detalhes da tarefa de apostas',
          type: 'Tipo de fonte',
          status: 'Status da tarefa',
          amount: 'Obter/Adicionar pontos',
          range: 'Exigir multiplicador de aposta',
          total: 'Aposta válida necessária',
          needAudit: 'Você precisa apostar',
          audited: 'Aposta já válida',
          limitPlatform: 'Plataforma de jogo designada',
          limitGame: 'Jogo restrito',
          time: 'Hora de Criação',
          activeName: 'Nome do Evento',
          completedTime: 'Hora de execução'
        },
        accountReceivable: {
          bank: 'Conta de Saque',
          alipay: 'Alipay',
          wechat: 'WeChat',
          addDefault: 'Definir como padrão',
          disable: 'Desativado',
          disabled: 'Desativado',
          qr: 'Leitura de QRCode',
          crypto: 'Criptomoeda',
          transfer: 'Transferir',
          add: 'Adicionar',
          cryptoName: 'Criptomoeda',
          pix: 'PIX',
          upi: 'UPI',
          wallet: 'Carteira de terceiros'
        },
        add: {
          account: 'Nome de Usuário',
          addBank: 'Adicionar Conta Bancária',
          addWechatDef: 'Adicionar WeChat',
          addWechat: 'Adicionar transferência WeChat',
          addWechatQR: 'Adicionar QRCode WeChat',
          addAlipayDef: 'Adicionar Alipay',
          addAlipay: 'Adicionar transferência por Alipay',
          addAlipayQR: 'Adicionar QRCode Alipay',
          bankNo: 'Número da Conta Bancária',
          bankNoRemark:
            '(Verifique cuidadosamente o número do cartão, caso contrário, o valor não será creditado na conta)',
          bankNoPlaceholder: 'Inserir número da conta bancária',
          bank: 'Banco',
          bankPlaceholder: 'Selecione o banco emissor',
          bankDetail: 'É necessário introduzir a agência bancária da conta!',
          bankDetailPlaceholder: 'Inserir agência bancária',
          branchBank: 'Agência bancária',
          branchBankPlaceholder: 'Digite os 4 dígitos da agência bancária',
          bankDetailIFSC: 'IFSC não pode ficar vazio',
          remark:
            'Verifique o nome e o número do cartão com cuidado; caso contrário, não poderá ser creditado',
          remark2:
            'Verifique a conta com cuidado; caso contrário, não poderá ser creditado',
          remark3:
            'Por favor, faça o upload do código de recibo com nome real, ou não será creditado',
          remark4:
            'São suportados apenas arquivos em png, jpg, etc., com até 2 milhões',
          realName: 'Nome real',
          realNamePlaceholder: 'Insira o nome',
          realNameUpperCaseRemark: '(São permitidas apenas letras maiúsculas!)',
          realNameRemark:
            '(Verifique cuidadosamente o nome real, caso contrário, o valor não será creditado na conta)',
          alipayNo: 'O campo Alipay ID não pode ficar em branco',
          alipayNoPlaceholder: 'Número de Telefone ou E-mail',
          alipayNoRemark:
            'A conta Alipay é inválida; ela deve ser um número de telefone ou um e-mail',
          wechatNo: 'A conta do WeChat não pode estar vazia',
          wechatNoPlaceholder: 'Entrar na Conta WeChat',
          wechatQR: 'QRCode WeChat para pagamento',
          alipayQR: 'QRCode Alipay para pagamento',
          transfer: 'Conta de transferência',
          receiveQR: 'Código do Receptor',
          ok: 'Confirmar',
          nextStep: 'Seguintes',
          retry: 'Reenviar',
          setDefaultSuccess: 'Definido com sucesso',
          noWalletNobind: 'Ainda não foi vinculado',
          nowalletId: 'Conta da carteira:',
          noWalletBalance: 'NO Saldo da carteira:',
          delSuccess: 'Deletado com sucesso',
          addSuccess: 'Adicionado com sucesso',
          alreadyBindCPF: 'A conta já está vinculada',
          addWalletAccount: 'Adicionar uma conta da carteira de terceiros',
          addCryptoAccount: 'Adicionar conta de criptomoeda',
          addCrypto: 'Adicionar Criptomoeda',
          addWallet: 'Adicionar a carteira de terceiros',
          addWalletAddress: 'Adicionar o endereço da carteira',
          wallet: 'Carteira',
          cionType: 'Moeda',
          protocol: 'Acordo',
          address: 'O endereço não pode ficar em branco',
          walletAddressPlaceholder: 'Introduza o endereço da carteira',
          addressLabel:
            'Confirme que a moeda, o protocolo e o endereço são corretos, caso contrário, o valor não será creditado',
          addressPlaceholder: 'Introduza um endereço de criptomoeda',
          addressRemark:
            'Por favor, confirme se a moeda, o protocolo e o endereço são consistentes; caso contrário, o valor não será creditado',
          cryptoRemark:
            'Dicas: USDT aceita apenas endereços de saque de acordo com o protocolo TRC20!',
          addPIX: 'Adicionar PIX',
          addPIXAccount: 'Adicionar Conta de PIX',
          accountType: 'Tipo de conta',
          PIXAccount: 'Conta PIX',
          PIXAccountPlaceholder: 'Introduza a sua chave do PIX',
          CNPJAccountPlaceholder: 'Por favor, insira o número do CNPJ',
          CPF: 'CPF',
          CPFPlaceholder: 'Introduza o número de 11 dígitos do CPF',
          addUPI: 'Adicionar UPI',
          addPayMaya: 'Adicionar PayMaya',
          addGrabPay: 'Adicionar GrabPay',
          PayMayaAccount: 'Conta PayMaya',
          GrabPayAccount: 'Conta GrabPay',
          PayMayaFieldPlaceholder: 'Insira sua conta PAYMAYA começando com 0',
          GrabPayFieldPlaceholder: 'Introduza a sua conta GrabPay',
          UPIAccount: 'Conta UPI',
          UPIAccountPlaceholder: 'Introduza a conta UPI',
          addMOMO: 'Adicionar MOMO',
          MOMOAccount: 'Número da conta MOMO',
          MOMOAccountPlaceholder: 'Introduza o número da conta MOMO',
          addZALO: 'Adicionar ZALO',
          ZALOAccount: 'Número da conta ZALO',
          ZALOAccountPlaceholder: 'Introduza o número da conta ZALO',
          addHuiW: 'Adicionar Huione',
          huiWAccount: 'Número da conta Huione',
          huiWAccountPlaceholder: 'Introduza o número da sua conta Huione',
          remark5:
            'Verifique cuidadosamente, caso contrário, não será creditado.',
          fileNull: 'Por favor, envie o código do recibo',
          addGCASH: 'Adicionar GCASH',
          addCLABE: 'Adicionar CLABE',
          addRocket: 'Adicionar Rocket',
          addBKash: 'Adicionar BKash',
          addSureCash: 'Adicionar SureCash',
          addNagad: 'Adicionar Nagad',
          addUPAY: 'Adicionar UPAY',
          addOVO: 'Adicionar OVO',
          addDANA: 'Adicionar DANA',
          addLINKAJA: 'Adicionar LINKAJA',
          addGOPAY: 'Adicionar GOPAY',
          addDOKU: 'Adicionar DOKU',
          addGoTymeBank: 'Adicionar o banco GoTyme',
          addPaga: 'Adicionar Paga',
          addFlutterwave: 'Adicionar Flutterwave',
          addPaystack: 'Adicionar Paystack',
          addInterswitch: 'Adicionar Interswitch',
          addOpay: 'Adicionar Opay',
          addCellulant: 'Adicionar Cellulant',
          addKongapay: 'Adicionar Kongapay',
          addLINEPay: 'Adicionar LINEPay',
          addApplePay: 'Adicionar LINEPay',
          gcashField: 'Conta GCASH',
          CLABEField: 'Conta CLABE',
          CLABEValidate:
            'Sua conta está incorreta. Você quer enviar mesmo assim?',
          RocketField: 'Conta Rocket',
          bKashField: 'Conta bKash',
          SureCashField: 'Conta SureCash',
          NagadField: 'Conta Nagad',
          UPAYField: 'Conta UPAY',
          OVOField: 'Conta OVO',
          DANAField: 'Conta DANA',
          LINKAJAField: 'Conta LINKAJA',
          GOPAYField: 'Conta GOPAY',
          DOKUField: 'Conta DOKU',
          GoTymeBankField: 'Conta bancária GoTyme',
          PagaField: 'Conta Paga',
          FlutterwaveField: 'Conta Flutterwave',
          PaystackField: 'Conta Paystack',
          InterswitchField: 'Conta Interswitch',
          OpayField: 'Conta Opay',
          CellulantField: 'Conta Cellulant',
          KongapayField: 'Conta Kongapay',
          LINEPayField: 'Conta LINEPay',
          ApplePayField: 'Conta LINEPay',
          RocketFieldPlaceholder: 'Insira a conta do foguete',
          bKashFieldPlaceholder: 'Insira a conta do BKASH',
          SureCashFieldPlaceholder: 'Insira a conta do SureCash',
          NagadFieldPlaceholder: 'Insira a conta Nagad',
          UPAYFieldPlaceholder: 'Insira a conta upay',
          OVOFieldPlaceholder: 'Insira a conta OVO',
          DANAFieldPlaceholder: 'Insira a conta Dana',
          DANARemark: 'Por favor, insira o número de celular começando com 0',
          LINKAJAFieldPlaceholder: 'Insira a conta Linkaja',
          GOPAYFieldPlaceholder: 'Insira a conta do Gopay',
          DOKUFieldPlaceholder: 'Insira a conta DOKU',
          PagaFieldPlaceholder: 'Por favor, insira conta Paga',
          FlutterwaveFieldPlaceholder: 'Por favor, insira a conta Flutterwave',
          PaystackFieldPlaceholder: 'Por favor, insira a conta Paystack',
          InterswitchFieldPlaceholder: 'Por favor, insira conta Interswitch',
          OpayFieldPlaceholder: 'Por favor, insira a conta Opay',
          CellulantFieldPlaceholder: 'Por favor, insira a conta Cellulant',
          KongapayFieldPlaceholder: 'Insira a conta Kongapay',
          LINEPayFieldPlaceholder: 'Insira a conta LINEPay',
          ApplePayFieldPlaceholder: 'Insira a conta LINEPay',
          gcashFieldPlaceholder: 'Introduza a conta GCASH começando com 0',
          GoTymeBankFieldPlaceholder: '',
          inputLengthExcessed: 'Insira um espaço para continuar a escrever',
          inputMaxLengthExcessed:
            'São suportados até {leng} caracteres para introdução contínua. Se exceder {leng} caracteres, utilize espaços para os separar.',
          addAccount: 'Adicionar {name}',
          accountName: 'Conta {name}',
          accountPlaceholder: 'Por favor, insira o número da conta {name}',
          IBANCode: 'Código IBAN',
          IBANCodePlaceholder: 'Por favor, digite 26 -bit iban código',
          IBANCodeVerify: 'Deve ter 26 caracteres no total, começando com TR',
          companyNamePlaceholder: 'Por favor, insira o nome da empresa',
          companyName: 'Nome da empresa',
          accountFormatError: 'Erro no formato da conta',
          digitOnly: 'Aceita apenas números puros'
        },
        warning: {
          needRecord:
            'A auditoria não foi concluída. Saque ainda não disponível',
          withdrawAmountMinError:
            'O valor do saque deve igual ou superior a {a}',
          withdrawAmountMaxError:
            'O valor do saque deve igual ou inferior a {a}',
          cpf: 'Insira 11 dígitos',
          email: 'Por favor, insira um formato válido de email',
          evp: 'Introduza 36 caracteres',
          disableAccount: 'A conta de saque foi desativada',
          phone: 'Insira {range} números',
          gcashPhone: 'Por favor, insira o número de 11 dígitos a partir de 0',
          cpfUnanimousPix: 'A conta PIX do tipo CPF deve coincidir com o CPF',
          pixPhoneNoStartWithZero:
            'A chave por telefone do PIX não pode começar com 0',
          pureDigital: 'Deve ter {range} dígitos puros',
          pixNonEmpty: 'Você tem uma conta de PIX que não está preenchida!',
          cpfNonEmpty: 'O CPF não está preenchido!',
          companyNameNonEmpty: 'Por favor, insira o nome da empresa!',
          bankNoNonEmpty: 'Insira o número da conta bancária!',
          bankNonEmpty: 'Escolha um banco!',
          branchBankNonEmpty:
            'Você precisa entrar na agência bancária 4 dígitos!',
          realNameNonEmpty: 'Por favor, insira seu nome real',
          bankIFSC: 'Por favor, insira o código IFSC correto',
          evpVerify: 'Por favor, insira o formato EVP correto'
        },
        withdrawText: {
          alipay: 'Sacar no Alipay',
          wechat: 'Sacar no WeChat',
          bank: 'Sacar no cartão bancário',
          crypto: 'Sacar com criptomoeda',
          wallet: 'Sacar para a carteira de terceiros',
          huiW: 'Sacar para Huione',
          NoWallet: 'Saque para a No Wallet',
          withdrawCashTo: 'Sacar para {to}'
        }
      },
      center: {
        wallet: {
          title: 'Recuperar o saldo',
          balance: 'Saldo total da conta',
          recycle: 'Um clique para recuperar',
          searchPlatform: 'Pesquisa de plataforma',
          refreshGoldSuccessText: 'Todos os saldos foram recuperados',
          refreshGoldFailText: 'Não há saldo para ser sacado no momento',
          prompt:
            'Apenas o saldo inteiro será devolvido para a carteira principal',
          updateError: 'Falhar',
          pending: 'Loading',
          findBackTips:
            'Você só pode recuperar o múltiplo inteiro do equilíbrio (ou seja, sem ponto decimal)'
        }
      }
    },
    aside: {
      music: {
        modalConfigTitle: 'Música',
        modalLibraryTitle: 'Lista',
        xhbf: 'Ciclo',
        sj: 'Aleatório',
        dqxh: 'Repetir',
        qk: 'Lista',
        tabSys: 'Sistema de Música',
        tabMy: 'Minhas músicas',
        toastMessage: 'Última música, que não pode ser eliminada',
        toastDeleteTitle: 'Lembrete',
        toastDeleteMessage: 'Deseja deletar?',
        toastCancel: 'Cancelar',
        toastOk: 'Confirmar',
        noMoreMusic: 'Não há músicas para tocar no momento',
        noMoreNewMusic: 'Não há músicas novas disponíveis',
        downloaded: 'Baixado',
        downloadError: 'Download das músicas falhou!'
      },
      jackpot: {
        title: 'JACKPOT',
        record: 'Registros',
        modelTitle: 'Registros de Jackpot',
        table: {
          time: 'Horas',
          nickname: 'Apelido do jogador',
          gameName: 'Jogo ganho',
          winningPrize: 'Vitórias'
        }
      },
      ping: {
        network: 'Rede',
        networkLine: 'Servidor ',
        currentNetworkLine: 'Servidor atual',
        unavailable: 'A linha não está disponível',
        selectLine: 'Escolha o servidor',
        checkLine: 'Verificação de rede'
      }
    },
    gameMenu: {
      all: 'Tudo',
      home: 'Inicio',
      loadingRecent: 'Recente',
      loadingCollect: 'Favoritos',
      loadingDemo: 'Demo',
      menu0: 'Popular',
      menu1: 'Cartas',
      menu2: 'Pescaria',
      menu3: 'Slots',
      menu4: 'Ao Vivo',
      menu5: 'Esporte',
      menu6: 'Brigas Galos',
      menu7: 'Esports',
      menu8: 'Loteria',
      menu9: 'Clube',
      menu10: 'Sala dos Amigos',
      menu11: 'Blockchain',
      menu20: 'Demo',
      allmenu1: 'Tudo de Cartas',
      allmenu2: 'Tudo de Pescaria',
      allmenu3: 'Tudo de Slots',
      allmenu11: 'Todas as Blockchains',
      allmenu20: 'Todos em jogo de teste',
      menuClub: 'Clube',
      menuFriend: 'Amigos',
      tipsClub: 'Só pode ser utilizado no aplicativo!',
      toDownloadApp: 'Baixar Agora',
      NotToDownloadApp: 'Baixar Depois'
    },
    stakeSystem: {
      discount: 'Centro de ofertas',
      fastShare: 'Compartilhamento rápido',
      onlineSupport: 'Suporte online',
      support: 'Centro de Apoio'
    },
    system: {
      activity: 'Eventos',
      task: 'Missão',
      rebate: 'Rebate',
      award: 'Recompensas',
      vip: 'VIP',
      promote: 'Agente',
      yuebao: 'Juros',
      service: 'Centro de Suporte',
      service2: 'Suporte',
      report: 'Relatório',
      more: 'Mais',
      vip2: 'Clube Superior',
      vip3: 'Royal Club',
      interest: 'Juros',
      rechargeFund: 'Fundo de Previdência'
    },
    game: {
      nav: {
        fastNews: '',
        clickLogin: 'Login',
        signUp: 'Cadastre-se agora',
        or: 'Ou',
        loginBalance: 'Verificar o saldo depois do login',
        Interest: 'Juros',
        yuebao: 'Juros',
        vip: 'VIP',
        promote: 'Agente',
        active: 'Eventos',
        task: 'Missão',
        backwater: 'Rebate',
        prizeFeedback: 'Bônus de Sugestão',
        security: 'Segurança',
        settings: 'Dados',
        accountDetails: 'Conta',
        bettingRecord: 'Apostas',
        personalStatement: 'Relatório',
        award: 'Bônus',
        withdrawalManagement: 'Gerenciamento de saque',
        network: 'Status da Rede',
        language: 'Idioma',
        wallet: 'Carteira',
        audit: 'Tarefas de apostas',
        facebook: 'Facebook',
        google: 'Google',
        line: 'Linha',
        wechat: 'WeChat',
        qq: 'QQ',
        fastNewsLabel: 'Notícias',
        discount: 'Eventos',
        waitingCollect: 'Pendente',
        receiveRecord: 'Histórico'
      },
      home: 'Lobby',
      lobby: 'Lobby',
      recent: 'Recente',
      collect: 'Meus Favoritos',
      demo: 'Jogar Demo',
      openDemoGameTip:
        'Este jogo ainda está em fase de teste; o saque dos lucros não está disponível',
      demoGameToRegTip:
        'O tempo não espera por ninguém. Cadastre-se agora e venha ganhar grandes prêmios! Não perca esta oportunidade!',
      all: 'Tudo',
      hot: 'Popular',
      allHot: 'Popular',
      searchResults: 'Buscar',
      hotCommend: 'Jogos populares',
      menue: 'Jogos',
      egame: 'Esports',
      loadingAll: 'Tudo',
      empty: 'Nenhum jogo disponível',
      maintain: 'Em manutenção',
      gameMaintainText: 'O jogo está em manutenção',
      platformClose: 'A plataforma do jogo está indisponível. Tente mais tarde',
      fetchingPrize:
        'O saldo está carregando. Por favor, tente novamente mais tarde',
      goldInadequate:
        'Seu saldo é menor que {gold}, Por favor, faça um depósito para jogar',
      quotaRatioPrompt:
        'Seu saldo atual é {balance}, que será trazido de acordo com a proporção de {proportion}. Após ser trazido, o valor exibido será: {amount}',
      enterGame: 'Entrar no Jogo',
      scrollDown: 'Deslize para baixo',
      loadingInfo: 'Exibindo {count} jogos de {total} {type} jogos',
      loadingHot: 'Popular',
      loadingRecent: 'Recente',
      loadingCollect: 'Favorito',
      loadingDemo: 'Demo',
      loadingMore: 'Carregar mais',
      loadinged: 'Loading',
      searchHistory: 'Pesquisas Recentes',
      searchGame: 'Procurar jogos',
      search: 'Pesquisar',
      deleteAll: 'Deletar tudo',
      recommend: 'MELHORES',
      takeOutScore: 'Atualizar pontuação',
      gameContinueTips: 'O jogo ainda não acabou, continue jogando.',
      confirmExitGame:
        'Para garantir que seus fundos estão sincronizados, retorne ao lobby após o término do jogo.',
      returnLobby: 'Voltar ao lobby',
      enterCurrenctGame: 'Entre no jogo atual',
      continueGame: 'Continuar o jogo',
      continueGameTips:
        'O último jogo está em andamento. Quer continuar o jogo?',
      nopermission: 'Esta conta não tem permissões de jogo',
      needBindBankCard:
        'Para uma melhor experiência de jogo, é necessário vincular o seu método de saque antes',
      needFirsstRecharge:
        'Para sua experiência de jogo, você precisa concluir a primeira recarga primeiro',
      needDownloadApp:
        'Faça o download e use o aplicativo para continuar aproveitando os jogos!',
      noMatchesLive: 'Nenhum evento ao vivo disponível',
      otherLiveList: 'Outras transmissões de evento ao vivo ',
      liveEnded: 'A transmissão ao vivo foi finalizada',
      noLiveForNow: 'Nenhum evento ao vivo disponível',
      worldCupLiveWillStart: 'A Copa do Mundo já começou. Clique para mudar',
      drag: 'ARRASTAR',
      liveError: 'A linha atual está instável. Mude para outra linha',
      worldCup: 'Copa do Mundo',
      refresh: 'Atualizar',
      fullScreen: 'Tela inteira',
      update: 'ATUALIZAR',
      new: 'NOVO',
      suggest: 'BEST',
      exitFullScreen: 'Sair da tela inteira',
      crownGold: {
        title: 'Coroa Esportiva',
        desc: 'Aproveite os principais eventos populares e aproveite a tempestade no campo',
        imgTitle1: 'Stephen Curry',
        imgDesc1: 'Embaixados Exclusivo da Imagem de Marcas Asiáticas',
        imgTitle2: 'Seleção da Argentina',
        imgDesc2: 'Parceiro Oficial Exclusivo da Ásia',
        imgTitle3: 'Clube de Barcelona',
        imgTitle4: 'Manchester United Club',
        bodyLeft1: 'Copa do Mundo de Futebol Feminino',
        bodyDesc1: 'Plataforma oficial de apostas',
        bodyLeft2: 'Copa do Mundo de Basquete',
        bodyLeft3: 'Copa Asiática',
        bodyLeft4: 'Copa da Europa',
        bodyLeft5: 'Copa América',
        bodyLeft6: 'Jogos Olímpicos de Paris',
        bodyRightTitle: 'Eventos emocionantes bem perto de você',
        bodyRightDesc:
          'Oferece as mais altas probabilidades da indústria, com milhares de eventos esportivos diariamente, abrangendo esportes e ligas em todo o mundo. Oferece uma variedade de opções de apostas, incluindo handicap, over/under, meio/tempo integral, placar correto, gols ímpares/pares, aposta múltipla e transmissão ao vivo, permitindo que você aproveite facilmente as melhores oportunidades de apostas!',
        football: 'Futebol',
        basketball: 'Basquete',
        tennis: 'Tênis',
        snuock: 'Sinuca',
        volleyball: 'Voleibol',
        f1: 'Corrida',
        baseball: 'Beisebol',
        football2: 'Rugby',
        copyRight: 'Copyright do Grupo Galaxy',
        logosBjl: 'Baccarat',
        logosLp: 'Roleta',
        logosSb: 'Sic Bo',
        logosLh: 'Dragon Tiger',
        logosNn: 'Bull Bull',
        logosZjh: 'Ganhar Três Cartas',
        logosSg: 'San Gong',
        logosSsc: 'Timely',
        logosLhc: 'Mark Six Lottery',
        logosSyxw: '11/6',
        logosBjsc: 'Beijing car',
        logosXync: 'Lucky farm',
        logosJssc: 'Speed ​​racing',
        legend: 'League of Legends',
        kingHonor: 'King Glory',
        stoneLegend: 'Hearthstone',
        watchPioneer: 'Overwatch',
        logosGjzl: 'FIFA',
        crownVIP: 'Benefício VIP Real',
        gamingDesc:
          'Cobertura completa dos principais eventos mundiais, fornecendo probabilidades profissionais e dados de resultados de partidas. Oferecendo mais de 100 eventos de esports diariamente, 50+ novos jogos de esports e 10+ partidas de esportes ao vivo com as melhores probabilidades da indústria. A interface visual impressionante e a experiência do usuário eficiente facilitam o seu início.',
        lotteryDesc:
          'Com anos de foco na indústria de jogos de loteria, fomos pioneiros em loteria blockchain e oferecemos numerosos métodos de jogo inovadores exclusivos. Nossa interface de jogo fácil de usar inclui loterias oficiais como a loteria oficial 24/7, 11/5, PK10, PC egg e a loteria oficial Six, permitindo que você jogue à vontade sem sair de casa!',
        porkerDesc:
          'Oferecendo uma grande variedade diversificada de jogos de cartas, incluindo Zhuang Niu Niu, Baccarat, Frying Golden Flowers, Landlords, Two Mahjong, Dragon and Tiger Fighting, etc. Jogue contra amigos e outros jogadores em batalhas reais, permitindo que você aproveite facilmente os jogos de cartas!',
        realDesc:
          'A plataforma mais criativa e orientada para jogos dentro da indústria fornece suporte técnico profissional, equipamentos estáveis de primeira linha, uma equipe de centenas de dealers treinados profissionalmente e um ambiente de cassino simulado. Tudo para garantir que os jogadores possam aproveitar ao máximo o jogo e a atmosfera imersiva!',
        sportsDesc:
          'Com uma variedade de jogabilidade e experiências de alta qualidade, cobrimos uma ampla gama de eventos esportivos e oferecemos centenas de formas de jogar em uma única partida. As operações são simples, atendendo à experiência tanto de novos usuários quanto de veteranos. Eventos especiais permitem que você experimente a paixão por meio de recursos exclusivos de jogabilidade, como apostas especiais, handicaps de 15 minutos, apostas over/under, vitórias simples e muito mais, garantindo que você emoções o tempo todo. '
      },
      galaxyGold: {
        searchTip: 'Insira o nome do jogo',
        backTop: 'Voltar ao topo',
        elecGame: 'Jogos eletrônicos',
        elecGameDesc:
          'Uma plataforma clássica de máquinas caça-níqueis com dezenas de milhares de jogos de caça-níqueis, permitindo que você jogue livremente. Mantendo o espírito trabalhador, inovamos continuamente para oferecer aos jogadores a melhor experiência de jogo. Jackpots acumulados de vários milhões - e de fácil acesso! - estão prontos para serem conquistados por você em um instante! ',
        seeMore: 'Ver mais',
        elecTips: 'Embarque no entretenimento de alto nível aqui',
        porkerFishTips: 'Experimente na perfeição uma deslumbrante galáxia',
        porker: 'Jogos de cartas',
        porkerTips:
          'Banker Bull Bull ou Dragon Tiger: escolha entre esses e outros jogos de cartas e mostre que tem uma mente aberta. Entretenimento competitivo que desafia a sua mente, onde pode jogar competitivamente com amigos. Estes jogos podem mudar vidas!',
        fishing: 'Jogos de pesca',
        fishingTips:
          'Os jogos da pesca estão vindo com toda força, em destaque em várias plataformas populares. Presentes diários luxuosos, Pesca dos Deuses da Sorte, Pesca dos Mil Canhões - o lago de peixes está cheio e à espera que se junte à diversão!',
        game4Tips: 'Todas as experiências são uma forma de prazer',
        realPerson: 'Cassino Ao Vivo',
        electric: 'Esports',
        lottery: 'Jogos de lotaria',
        sports: 'Jogos de esporte',
        realPersonTips:
          'A plataforma mais criativa e divertida do setor, com suporte técnico profissional, equipamentos estáveis de alta qualidade, centenas de dealers treinados profissionalmente e um ambiente de cassino simulado que permite aos jogadores desfrutar da diversão.',
        electricTips:
          'A plataforma de esportes eletrônicos mais profissional da Ásia, projetada para vários jogadores e entusiastas de esportes eletrônicos, com a melhor interface visual e uma experiência de apostas eficiente, reunindo os eventos mais recentes e populares de toda a rede para você escolher.',
        lotteryTips:
          'Explore uma seleção diversificada de centenas de jogos de loteria feitos sob medida para o seu entretenimento. Estamos dedicados a criar um ambiente de entretenimento de primeira linha para os jogadores, garantindo uma experiência de jogo segura e agradável, tudo enquanto mantemos um compromisso com resultados de loteria justos e equitativos.',
        sportsTips:
          'Oferece as probabilidades mais altas da indústria, cobrindo os eventos mais populares em todo o mundo, previsões diversas e transmissões ao vivo em animação e vídeo, facilitando para você experimentar o entretenimento de apostar e encontrar alegria no mundo dos esportes.',
        appTitle: 'Aplicativo Oficial do Galaxy Group',
        appSubTitle: 'Desfrute do tempo entre um momento e um pensamento',
        appDesc:
          'A plataforma móvel de apostas atende jogadores em todo o mundo, oferecendo quase dez mil jogos de caça-níqueis, máquinas caça-níqueis, baccarat, loteria e apostas esportivas. Fornece depósitos e saques online com operações de clique único. Ao empregar cálculos em tempo real em 3D para criar cenas realistas combinadas com imagens em 3D, forma uma plataforma de entretenimento abrangente entre sistemas. Contas sincronizadas integradas e transmissão de dados permitem aproveitar sem interrupções a qualquer momento e em qualquer lugar. Com cada detalhe meticulosamente projetado, o entretenimento está ao seu alcance, acessível sem esforço, e a riqueza está a apenas um clique de distância. ',
        downloadTip:
          'Faça a leitura do QRCode com o seu celular para fazer download',
        downloadH5: 'Acesse sem download',
        aboutTitle:
          'Desfrute de um tratamento excecional e experimente o extraordinário',
        aboutP1:
          'O Galaxy Entertainment Group ("Galaxy" ou o "Grupo") é uma empresa de resorts, hotéis e jogos de azar de renome mundial. Está cotada na Bolsa de Valores de Hong Kong e é um constituinte do Índice Hang Seng.',
        aboutP2:
          'Como um dos três operadores em Macau a receber um contrato de jogo, a Galaxy tem consistentemente recebido reconhecimento por seus projetos, produtos e serviços pioneiros, inovadores e premiados. Aliado à filosofia de serviço "Desafiando Limites, Conectando a Ásia", o desempenho do grupo continua exemplar e lidera o mercado de Macau. ',
        professional: 'Mais profissional',
        professionalTips:
          'A plataforma de jogos mais completa do mundo, com uma equipe profissional garantindo sua jornada e oferecendo uma ampla variedade de jogos eletrônicos para o seu entretenimento. Escolha entre diversas opções de entretenimento, como cartas, pesca e muito mais, permitindo uma experiência de jogo perfeita.',
        safety: 'Mais seguro',
        safetyTips:
          'Desenvolvido exclusivamente, utilizando tecnologia de criptografia de 128 bits e sistemas rigorosos de gerenciamento de segurança, os fundos dos clientes são abrangentemente protegidos, permitindo que você desfrute completamente de entretenimento, apostas em eventos e muito mais, tudo sem preocupações.',
        reliable: 'Mais confiável',
        reliableTips:
          'A plataforma utiliza um sistema de processamento financeiro de última geração, desenvolvido de forma independente, que possibilita depósitos, saques e transferências em alta velocidade. Nossa tecnologia exclusiva de otimização de rede garante uma experiência de jogo de alta qualidade, minimizando a latência da rede ao máximo.',
        convenient: 'Mais conveniente',
        convenientTips:
          'Liderando o mercado com nossas tecnologias excepcionais, desenvolvemos de forma independente um conjunto completo de aplicativos. Você pode desfrutar de acesso contínuo por meio de interfaces Web e H5, e ainda há a conveniência adicional de aplicativos nativos para iOS e Android, permitindo que você participe de entretenimento e apostas a qualquer momento e em qualquer lugar. ',
        activities: 'Promoções',
        vip: 'Vantagens exclusivas para VIP',
        appDownload: 'Baixar App',
        exCenter: 'Centro exclusivo',
        newerHelp: 'Ajuda',
        service: 'Suporte',
        monitor: 'Autoridades reguladoras',
        aboutUs: 'Sobre Nós',
        onlineService: 'Suporte online',
        rewardFeedback: 'Bônus de Sugestão',
        privacy: 'Política de Privacidade',
        aomen: 'Autorizado pelo Governo de Macau',
        feilvbin: 'Autorizado pelo Governo das Filipinas',
        jianpuzhai: 'Autorizado pelo Governo do Camboja',
        gesida: 'Autorizado pelo Governo da Costa Rica',
        latestGame: 'Jogo mais novos',
        latest: 'Atualizado',
        elecGameTips: 'Grande Jackpot - Prestes a Explodir a Qualquer Momento',
        allGame: 'Todos os Jogos',
        hotGame: 'Jogos populares',
        collectGame: 'Coleção de Jogos',
        fishingDesc: 'Big Fish está cheio de vitórias - Exploda com Um Clique',
        porkerDesc: '10.000 pessoas online - PK Intenso',
        sportsDesc: 'Eventos de Alto Nível - Aproveite ',
        lotteryDesc: 'Loterias Em Alta - Escolhas Ilimitadas',
        electricDesc: 'Cobertura completa dos principais eventos',
        realDesc: 'Ótimos dealers ao vivo',
        gamingTitle: 'Muitos jogos populares para você se divertir ao máximo ',
        legend: 'League of Legends',
        kingHonor: 'A Jornada dos Reis',
        eatChicken: 'PUBG',
        stoneLegend: 'Hearthstone',
        starWar: 'StarCraft II',
        watchPioneer: 'Overwatch',
        legendMatch: 'Campeonato de League of Legends',
        dota2Match: 'DOTA2 Torneio Internacional',
        csgoMatch: 'CS: Go Parcerias Oficiais',
        lotteryLhc: 'Mark Six Lottery',
        lotteryCqssc: 'Chongqing Shishi Lottery',
        lotteryPk: 'PK11',
        lotteryKlsf: 'Happy 10',
        lotterySyxw: '11/6',
        lotteryPls: '3D Arrangement',
        lotteryKs: 'Fast 3',
        lotteryJssb: 'Jiangsu Sic Bo',
        lotteryFcsd: 'Fujian Lottery 3D',
        lotteryTitle: 'Muitos jogos populares para garantir sua diversão',
        onshowing: 'Sendo exibido',
        loadingUnit: 'Itens',
        loadingContent: 'Meio',
        loadMore: 'Carregar mais'
      },
      hk: {
        receber_dz: '',
        convidar_dz: '',
        total_dz: '',
        distancia_dz: '',
        recebido_dz: '',
        montante_dz: '',
        hotTest_dz: '',
        play_dz: '',
        playTipTitle_dz: '',
        pplayTipContent_dz: ''
      },
      playStep: 'Passos {n}',
      createAccount: 'Registrar uma Conta',
      topUpNow: 'Deposite Agora',
      topUpNowBtn: 'Depositar agora',
      withdrawNow: 'Sacar agora',
      startPlay: 'Comece a jogar!',
      playNow: 'Jogar agora',
      mostPopular: 'Mais popular',
      palyFishing:
        'Uma plataforma avançada de pesca global que oferece diversas opções de jogo e recompensas diárias.',
      palySlot:
        'Combinando elementos de sorte e habilidade, este jogo proporciona diversão e fascínio aos jogadores.',
      palyLive:
        'A seção de jogos ao vivo funciona como centro para atividades de jogo e apostas.'
    },
    selfoperatedGames: {
      sports: {
        soccer: 'Futebol',
        basketball: 'Basquetebol',
        football: 'Futebol',
        iceHockey: 'Hockey no gelo',
        tennis: 'Tênis',
        volleyball: 'Voleibol',
        billiards: 'Sinuca',
        baseball: 'Beisebol',
        badminton: 'Badminton',
        golf: 'Golfe',
        motorsports: 'Corrida',
        swimming: 'Nadar',
        politics: 'Política',
        water: 'Pólo aquático',
        diving: 'Mergulhando',
        boxing: 'Boxe',
        tableTennis: 'Pingue-pongue',
        handball: 'Handebol',
        darts: 'Dardos',
        rugby: 'Rugby',
        judo: 'Judo',
        ESports: 'eSports',
        beachVolleyball: 'Vôlei de praia',
        finance: 'Finança',
        lotto: 'Loteria',
        unauthorized: 'Sem permissão',
        streamingTemporarilyClosed: 'Vídeo fechado temporariamente',
        fetchStreamingFail: 'Falha ao obter vídeos',
        systemIsUnderMaintenance: 'Sistema em manutenção',
        stakeProblem:
          'O valor da aposta excede o máximo ou está abaixo do mínimo',
        max: 'Máx',
        priceClosed: 'Mercado de apostas temporariamente fechado',
        searchResult: 'Buscar',
        pointChanged: 'Cabeça da bola foi atualizada',
        internalServerError: 'O servidor encontrou um erro inesperado',
        invalidParameterInput:
          'A entrada do parâmetro é inválida ou não é suportada',
        transactionIdNotFound:
          'Número de pedido de aposta correspondente não encontrado',
        cannotCashout: 'Esse bilhete de aposta não pode ser sacado',
        sellBackFail: 'Falha ao terminar antecipadamente',
        eventClosedOrInvalidMarketID: 'O jogo foi fechado',
        parlaySameEvent: '',
        singleWalletFailed: 'Em manutenção. Tente novamente mais tarde!',
        parlayComboMaxPayoutOverLimit:
          'Esta combinação de apostas combinadas atingiu o limite de pagamento',
        parlayOddsLowerThanMinOdds:
          'As probabilidades são menores do que o limite mínimo de probabilidades para apostas combinadas',
        overMaxPayoutPerEvent:
          'Um único evento excede o valor máximo de pagamento',
        parlayNoComboAvailable:
          'Excedeu o número máximo de apostas combinadas. Por favor, reduza o número de apostas na sua combinação.',
        parlayMaxBetLessThanMinBet:
          'A quantidade máxima de apostas múltiplas é menor que a quantidade mínima',
        eventClosed: 'O jogo foi fechado',
        underParlayCount:
          'Abaixo do número mínimo de partidas para aposta múltipla',
        insufficientBalance: 'Saldo insuficiente',
        oddsChanged: '',
        marketClosed: 'Handicap foi fechado',
        overMaxBet:
          'O número de apostas em um único evento excede o valor máximo',
        duplicatedBet: 'Aposta repetida',
        disabledParlayEvent: 'A competição não permite apostas múltiplas',
        disabledParlayByNum:
          'O número mínimo de links cruzados não foi atingido e as apostas não podem ser feitas.',
        loadMore: 'Clique para ver mais',
        noMore: 'Sem mais',
        handicap: 'Handicap',
        bigsmall: 'Over/Under',
        winlosee: 'vitória derrota',
        winloseequal: 'vitória empate derrota',
        betting: 'Apostas',
        betTime: 'Horário de Aposta',
        inputMoney: 'Por favor, insira o principal',
        allMoney: 'Saldo total',
        passLevel: 'Aposta acumulativa',
        canGet: 'Lucro Potencial',
        all: 'Tudo',
        wgSports: 'WG Sports',
        rollingCount: 'Bola rolando {count}',
        todayCount: 'Hoje {count}',
        morningCount: 'Mercado Antecipado {count}',
        passLevelCount: 'Aposta acumulativa {count}',
        championCount: 'Campeão {count}',
        focusOnCount: 'Seguir {count}',
        home: 'Página Inicial',
        away: 'Fora',
        more: 'Mais',
        small: 'Pequeno',
        big: 'Grande',
        homewin: 'Vitória em casa',
        awaywin: 'Vitória fora de casa',
        win: 'vitória',
        foreven: 'empate',
        lose: 'derrota',
        balance: 'Saldo',
        limitAmount: 'Por favor, insira a aposta (limite {minBet}~{maxBet})',
        onlyInteger:
          'O valor da aposta deve ser um número inteiro maior do que 0',
        betted: 'Aposta',
        canGetMost: 'Máx. de lucros',
        cashout: 'Liquidação antecipada',
        cashouting: 'Liquidação antecipada em andamento',
        cashoutTips:
          'Essa aposta será liquidada imediatamente, e o resultado final relacionado a essa aposta não afetará o valor retornado para sua conta. O valor de reembolso inclui a aposta.',
        dealSellback: 'Reembolso em andamento',
        dealSellbackWaiting: 'Reembolso em andamento',
        dealSellbackAccept: 'Retornar para "Aceito"',
        dealSellbackReject: 'Retornar para "Rejeitado"',
        newOffer: 'Forneça novas informações de saque',
        totalStake: 'Aposta total',
        sellBack: 'Reembolso',
        autoReceiveNewPirce:
          'Aceitar automaticamente as últimas probabilidades',
        autoReceiveHighPirce:
          'Aceitar automaticamente as probabilidades mais altas',
        notChangePirce: 'Nunca aceitar alterações nas probabilidades',
        parlayBet: 'Aposta múltipla',
        league: 'Ligas',
        time: 'Horário',
        europe: 'Handicap Europeu',
        hongkong: 'Handicap de HongKong',
        noEventsYet: 'Sem eventos',
        routerBack: 'Voltar',
        clearAll: 'Deletar tudo',
        filterLeague: 'Tela',
        searchEvent: 'Pesquisar',
        hotSearch: 'Pesquisas em alta',
        noLeague: 'Desculpe, não há eventos relevantes',
        showMoreBet: 'Expandir mais opções de acumulação',
        showLessBet: '\nFechar mais opções de aposta múltipla',
        totalBet: 'Aposta comum',
        cancle: 'Cancelar',
        selectAll: 'Tudo',
        cancleAll: 'Desmarcar Tudo',
        confirm: 'Confirmar',
        checkLeague: 'Por favor, selecione o evento',
        betSuccess: 'Apostado com sucesso',
        betFalid: 'A aposta falhou',
        parlayTip: 'Limite máximo de aposta múltipla',
        parlayTip2:
          'Mesma aposta e evento não podem ser acumuladas em conjunto',
        disableParlay: 'A rodada atual não pode ser acumulada',
        addParlaySuccess: 'Adicionada a aposta múltipla com sucesso! ',
        clearBetType: 'Exclua o sucesso da string!',
        marketParlayError:
          'Rodada de exceção. Por favor, selecione a rodada novamente',
        seeBetRecord: 'Ver registros',
        stakeRecord: 'Apostas',
        continueBetting: 'Continuar apostando',
        betRecord: 'Registro de aposta',
        backToHome: 'Voltar a página inicial',
        sports: 'Esportes',
        settled: 'Liquidado',
        unSettled: 'Não liquidado',
        settledAndNot: 'Todos os registros',
        betAmount: 'Valor da aposta:',
        transId: 'Número do pedido',
        betContent: 'Conteúdo da aposta',
        markets: 'Handicap',
        bettingStatus: 'Estado',
        winOrLose: 'V/D (excluindo o principal)',
        tranId: 'Número do pedido',
        copy: 'Copiar',
        screenShot: 'Captura de tela',
        share: 'Partilhar',
        screenShotFalid: 'Captura de tela falhou. Por favor, tente novamente',
        acceptTikets: 'Pedido com sucesso',
        betConfirming: 'Confirmação pendente',
        void: 'Vazio',
        refund: 'Reembolso',
        reject: 'Cancelado',
        draw: 'Empate',
        halfWon: 'Semi-vitória',
        halfLose: 'Semi-derrota',
        noData: 'Sem dados da captura de tela',
        PointDisappear: 'A partida foi removida',
        OddsChanged: 'A probabilidade foi alterada',
        OddsAdjust: 'Ajuste de probabilidade em andamento',
        OddsError: 'Erro na probabilidade',
        GameStatusChanged: 'Alteração no status do jogo',
        GameScoreChanged: 'Alteração na pontuação do jogo',
        GamePointChanged: 'Alteração na rodada do jogo',
        sortPlaceholder: 'Sortear',
        oddPlaceholder: 'Probabilidades',
        processing: '',
        accessTitle: 'Acesso restrito',
        accessContent:
          'A região onde seu IP está localizado não está dentro do nosso alcance de serviço. Mude seu endereço IP para outro país. Pedimos desculpas por qualquer inconveniente que isso possa causar.',
        liveStreaming: 'Vídeo ao vivo',
        viewData: 'Ver dados',
        yellowCard: 'Cartão amarelo',
        redCard: 'Cartão vermelho'
      },
      country: {
        China: 'China',
        Russia: 'Rússia',
        Argentina: 'Argentina',
        Ukraine: 'Ucrânia',
        Mexico: 'México'
      },
      markets: {
        special: 'Aposta especial',
        handicap: 'Handicap',
        handicapUp: 'Na primeira metade, handicap',
        handicapDown: 'Na segunda metade, handicap',
        bigsmall: 'Over/Under',
        bigsmallUp: 'Na primeira metade, Over/Under',
        bigsmallDown: 'Na segunda metade, Over/Under',
        winDrawLose: 'Resultado',
        winDrawLoseUp: 'Resultado - Primeira metade',
        winDrawLoseDown: 'Resultado - Segunda metade',
        score: 'Pontuação',
        scoreUp: 'Pontuação - Primeira metade',
        scoreDown: 'Pontuação - Segunda metade',
        singleDouble: 'Ímpar/Par',
        singleDoubleUp: 'Primeira Metade Ímpar/Par',
        singleDoubleDown: 'Segunda Metade Ímpar/Par',
        doubleChance: 'Chance Dupla',
        doubleChanceUp: 'Primeira Metade Chance Dupla',
        doubleChanceDown: 'Segunda Metade Chance Dupla',
        totalGoal: 'Pontuação Total',
        totalGoalUp: 'Primeira Metade Total de Gols',
        rightTotalGoal: 'Número Exato de Gols',
        rightHomeTotalGoal: 'Número Exato de Gols do Time da Casa',
        rightAwayTotalGoal: 'Número Exato de Gols do Time Visitante',
        rightTotalGoalUp: 'Número Exato de Gols no Primeiro Tempo',
        rightTotalGoalDown: 'Número Exato de Gols no Segundo Tempo',
        zeroLose: 'Zero a Zero',
        zeroLoseWinner: 'Vencedor do Zero a Zero',
        halfAll: 'Metade da Partida/Partida Completa',
        winLose: 'V/D'
      },
      live: {
        notSupportFull: 'O navegador não suporta a função de tela inteira',
        notSupportInPicture:
          'O navegador não suporta a função de tela minimizada',
        pleasePlayFirst: 'Por favor, primeiro clique para jogar'
      },
      eventStatus: {
        prepare: 'Não começar',
        running: 'Em andamento',
        close: 'Fechado',
        postponed: 'Adiado',
        deleted: 'Cancelado'
      }
    },
    notice: {
      announcement: 'Notícia',
      notice: 'Notificação',
      marquee: 'Painel Rolante',
      readed: 'Lidos',
      unread: 'Não lidos',
      empty: 'Sem Mensagem',
      winPrize: 'Bônus',
      receivedSuccess: 'Resgatado com sucesso!',
      receive: 'Resgatar',
      received: 'Resgatado',
      receviePrize: 'Aceitar Bônus',
      all: 'Tudo',
      edit: 'Editar',
      allRead: 'Todos Lidos',
      delete: 'Eliminar',
      cancle: 'Cancelar',
      complete: 'Concluído',
      importantNotice: 'Lembrete importante',
      deleteTip: 'Tem certeza de que deseja limpar todas as notificações?',
      readTip: 'Todas as marcas lidas com sucesso'
    },
    center: {
      components: {
        categorySelect: {
          allCategory: 'Todos os tipos',
          allPlatformCategory: 'Todas as Plataformas',
          alGameCategory: 'Todos os Jogos',
          allDealCategory: 'Detalhes da subcategoria'
        },
        dateRadio: {
          today: 'Hoje',
          yesterday: 'Ontem',
          lastTowDay: 'Nos últimos 2 dias',
          lastSevenDay: 'Últimos 7 Dias',
          lastFifteenDay: 'Últimos 15 Dias',
          lastThirtyDay: 'Últimos 30 Dias',
          lastSixtyDay: 'Últimos 60 dias',
          thisWeek: 'Está Semana',
          lastWeek: 'Última Semana',
          thisMonth: 'Este Mês',
          lastMonth: 'Mês Passado',
          lastTwoMonth: 'Últimos 2 meses',
          lastThreeMonth: 'Últimos 3 meses',
          all: 'Tudo',
          undo: 'Aguardando apostas',
          pending: 'Em andamento',
          done: 'Concluído',
          custom: '',
          customize: 'Personalizar'
        }
      },
      report: {
        title: 'Relatório',
        tabs: {
          personalStatement: 'Relatório',
          bettingRecord: 'Apostas',
          accountDetails: 'Conta'
        },
        table: {
          time: 'Horário',
          type: 'Tipos',
          platform: 'Plataforma',
          game: 'Jogos',
          betting: 'Apostas Válidas',
          betSlip: 'Número de apostas',
          win: 'V/D',
          no: 'ID da Aposta',
          accountChangeType: 'Tipo de Transação',
          typeDetails: 'Detalhes do tipo',
          amount: 'Quantia'
        },
        statistics: {
          validBetTotal: 'Total de Apostas Válidas',
          betSlip: 'Número total de apostas efetuadas',
          profitTotal: 'Total de V/D',
          rechargeTotal: 'Depósito Total',
          reflectTotal: 'Total de Saques',
          discount: 'Acumulado Total'
        },
        bettingRecord: {
          canneled: 'Pedido cancelado',
          unsettled: 'Não Liquidado',
          settled: 'Liquidado',
          all: 'Todos os status'
        },
        personalStatement: {
          winOrLose: 'Número de Apostas/<br />Valor/<br />V/D'
        }
      },
      security: {
        title: 'Segurança',
        notBind: 'Desvincular',
        none: 'Não configurado',
        done: 'Foi Definido',
        status: 'Estado Atual',
        close: 'Desativado',
        isClosed: 'Ativar após verificação',
        open: 'Ativado',
        isOpened: 'Desativar após verificação',
        loginLable: 'Senha de Login',
        valid: 'Verificar a senha para login',
        validOldPwd: 'Verifique a senha de login antiga',
        verifyCode: 'Insira o código de verificação',
        passwordvalidation: 'Verificação da senha',
        twoStepVerification: 'Verificação de dois passos',
        forceBindAnd: 'e',
        forceBindTitle: 'Para segurança da sua conta, vincule o {bindItem}',
        forceBindWidthdrawPass:
          'Para manter seus fundos seguros, uma senha de saque deve ser definida antes de solicitar um saque!',
        forceBindItemTitle:
          'Para segurança da sua conta, você deve vincular pelo menos {length} itens entre {bindItem}',
        bindOtherPrompt:
          'Para segurança da sua conta, vincule primeiro outros itens de segurança',
        noModificationPhone:
          'O número de celular não pode ser alterado no momento',
        bindOther: 'Vincular outros itens de segurança',
        LargeBalancesBindTitle:
          'Devido à grande quantidade de ativos em sua conta, você precisa ativar a autenticação de dois fatores para proteger a segurança de seus fundos! Clique em "Confirmar" para iniciar o processo de vinculação obrigatória',
        phone: {
          tab: 'Nº de Telefone',
          forceBind: 'Vincule o número de celular para jogar jogos',
          phonePlaceholder: 'Digite o Número do Celular',
          smsPlaceholder: 'Insira o código de verificação',
          update: {
            title: 'Alterar número de telemóvel',
            tips: 'O número de celular pode ser alterado após a verificação da senha de login',
            success: 'Número de celular modificado com êxito'
          },
          bind: {
            title: 'Vincular Número de Celular',
            tips: 'Você pode vincular o telefone após verificar a senha de login',
            success: 'Número de celular vinculado com sucesso'
          }
        },
        cpf: {
          tab: 'CPF',
          label: 'CPF',
          placeholder:
            'Não pode ser modificado após a definido. Por favor, prossiga com cautela',
          tips: 'Insira até 11 dígitos',
          bind: {
            title: 'Configurar CPF',
            tips: 'O CPF pode ser configurado após verificar a senha de login',
            success: 'CPF definido com sucesso'
          }
        },
        email: {
          tab: 'Endereço de e-mail',
          forceBind: 'Vincule o e-mail para jogar',
          auth: {
            placeholder: 'Vincule o seu e-mail',
            codePlaceholder: 'Insira o código de verificação'
          },
          update: {
            title: 'Alterar o E-mail',
            tips: 'O e-mail pode ser modificado após verificar a senha de login',
            success: 'E-mail vinculado com sucesso'
          },
          bind: {
            title: 'Vincular o e-mail',
            tips: 'O e-mail pode ser vinculado após verificar a senha de login',
            success: 'E-mail vinculado com sucesso'
          }
        },
        ga: {
          tab: 'Google Authenticator',
          open: 'Ativar a Autentificação Google',
          close: 'Desativar a Autentificação Google',
          forceBind: 'Vincule a Autentificação Google para jogar',
          update: {
            title: 'Modificar a Autentificação Google',
            openTips:
              'O Autentificação Google pode ser ativado após verificar a senha de login',
            closeTips:
              'O Autentificação Google pode ser desativado após verificar a senha de login',
            openSuccess: 'Autentificação Google ativada com sucesso',
            closeSuccess: 'Autentificação Google desativada com sucesso'
          },
          bind: {
            title: 'Vincular Autentificação Google',
            tips: 'A Autentificação Google pode ser vinculada após verificar a senha de login',
            success: 'Autentificação Google configurada com sucesso'
          },
          steps: {
            '1': {
              title:
                'Passo 1: Faça download do aplicativo de Autentificação Google',
              content:
                'Pesquise "Autentificação Google" ou "Google Authenticator" na loja de aplicativos para baixar o aplicativo'
            },
            '2': {
              title: 'Passo 2: Abra o aplicativo e adicione um QR Code',
              content:
                'Não é possível fazer a leitura. Por favor, insira a chave'
            },
            '3': {
              title:
                'Passo 3: Insira o número de seis dígitos mostrado no aplicativo para verificar'
            }
          }
        },
        loginPwd: {
          tab: 'Senha de Login',
          title: 'Alterar Senha',
          placeholder: 'Inserir Senha',
          newPwd: {
            label: 'Nova Senha',
            placeholder:
              '6-16 caracteres, incluindo pelo menos duas letras/números/símbolos',
            placeholder2: 'Por favor, insira a nova senha'
          },
          confirmNewPwd: {
            label: 'Confirme a senha',
            placeholder: 'Confirmar Nova Senha'
          },
          update: {
            tips: 'A senha de login pode ser alterada após verificar a senha atual',
            success: 'Senha alterada com sucesso'
          }
        },
        withdrawalPwd: {
          tab: 'Senha de Saque',
          label: 'Senha de Saque',
          confirmPwd: 'Confirmar Nova Senha',
          oldWithdrawalPwd: 'Senha original de saque',
          newWithdrawalPwd: 'Nova Senha de Saque',
          withdrawalPwdNonEmpty: 'A senha de saque não pode ficar em branco',
          confirmNewPwd: 'Confirme a nova senha de saque',
          update: {
            title: 'Alterar Senha de Saque',
            tips: 'A senha de saque pode ser modificada após verificar a senha de login.',
            success: 'Senha de saque modificada com sucesso.'
          },
          bind: {
            topTips:
              'É o seu primeiro saque. Você precisa configurar uma senha de saque',
            title: 'Defina sua senha de saque',
            tips: 'Depois de verificar a senha de login, você pode definir a senha de saque',
            success: 'Senha de saque configurada com sucesso',
            topRemark: 'Defina primeiro a senha para saque',
            remark:
              'Atenção: A senha de saque protege seus fundos e é extremamente importante. Mantenha-a em segredo para evitar qualquer perda financeira. '
          },
          sameOrContinuousTip: 'Não pode ser 6 mesmos ou números contínuos'
        },
        question: {
          tab: 'Pergunta de Segurança',
          label: 'Pergunta de Segurança',
          update: {
            title: 'Alterar Pergunta de Segurança',
            tips: 'A Pergunta de Segurança pode ser alterada após verificar a senha de login.',
            success: 'Pergunta de Segurança alterada com sucesso'
          },
          bind: {
            title: 'Defina a Pergunta de Segurança',
            tips: 'A Pergunta de Segurança pode ser definida após verificar a senha de login.',
            success: 'Pergunta de segurança definida com sucesso',
            topRemark: 'Defina primeiro uma pergunta de segurança'
          },
          answerConfirm: 'Confirmar a resposta',
          answerConfirmPlaceholder:
            'Insira novamente a resposta à pergunta de segurança',
          notMatch: 'As respostas não correspondem entre si. Insira novamente!'
        },
        thirdWay: {
          tab: 'Vinculação de terceiros',
          tips: 'O terceiro pode ser vinculado após verificação da senha para login',
          success: 'Terceiro vinculado com sucesso',
          login: 'Vincular Login de Terceiros'
        },
        securityConfigExpired:
          'As configurações de segurança foram atualizadas, e a página está atualizando ',
        WithdrawAccount: { title: 'Conta de Saque' }
      },
      setting: {
        avatar: 'Avatar',
        setting: 'Configurar',
        account: 'Nome de Usuário',
        nick: 'Apelido',
        wechat: 'WeChat',
        whatsapp: 'WhatsApp',
        facebook: 'Facebook',
        telegram: 'Telegram',
        zalo: 'Zalo',
        line: 'LINE\n',
        twitter: 'Twitter',
        name: 'Nome',
        enterbirthday:
          'Data de nascimento (não pode ser modificada uma vez que for cadastrada)',
        registerDate: 'Data de Cadastro',
        nickPlaceholder: 'Insira um apelido',
        wechatPlaceholder: 'Introduza a ID do WeChat',
        whatsAppPlaceholder: 'Insira o WhatsApp',
        facebookPlaceholder: 'Por favor, insira sua conta do Facebook',
        telegramPlaceholder: 'Por favor, insira o seu Telegram',
        zaloPlaceholder: 'Por favor insira o seu número Zalo',
        linePlaceholder: 'Entre no Line',
        twitterPlaceholder: 'Introduza a conta do Twitter',
        realNamePlaceholder: 'Vincule primeiro a conta para saque',
        phonePlaceholder: 'Vincule o seu celular',
        ok: 'Confirmar',
        birthdayPlaceholder:
          'Selecione a data de nascimento (depois de definida, não pode ser alterada)',
        goBackConfirm: 'Deseja mesmo voltar?',
        remark:
          'As modificações atuais ainda não foram salvas. Se você retornar, as modificações não serão aplicadas',
        cancel: 'Cancelar',
        man: 'Masculino',
        woman: 'Feminino',
        updateAvatar: 'Mudar Avatar',
        error1: 'Limite de caracteres excedido. Insira novamente',
        error2:
          'A conta WeChat deve iniciar com uma letra ou sublinhado, e pode ser composta por 6-20 caracteres, incluindo sublinhados, símbolos matemáticos ou a sua combinação',
        error3: 'Insira 6-40 números',
        error4: 'Máx. de 40 caracteres permitidos. Insira novamente',
        error5: 'Insira até 40 caracteres',
        error6: 'Insira 5-40 caracteres',
        error7: 'Introduza 4-40 letras/números',
        error8: 'Introduza 4-40 letras/números/símbolos',
        error9:
          'Apenas é permitido introduzir letras, números e caracteres especiais @._-\\',
        error10: 'É permitido até 60 letras/números/caracteres',
        error11: 'Por favor, insira 3-50 bits de inglês/números/caracteres',
        success: 'Informações pessoais alteradas com sucesso',
        save: 'Salvar',
        noChangeToast: 'Você não fez nenhuma alteração',
        goBind: 'Vincular',
        goRecharge: 'Depósito',
        selectDate: 'Selecione a data'
      }
    },
    footer: {
      quickJump: {
        recreationCity: 'Cassino',
        active: 'Eventos',
        task: 'Missão',
        backwater: 'Cashback',
        award: 'Bônus',
        vip: 'VIP',
        paidToPromote: 'Agente',
        game: 'Jogos',
        chessAndCards: 'Cartas',
        fishing: 'Pescaria',
        electronic: 'Slots',
        Cockfight: 'Brigas Galos',
        person: 'Ao Vivo',
        sports: 'Esporte',
        lottery: 'Loteria',
        support: 'Suporte',
        onlineSupport: 'Suporte online',
        helpCenter: 'Central de Ajuda',
        prizeFeedback: 'Bônus de Sugestão',
        quickLogin: 'Login Rápido',
        bindFacebook: 'Vincular Facebook',
        bindGoogle: 'Vincular Google',
        bindLine: 'Vincular linha',
        boundFacebook: 'Facebook vinculado',
        boundGoogle: 'Google vinculado',
        boundLine: 'Linha já vinculada',
        aboutUs: 'Introdução',
        aboutUsSub: 'Sobre Nós',
        privacyPolicy: 'Política de Privacidade',
        other: 'Outros',
        withdraw: 'Problemas no Saque',
        recharge: 'Perguntas de depósito',
        language: 'Idioma',
        eSports: 'E-sportes',
        BlockchainGames: 'Blockchain',
        providentFund: 'Fundo de\nPrevidência'
      },
      cyanBlue: {
        daily: 'Agente',
        dailyContent:
          'Junte-se ao programa para colaboradores gratuitos e capture para ganhar comissões',
        introduceFriends: 'Convidar amigos',
        introduceFriendsContent: 'Convidar amigos para aderir imediatamente',
        vip: 'VIP',
        vipContent: 'Atualize para VIP para desfrutar de benefícios exclusivos',
        support: 'Suporte',
        supportContent:
          'O nosso Atendimento ao Cliente está sempre pronto para o ajudar',
        moreInformation: 'Mais informações',
        followUs: 'Siga-nos',
        licensor: ' Licenciador',
        supplier: 'Fornecedor',
        gameLicecense: 'Licença de jogo',
        certificate: 'Certificado',
        paymentMethod: 'Método de pagamento'
      },
      footerContactUs: 'Fale Conosco',
      copyright: '@Copyright 2002-2022',
      companyInfo:
        '****Group é um dos operadores de jogos online mais renomados do mundo, oferecendo uma variedade emocionante e divertida de jogos, incluindo cassino ao vivo, xadrez, caça-níqueis, pesca, loteria e apostas esportivas. É autorizado e regulamentado pelo governo de Curaçao e opera sob o número de licença **** emitido por ****. Passou por todas as verificações de conformidade e possui autorização legal para conduzir todas as operações de jogos envolvendo oportunidades e apostas.'
    },
    cashback: {
      title: 'Rebate',
      successTips:
        'Resgatado com êxito. Continue a jogar para obter mais bônus~',
      rewardSource: '',
      subInfo: {
        validBets: 'Apostas Válidas',
        amount: 'Eligível para Rebate',
        canReceive: 'Coletável',
        collectAll: 'Resgatar Tudo',
        allValidBets: 'Total de Apostas Válidas',
        allAmounts: 'Rebate Total',
        washCodeAll: 'Rebate instantâneo',
        washableCodesToday: 'Rebate de hoje',
        washableCodesTomorrow: 'Rebate de amanhã',
        accumulated: 'Acumulado',
        totalCodesWash: 'Rebate total',
        todayCollection: 'Disponível para resgate hoje:',
        tomorrowCollection: 'Disponível para resgate amanhã:',
        washableCode: 'Disponível para resgate <span>{x}</span>',
        settingDay: 'Creditado automaticamente as <span>{x}</span>',
        settingWeek: '<span>{x}</span> Chega automaticamente',
        settingMonth:
          'Todo mês no dia {d} às <span>{x}</span> chega automaticamente'
      },
      popup: {
        dayRebate: 'Cashback diário',
        weekRebate: 'Cashback semanal',
        moonRebate: 'Cashback mensal',
        pickUpManually: 'Resgatar manualmente',
        systemDispatch: 'Sistema distribuído',
        upToTip1:
          'Creditado automaticamente devido à falha ao resgatar o prêmio de {x}',
        upToTip2: 'Perdido por não ter reclamado a recompensa até {x}',
        upToTip3: 'Os prémios são creditados automaticamente até {x}'
      },
      tab: { cashback: '{name} Rebate' },
      pageTitle: {
        cards: 'Rebate dos Jogos de Cartas',
        fishHunt: 'Rebate dos Jogos de Pesca',
        electronic: 'Rebate dos Jogos de Slot',
        sports: 'Rebate dos Jogos de Esporte',
        lottery: 'Rebate dos Jogos de Loteria',
        rates: 'Taxa de Rebate',
        records: 'Registro de Rebate',
        vipLevel: 'Nível VIP',
        pickUpRecord: 'Histórico'
      },
      table: {
        platform: 'Plataforma',
        downRates: 'Taxa do nível mais baixo',
        canReceiveAmount: 'Disponível',
        upgradeVip: 'Atualizar para VIP {v} para receber {r}%',
        betAgain: 'Aposte {b} para receber {r}%',
        amount: 'Bônus de Rebate',
        selectCategory: 'Selecionar tipo',
        selectPlatform: 'Selecionar plataforma',
        category: 'Tipos',
        time: 'Horas',
        operator: 'Operar',
        detail: 'Detalhes',
        current: 'Atual'
      },
      detail: 'Detalhes do Rebate'
    },
    event: {
      title: 'Eventos',
      titleGalaxyGold: 'Centro de ofertas',
      galaxyGoldPropaganda1: 'Aproveite a vida ao máximo',
      galaxyGoldPropaganda2: '',
      allActivities: 'Todas as atividades',
      tabLabel: '{x} evento',
      rules: 'Regras',
      content: 'Instruções Do Evento',
      rulesDes:
        'As recompensas deste evento exigem {times} apostas válidas para saque.',
      condition: 'Condições do Evento',
      conditionDeposit: 'Depósito Designado',
      conditionPlatform: 'Plataforma designada',
      time: 'Hora do evento',
      reset: 'Reseta todos os dias às 00:00',
      resetWeek: 'Reseta todas as segundas-feiras às 00:00',
      resetMonth: 'Reseta às 00:00 do primeiro dia de cada mês',
      rulesOnlyDes:
        'O bônus do evento pode ser resgatado em {device} e sacado apenas após ser apostado {times} vezes',
      rulesOnlyDesNoTimes:
        'A recompensa deste evento deve ser resgatado em {device}',
      onlyAndroid: 'Aplicativo Android',
      onlyIos: 'Aplicação iOS',
      onlyApp: 'APP',
      onlyH5: 'Versão mobile do site',
      onlyWeb: 'Versão para computador do site',
      receiveTimes: 'Número de aplicações restantes',
      receiveBtn: 'Cadastrar Imediatamente',
      questionPlaceholder: 'Insira a resposta',
      unconditional: 'Nenhuma condição',
      cumulativereCharge: 'Depósito Total',
      cumulativeCoding: 'Apostar',
      firstIndex: 'I.',
      secondIndex: 'II.',
      thirdIndex: 'III.',
      fourIndex: 'IV.',
      participate: 'Participar',
      verifyTips: 'Esta recompensa precisa ser revisada antes de ser creditada',
      pendingApply: 'Aguardando aplicação',
      tipsText1: 'De volta à água, ainda não foi aberto',
      tipsText2: 'VIP ainda não foi aberto',
      tipsText3: 'Juros não disponíveis',
      expiredTip: 'Expirou em {0}',
      valid: {
        hasH5: 'Login',
        hasApp: 'Fazer download e login',
        h5: 'Versão mobile do site',
        reward: 'Resgate {reward}'
      },
      validRule: {
        limit_1:
          'O bônus do evento pode ser reivindicado no aplicativo iOS, e pode ser sacado após ser apostado {times} vezes',
        limit_2:
          'O bônus do evento pode ser reivindicado no aplicativo Android, e pode ser sacado após ser apostado {times} vezes',
        limit_3:
          'O bônus do evento pode ser reivindicado na versão mobile do site, e pode ser sacado após ser apostado {times} vezes',
        limit_4:
          'O bônus do evento pode ser reivindicado na versão para computador do site, e pode ser sacado após ser apostado {times} vezes',
        limit_1_2:
          'O bônus do evento pode ser reivindicado no aplicativo, e pode ser sacado após ser apostado {times} vezes',
        limit_1_3:
          'O bônus do evento pode ser reivindicado no aplicativo para iOS e na versão mobile do site, e pode ser sacado após ser apostado {times} vezes',
        limit_1_4:
          'O bônus do evento pode ser reivindicado no aplicativo para iOS e na versão para computador do site, e pode ser sacado após ser apostado {times} vezes',
        limit_2_3:
          'O bônus do evento pode ser reivindicado no aplicativo para Android e na versão mobile do site, e pode ser sacado após ser apostado {times} vezes',
        limit_2_4:
          'O bônus do evento pode ser reivindicado no aplicativo para Android e na versão para computador do site, e pode ser sacado após ser apostado {times} vezes',
        limit_3_4:
          'O bônus do evento pode ser reivindicado na versão mobile e na versão para computador do site, e pode ser sacado após ser apostado {times} vezes',
        limit_1_2_3:
          'O bônus do evento pode ser reivindicado no aplicativo e na versão mobile do site, e pode ser sacado após ser apostado {times} vezes',
        limit_1_2_4:
          'O bônus do evento pode ser reivindicado no aplicativo e na versão para computador do site, e pode ser sacado após ser apostado {times} vezes',
        limit_1_3_4:
          'O bônus do evento pode ser reivindicado no aplicativo iOS, na versão mobile e na versão para computador do site, e pode ser sacado após ser apostado {times} vezes',
        limit_2_3_4:
          'O bônus do evento pode ser reivindicado no aplicativo Android, na versão mobile e na versão para computador do site, e pode ser sacado após ser apostado {times} vezes',
        limit_1_2_3_4:
          'O bônus do evento pode ser sacado após ser apostado {times} vezes',
        limitNoTimes_1:
          'As recompensas deste evento precisam ser resgatadas no aplicativo iOS.',
        limitNoTimes_2:
          'As recompensas deste evento precisam ser resgatadas no aplicativo Android',
        limitNoTimes_3:
          'As recompensas deste evento precisam ser resgatadas na versão mobile do site',
        limitNoTimes_4:
          'As recompensas deste evento precisam ser resgatadas na versão para computador do site',
        limitNoTimes_1_2:
          'As recompensas deste evento precisam ser resgatadas no aplicativo',
        limitNoTimes_1_3:
          'As recompensas deste evento precisam ser resgatadas no aplicativo iOS e na versão para computador do site.',
        limitNoTimes_1_4:
          'As recompensas deste evento precisam ser resgatadas no aplicativo iOS e na versão para computador do site.',
        limitNoTimes_2_3:
          'As recompensas deste evento precisam ser resgatadas no aplicativo Android e na versão mobile do site.',
        limitNoTimes_2_4:
          'As recompensas deste evento precisam ser resgatadas no aplicativo Android e na versão para computador do site.',
        limitNoTimes_3_4:
          'As recompensas deste evento precisam ser resgatadas na versão mobile e na versão para computador do site.',
        limitNoTimes_1_2_3:
          'As recompensas deste evento precisam ser resgatadas no aplicativo e na versão mobile do site.',
        limitNoTimes_1_2_4:
          'As recompensas deste evento precisam ser resgatadas no aplicativo e na versão para computador do site.',
        limitNoTimes_1_3_4:
          'As recompensas deste evento precisam ser resgatadas no aplicativo iOS, na versão mobile e na versão para computador do site.',
        limitNoTimes_2_3_4:
          'As recompensas deste evento precisam ser resgatadas no aplicativo Android, na versão mobile e na versão para computador do site.'
      },
      validTips: {
        limit_1: 'Faça download e login no aplicativo iOS para resgatar',
        limit_2: 'Faça download e login no aplicativo Android para resgatar',
        limit_3: 'Faça login na versão mobile do site para resgatar',
        limit_4: 'Faça login na versão para computador do site para resgatar',
        limit_1_2: 'Faça download e login no aplicativo para resgatar',
        limit_1_3:
          'Faça download e login no aplicativo iOS, na versão mobile e na versão para computador do site para resgatar',
        limit_1_4:
          'Faça download e login no aplicativo iOS e na versão para computador do site para resgatar',
        limit_2_3:
          'Faça download e login no aplicativo Android, na versão para computador e na versão mobile do site para resgatar',
        limit_2_4:
          'Faça download e login no aplicativo Android e na versão para computador do site para resgatar',
        limit_3_4:
          'Faça login na versão mobile e na versão para computador do site para resgatar',
        limit_1_2_3:
          'Faça download e login no aplicativo e na versão mobile do site para resgatar',
        limit_1_2_4:
          'Faça download e login no aplicativo e na versão para computador do site para resgatar',
        limit_1_3_4:
          'Faça download e login no aplicativo iOS, na versão mobile e na versão para computador do site para resgatar',
        limit_2_3_4:
          'Faça download e login no aplicativo Android, na versão mobile e na versão para computador do site para resgatar'
      },
      validDay: {
        monday: 'Todas as segundas-feiras',
        tuesday: 'Todas as terças-feiras',
        wednesday: 'Todas as quartas-feiras',
        thursday: 'Todas as quintas-feiras',
        friday: 'Todas as sextas-feiras',
        saturday: 'Todos os sábados',
        sunday: 'Todos os domingos',
        daily: 'Limite Diário',
        day: 'Diário',
        renPocketTime: 'Hora da distribuição',
        reset: 'Resetar',
        template: '{day} {startTime} - {endTime}'
      },
      eventTypes: {
        deposit: 'Depósito do Evento',
        chips: 'Evento de Apostas',
        characters: 'Evento de Coleção de Caracteres',
        sign: 'Evento de Check-In',
        redPocket: 'Evento de Envelope Vermelho',
        rescue: 'Bônus de Suporte no Evento',
        invest: 'Evento de Investimento',
        luckyWheel: 'Roda da Fortuna',
        customize: 'Evento Personalizado',
        proxy: 'Evento do Agente',
        promote: 'Evento do Agente'
      },
      listedRewards: {
        perTime: 'Cada vez',
        perMonth: 'Todo mês',
        perDay: 'Diário',
        perWeek: 'Semanalmente',
        upperLimit: '(Até {x})',
        noRewards: 'Não existem recompensas a serem resgatadas no momento',
        firstRecharge: 'Primeiro depósito',
        weeklyPay: 'Depósito único por semana',
        weeklyTotalPay: 'Depósito acumulativo por semana',
        perMonthPay: 'Depósito único por mês',
        perMonthTotalPay: 'Depósito acumulado por mês',
        perMonthReceive: 'Receber no {time} de cada mês',
        weeklyReceive: 'Receber no {time}',
        receiveTimeDay: 'Resgatar das {startTime} as {endTime} diariamente',
        canReceiveTip:
          'Esta recompensa só pode ser reclamada em {day}; recompensas expiradas serão perdidas!',
        canReceiveTip1: 'Esta recompensa pode ser resgatada após {day}',
        canReceiveTip2:
          'A recompensa pode ser resgatada entre {startTime} a {endTime} diariamente',
        canReceiveTip3:
          'A recompensa só pode ser resgatada em {week}{startTime}-{endTime}',
        canReceiveTip4:
          'Esta recompensa pode ser resgatada no dia {day} as {startTime}-{endTime} de cada mês',
        source: 'Fonte',
        toBeCollectedToday: 'Para coletar hoje',
        collectTomorrow:
          'Amanhã pode receber <span> (lembre-se de verificar) </span>',
        receivedToday: 'Creditado automaticamente hoje',
        rewardSource: 'Fonte de recompensa',
        rewardName: 'Nome da recompensa',
        rewardTime: 'Tempo de recompensa',
        rewardexplain: 'Recompensas',
        distributed: '',
        validBet: 'Total de\nApostas Válidas',
        ratio: 'Proporção',
        award: 'Tipo de recompensa',
        arrivalTime: 'Hora de chegada',
        availableTime: 'Horário disponível',
        validityTime: 'Período de validade',
        status: 'Estado',
        remark: 'Observação',
        pending: 'Pendente',
        received: 'Resgatado',
        dispatched: 'Distribuído',
        expiredDispatched: 'Distribuição expirada',
        bonus: 'Bônus',
        ruleTabe: {
          singleRechargeAmount: 'Valor de depósito único',
          awardAmount: 'Recompensa',
          activityDescription: 'Introdução do Evento',
          singleRecharge:
            'Efetue um depósito único de {x} para reivindicar {y}',
          single: 'Depósito único',
          rewardRatio: 'Taxa de recompensa',
          awarMaxLimit: 'Limite de recompensa'
        }
      },
      redPocket: {
        todaySinglePay: 'Depósitos diarios',
        todayPay: 'Depósitos diarios',
        todaySingleBet: 'Apostas diárias',
        todayBet: 'Apostas diárias',
        redPocketAmount: 'Quantia de envelopes vermelhos',
        grabPocketAwarMaxLimit: 'Limite de envelopes vermelhos',
        payTip: 'Deposite {x} hoje para participar. Você já depositou {y}',
        grabTip1:
          'Limite total: {x} vezes, limite desta rodada: {y} vezes (restantes: {z} vezes)',
        grabTip2:
          'Máximo de resgates nesta rodada: {x} vezes (restantes: {y} vezes)',
        betTip: 'É necessário {x} em apostas hoje. Você já apostou {y}',
        sendRedPockTip:
          'Limite de envelopes vermelhos: {x} vezes (ainda restam {y} vezes)',
        times: '{x} vezes',
        closeTip:
          'Após o fechamento, as recompensas desta rodada não aparecerão mais. <br />Ao desistir voluntariamente da recompensa.',
        open: 'ATIVAR',
        grab: 'AGARRAR',
        send: 'Enviar',
        congrats: 'PARABÉNS',
        message: 'O bônus foi depositado na sua carteira',
        pinReset: 'Apagar',
        pinDelete: 'Deletar',
        pinText: 'Código',
        errorTips: 'Código incorreto'
      },
      rescue: {
        yesterdayData: 'Perdas de ontem',
        yesterdayData1: 'Perdas da última semana',
        yesterdayData2: 'Perdas do último mês',
        todayData: 'Bônus de suporte de hoje',
        todayData1: 'Bônus de apoio desta semana',
        todayData2: 'Bônus de apoio deste mês',
        columns: {
          amount: { label: 'Valor da perda' },
          reward: {
            label: 'Prêmios Extra ({unit})',
            labelNoPercent: 'Prêmios Extra'
          }
        }
      },
      proxy: {
        yesterdayCommission: 'Comissões de ontem',
        todayCommission: 'Comissões de hoje',
        todayReward: 'Bônus de hoje',
        dayPay: {
          '0': 'Depósito do subordinado ontem',
          '1': 'Depósito diário do subordinado'
        },
        day: {
          '0': 'Comissões de ontem',
          '1': 'Comissões diárias',
          '2': 'Recompensas de hoje'
        },
        weekPay: {
          '0': 'Depósito do subordinado da semana anterior',
          '1': 'Depósito semanal do subordinado'
        },
        week: {
          '0': 'Comissões da semana passada',
          '1': 'Comissões semanais',
          '2': 'Recompensas desta semana'
        },
        monthPay: {
          '0': 'Depósito do subordinado do mês anterior',
          '1': 'Depósito mensal do subordinado'
        },
        month: {
          '0': 'Comissões do mês passado',
          '1': 'Comissões Mensais',
          '2': 'Recompensas deste mês'
        },
        otherReward: 'Prêmios Extra'
      },
      invest: {
        todayData: 'Rebate de Hoje',
        daysReceived: 'Dias Recebidos',
        investmentAmount: 'Valor Investido',
        accumulated: 'Acumulado Total',
        now: 'Invista Agora',
        receive: 'Resgatar',
        receiveSuccess: 'Reivindicado com êxito!',
        applySuccess: 'Aplicado com sucesso!',
        received: 'Resgatado',
        confirm: 'Confirmar',
        title: 'Investimento',
        balance: 'Saldo da Conta',
        amount: 'Valor Investido',
        investSuccess: 'Investido com sucesso',
        investLimitTips: 'Saldo insuficiente',
        receiveItem: 'Invista {range}, e ganhe mais {give}',
        tips: 'O valor investido será deduzido da conta, e a recompensa pode ser solicitada a partir do próximo dia após o investimento',
        columns: {
          investmentAmount: { label: 'Valor do investimento' },
          dayRewardRate: { label: 'Lucro Diário' },
          rewardDays: { label: 'Dias de Rebate', value: '{days}Dia(s)' },
          totalRewardRate: { label: 'Lucro acumulado' }
        }
      },
      collectWords: {
        beingSynthesized: 'Combinando',
        synthesized: 'Combinado com êxito',
        totalAmount: 'Recolha palavras para distribuir os lucros',
        reveal: 'Prêmio',
        collected: 'Coletei {x} conjuntos',
        collectedStrong: 'Coletei <span>{x}</span> conjuntos',
        tips: 'As chances de sorteio de caracteres é obtidos diariamente ao concluir tarefas.',
        extract: 'SORTEIO',
        extractAllWord: 'Sorteio por um clique',
        extractValidTimes: 'Resta {x} vezes',
        button: 'UNIR',
        ruleButtons: {
          unstarted: 'Não Começou',
          forward: 'Prosseguir',
          processing: 'Em andamento',
          complete: 'Concluído'
        },
        syntheticSuccess: 'Combinação bem-sucedida',
        syntheticFailed: 'Combinação falhou',
        ruleTimes: 'Concluído {x}/{y} vezes',
        congrats: 'Parabéns!  ',
        resultSummary:
          '{x} jogadores coletaram {y} conjuntos, e cada conjunto ganha <span>{z}</span>',
        resultCollect: 'Resgatar',
        resultCollected: 'Resgatado',
        result: '{x}×{y} conjuntos: <span>{z}</span>',
        resultUnFinish:
          'Você não completou o evento dessa vez. Tente novamente!'
      },
      sign: {
        continued: 'Sessão iniciada <span>{x}</span> dias consecutivos',
        grand: 'Fez check-in por <span>{x}</span> dias consecutivos',
        topupNeed:
          'É necessário para depositar <span>{x}<span>/{y}</span></span>',
        collected: 'RECEBIDOS <strong>{x}</strong>',
        betNeed: 'Apostas necessárias <span>{x}<span>/{y}</span></span>',
        signIn: 'Entrar',
        hasSignIn: 'Inscrito',
        hasReceive: 'Resgatado',
        dayCount: 'Dia {x}',
        extraPrize: 'Prêmios Extra',
        successText: 'Parabéns! Você recebeu um bônus de {x}',
        extraPrizeSuccessText: 'Parabéns por receber um bônus adicional de {x}',
        noSignIn: 'Não é possível fazer login no momento'
      },
      luckyWheel: {
        tabs: {
          silver: 'Roda de Prata',
          gold: 'Roda de Ouro',
          diamond: 'Roda de Diamante',
          luckyValue: 'Pontos de Sorte',
          turntableTask: 'Tarefa necessária',
          getAnnouncement: 'Notificação de Prêmio',
          myRecord: 'Meus Registros',
          noData: 'Sem Registros',
          drawNow: 'RODAR',
          currentLuckyValue: 'Pontos de sorte atuais',
          details: 'Detalhes'
        },
        splicingGet: '{user} obtê -lo em {zhuanpan}',
        effectiveBetTips:
          'Você ainda precisa apostar {x} para obter {n} Pontos de sorte',
        betDetails: {
          betTotal: 'Total de apostas durante o período do evento',
          currentRulesLabel: 'Regras atuais',
          currentRules: 'Aposte {b} para obter {n} Pontos de sorte',
          luckyPointsUsed: 'Valor de sorte utilizado',
          luckyValueAvailable: 'Valor de sorte disponível',
          expireIntegral: 'Valor da Sorte expirado',
          countingMethodTitle: 'Método de cálculo do Valor de sorte:'
        },
        toast: {
          notEnough: 'O seu valor da sorte não é suficiente',
          receiveSuccess: 'Resgatado com sucesso',
          depositBalance: 'Depositado no saldo'
        },
        table: {
          time: 'Horário',
          dayTask: 'Missão Diária',
          weekTask: 'Missão Semanal',
          luckyValue: 'Pontos de Sorte',
          canGetluckyValue: 'Pode ganhar pontos de sorte'
        }
      },
      promote: {
        currentValid: 'Está sendo referido por <span>{x}</span> pessoas',
        currentRequire:
          '(Depósito necessário <span>{x}</span>, Aposta necessária <span>{y}</span>)',
        currentRecharge: '(Requisitos para depósito<span>{x}</span>)',
        currentBet: '(Requisitos para apostas<span>{y}</span>)',
        copySuccess: 'Copiado com sucesso!',
        copyFailed: 'A cópia falhou. Copie manualmente',
        people: '{x} pessoas',
        promoteUrl: 'URL de Convite',
        userName: 'Contas de subordinados',
        createTime: 'Hora de registro',
        isItEffective: 'É válido?',
        yes: 'Sim',
        no: 'Não',
        validConditions: 'Condições válidas',
        details: 'Detalhes',
        all: 'Tudo',
        isEffective: 'É válido?',
        efficient: 'Válido',
        invalid: 'Inválido',
        accountFirstDeposit: 'Depósito inicial da conta',
        cumulativeRecharge: 'Depósito Total',
        cumulativeCoding: 'Apostas',
        cumulativeRechargeDays: 'Total de depósitos',
        cumulativeRechargeTimes: 'N.º de dias com depósitos',
        registerIPRestrictions: 'IP de registro duplicado',
        registerDeviceRestrictions: 'Dispositivo de registro duplicado',
        downloadAPPLogin: 'Baixe o aplicativo e faça login',
        promotionDetails: 'Detalhes do convite',
        effectivePromotionNumber: 'N.º de jogadores efetivamente promovidos',
        award: 'Bônus',
        effectivePromotionNumberQuestion:
          'O que é um número válido promocional?(Cumprir todos os requisitos indicados abaixo)',
        effectivePromotionNumberArbitrarily:
          'O que é um número válido promocional? (Cumpra qualquer dos seguinte requisitos) ',
        effectivePromotionNumberTip0:
          'Subordinados precisam fazer download do aplicativo e login',
        effectivePromotionNumberTip1: 'Primeiro depósito do subordinado',
        effectivePromotionNumberTip2: 'O subordinado acumulou depósitos',
        effectivePromotionNumberTip3: 'O subordinado acumulou apostas',
        effectivePromotionNumberTip4:
          'O subordinado acumulou o nº de depósitos',
        effectivePromotionNumberTip5: 'O subordinado acumulou depósitos',
        mySubordinate: 'Os meus subordinados',
        numberPeople: 'Pessoas',
        effectiveNumberOfPeople: '{x} Jogadores válidos',
        yesterdayEfficient: '{x} pessoas válidas ontem',
        receive: 'Resgatar',
        quickShare: 'Partilha rápida',
        shareNow: 'Partilhar agora',
        more: 'Mais',
        shareTo: 'Partilhar para',
        orAbove: 'Ou o acima mencionado',
        timesOrMore: 'Vezes ou mais',
        copyLink: 'Copiar link',
        save: 'Salvar',
        cancel: 'Cancelar',
        cumulativeRewards: 'Recompensas cumulativas',
        cumulativeRewardsTip: 'Distribuição automática no dia seguinte',
        effectivePromotionYesterday: 'Promovido efetivamente ontem',
        dayOrMore: 'Dias ou mais',
        updateTime: 'Hora da atualização',
        effectiveSubordinate: 'Subordinados válidos {x} pessoas',
        yesterdaysEffectivePromoter: 'Promoveu efetivamente {x} pessoas ontem',
        receiveTimeEveryDaily:
          'A recompensa é apenas diariamente {startTime}-{endTime}',
        receiveTimeNextDay:
          'Esta recompensa pode ser resgatada apenas no dia seguinte {startTime}-{endTime}',
        receiveTimeWeekly:
          'Esta recompensa pode ser resgatada toda segunda-feira {startTime}-{endTime}',
        receiveTimeMonthly:
          'Esta recompensa pode ser resgatada no primeiro dia de cada mês {startTime}-{endTime}'
      },
      bet: {
        endToBeAwarded: 'O evento terminou. Aguarde os resultados',
        endAndAwarded:
          'A recompensa foi distribuída, você pode acessar o registro de reivindicação para visualizá-la',
        myIntegral: 'Meus Pontos',
        slimageBonusBonus: 'Partilhar o bônus total',
        award: 'Prêmio',
        winWin: 'Perdas e ganhos de pontos',
        record: 'Registros',
        time: 'Horas',
        result: 'Resultados',
        quizProject: 'Eventos de aposta',
        bettingBelow: 'Aposte {x} para ganhar ({y})',
        bettingOneBelow: 'Aposte {x} para ganhar',
        toBeAwarded: 'Para ser aberto',
        winning: 'Ganhou',
        unintendedPrize: 'Perder',
        guessRecord: 'Registros de aposta',
        allDisplayed: 'Exibir tudo',
        noGame: 'Sem jogos disponíveis',
        day: 'Faça login no evento diariamente para ganhar {x} pontos por dia',
        charge: 'Obtenha pontos correspondentes a 1:10 por depósitos diários',
        coding: 'Obtenha pontos correspondentes a 1:1 por apostas diárias',
        item: {
          betting: 'Aposta em andamento',
          bettingEnd: 'Espere a recompensa',
          win: 'Parabéns!',
          failed: 'Falhou',
          opened: 'Recompensa',
          renew: 'Continuar apostando',
          noGame: 'Sem jogos disponíveis',
          bet: 'Aposta',
          seal: 'Fechado',
          youDontNote: 'Não apostou',
          integral: 'Pontos',
          toBeDetermined: 'A ser determinado',
          odds: 'Probabilidade',
          draw: 'Empate',
          winOut: 'Ganhar',
          all: 'Tudo',
          youHaveBet: 'Apostou <span>{x}</span> pontos',
          betTeam: 'Selecionou {x} para ganhar',
          betDraw: 'Selecionou Empate',
          pleaseSelectTheOdds: 'Selecione a probabilidade',
          pleaseEnterTheBetPoint: 'Insira os pontos apostados',
          notBeLower: 'Os pontos da aposta não podem ser inferiores a {x}',
          notBeHigher: 'Os pontos da aposta não podem ser superiores a {x}',
          onlySupports: 'Os pontos de aposta suportam apenas {x}-{y}',
          notBeHigherThanYours: 'Os seus pontos são insuficientes',
          withdrawAmountPlaceholder: 'Mínimo{a}, Máximo{b}',
          deadlineForBetting: 'Prazo para apostas:',
          onlyParticipate: 'É necessário {a}{b} para participar'
        }
      },
      luckyBet: {
        awardOrders: 'Aposta ganha de hoje',
        notAwarded: 'Nenhuma aposta ganha hoje',
        receive: 'Resgatar',
        received: 'Resgatado',
        reward: 'Bônus',
        orderNo: 'Número do pedido vencedor:',
        totalLimit: 'Limite total - {x} vezes. ',
        todayLimit: 'Limite máx. {y} hoje ({z} vezes restantes)',
        orderEnd: 'Número final da aposta',
        orderContinue: 'Números consecutivos em qualquer posição da aposta',
        orderRandom: 'Qualquer posição da aposta inclui',
        amountTimes: 'Multiplicação de Bônus',
        betNumTimes: '{x} vezes o valor da aposta',
        fixedAmount: 'Bônus fixo',
        amountLimit: 'Limite de bônus',
        validBet: 'Apostas válidas diárias',
        validCharge: 'Depósito diário',
        dailyLimit: 'Limite diário de resgates',
        times: 'Vezes',
        piece: 'Um',
        rewardDescription:
          'Valor do bônus = valor da aposta x bônus multiplicado, sem exceder o limite máximo',
        receiveSuccess: 'Resgatado com sucesso!',
        noLimit: 'Ilimitado'
      },
      ranking: {
        ranking: 'Presença',
        loadingMore: 'Carregar tudo',
        settling: 'Liquidação em andamento',
        rewardAmount: 'Recompensa',
        accumulatedRecharge1: 'Jogador/recarga\ncumulativa',
        accumulatedRecharge2: 'Jogador/recarga única',
        accumulatedRecharge3: 'Apostador/apostado\ncumulativo',
        todayRanking1_1: 'Ranking de recarga de hoje',
        yesterdayRankingList1_1: 'Ranking da recarga de ontem',
        todayRanking2_1: 'Ranking esta semana',
        yesterdayRankingList2_1: 'Ranking de recarga da semana passada',
        todayRanking3_1: 'Classificação de recarga este mês',
        yesterdayRankingList3_1: 'Ranking de recarga do mês passado',
        todayRanking1_2: 'Ranking único de hoje',
        yesterdayRankingList1_2: 'Ranking único\nde ontem',
        todayRanking2_2: 'Ranking único esta semana',
        yesterdayRankingList2_2: 'Ranking único da semana passada',
        todayRanking3_2: 'A classificação única deste mês',
        yesterdayRankingList3_2: 'Ranking único do mês passado',
        todayRanking1_3: 'Ranking de aposta de hoje',
        yesterdayRankingList1_3: 'Ranking de apostas ontem',
        todayRanking2_3: 'Rankings de apostas esta semana',
        yesterdayRankingList2_3: 'Ranking de aposta da semana passada',
        todayRanking3_3: 'Rankings de apostas este mês',
        yesterdayRankingList3_3: 'Ranking de aposta do mês passado',
        yesterdayRanking1: 'Seu ranking ontem',
        yesterdayRanking2: 'Você está classificado na semana passada',
        yesterdayRanking3: 'Você está no mês passado',
        maxRow: 'Apareça até 100 dados de jogadores',
        getBonus: 'Bônus de vitória',
        myself: 'Eu mesmo',
        currentRanking: 'Sua classificação atual',
        todayBonus: 'Bônus esperado',
        refresh: 'Atualizar',
        rankingNum: 'Não. {0}',
        everyOneRewardAmount: '/Pessoas',
        notOnList: 'Não Listado'
      },
      discountCode: {
        discountCode: 'Bônus de novo jogador',
        firstDepositCount: 'Valor do primeiro depósito',
        discountCodeSms: 'Execute a verificação de SMS para ganhar bônus',
        placeholder: 'Introduza o código de resgate',
        confirmTheExchange: 'Resgatar bônus',
        payBtn: 'Deposite agora',
        success: 'Parabéns, você recebeu um bônus de {x}',
        confirm: 'Confirmar',
        close: 'Fechar',
        needRecharge: 'É necessário depositar {x} para sacar',
        tipsLable: 'Valor do bônus:',
        tips3: '{x}% do valor do primeiro depósito, até {y}',
        activityNotStarted: 'O evento ainda não começou',
        activityHasEnded: 'O evento terminou',
        activityIDInvalid: 'ID do evento inválido',
        notPhoneGold: 'O ID do evento não é um bônus de telefone',
        areaCodeIncorrect: 'Código da área incorreto',
        phoneNumberNothingness: 'Número de telefone inválido',
        phoneNumberBeUsed: 'Número de telefone já utilizado',
        congratulations: 'Parabéns! Verificação por SMS concluída ',
        completedRegistration:
          'Parabéns, você concluiu o registro da sua conta',
        activityDissatisfy:
          'Você não cumpre os requisitos para participar desta atividade. A participação está limitada à usuários convidados.',
        notEligibleEvent:
          'Você não cumpre os requisitos para participar do evento',
        alreadyWon: 'Bônus Recebidos',
        verifyMobile: 'Verifique o seu número de celular para resgatar o bônus',
        congratulationsReCode: 'Parabéns, troca concluída com sucesso! ',
        tipsText:
          'Lembrete: o limite máximo de lucro deste bônus é {x}. Após obter o lucro, é necessário depositar {y} antes de efetuar um saque! ',
        notProfitLimit: 'Ilimitado',
        tipsProfitUpperLimit: 'O limite máximo de lucro para este bônus é {x}',
        tipstipsNeedRechargeAfterProfit:
          'Depósito de {y} é requerido para sacar o lucro obtido!',
        distributed: 'Distribuído',
        getRedeemCode: 'Obtenha o código de troca'
      },
      cutOnce: {
        lottery: 'Sorteio',
        drawsNumber: 'Resta<span>{x}</span>vezes',
        myRecord: 'Meus Registros',
        winningAnnouncement: 'Anúncio do vencedor',
        rule: 'Regras',
        bonus: 'Prêmio <span>{x}-{y}</span>',
        receive: 'Resgatar',
        progressText1: '{x}% concluído; resta {n}%',
        progressText2: '{x}% concluído',
        resetcountdown: 'Redefinir após {time}',
        updateTime: 'Atualizar tempo: {time}',
        manualUpdate: 'Atualização manual',
        detail: 'Detalhes',
        forward: 'Ir',
        lookover: 'Visualizar',
        more: 'Mais',
        userAccount: 'Nome de Usuário',
        createTime: 'Hora de registro',
        detailInfo: 'Detalhes',
        announcement:
          'Em <span>{time}</span>, resgatei com sucesso <span>{prize}</span>',
        firstAward: 'Você ganhou <span>{prize}</span> na loteria',
        secondAward:
          'Parabéns! Você ganhou <span>{prize}</span> no sorteio! Mas para receber o prêmio, você precisa completar uma tarefa.',
        finishTask: 'Missão cumprida',
        getAward: 'Resgatado com sucesso <span>{prize}</span>',
        tips: 'Você precisa ter um total de {x} prêmios para poder resgatar. No momento, você já tem <span>{y}</span> prêmios.',
        cardTitle:
          'Complete as seguintes tarefas para ganhar <span>{prize}</span>',
        detailTitle1: 'Como obter recompensas?',
        detailTitle2: 'Condições válidas para subordinados',
        detailTitle3: 'Meus subordinados',
        detailTitle4: 'Compartilhamento rápido',
        taskText1: 'Subordinados validados promovidos ≥ {x} pessoas',
        taskText2: 'Subordinados com apostas válidas ≥ {x} pessoas',
        taskText3: 'Subordinados com depósito inicial ≥ {x}',
        taskText4: 'Número de depósitos do subordinado ≥ {x}',
        taskText5: 'Valor total do depósito do subordinado ≥ {x}',
        taskText6: 'Valor total de saques do subordinado ≥ {x}',
        taskText7: 'Número de saques do subordinado ≥ {x}',
        taskText8: 'Baixe e faça login no aplicativo',
        taskText9: 'Minha única recarga ≥{x}',
        taskText10: 'Minha aposta simples ≥{x}',
        taskText11: 'Minha recarga acumulada ≥{x}',
        taskText12: 'Minhas apostas acumuladas são ≥ {x}',
        text1:
          'Tenha pelo menos {x} promoções válidas de subordinados para receber o bônus restante de <span>{prize}</span>',
        text2:
          'Tenha pelo menos {x} subordinados com apostas válidas para receber o bônus restante de <span>{prize}</span>',
        text3:
          'Tenha pelo menos {x} subordinados com primeiro depósito para receber o bônus restante de <span>{prize}</span>',
        text4:
          'Tenha pelo menos {x} depósitos de subordinados para receber o bônus restante de <span>{prize}</span>',
        text5:
          'Tenha um valor total de depósitos de subordinados de pelo menos {x} para receber o bônus restante de <span>{prize}</span>',
        text6:
          'Tenha um valor total de saques de subordinados de pelo menos {x} para receber o bônus restante de <span>{prize}</span>',
        text7:
          'Tenha pelo menos {x} saques de subordinados para receber o bônus restante de <span>{prize}</span>',
        text8:
          'Aposta de nível inferior ≥ {x}, você pode obter o bônus restante <span>{prize}</span>',
        processText: 'Você possui {x} subordinados válidos, restando {y}',
        detailText1:
          'O login bem -sucedido dos subordinados, significa que é eficaz',
        detailText2: 'Os subordinados têm apostas, o que significa válido',
        detailText3:
          'A conclusão do primeiro carregamento dos subordinados indica que é eficaz',
        detailText4: 'Faça login com sucesso durante o ciclo',
        withdrawals: 'Número de saques',
        withdrawValue: 'Valor do Saque',
        rechargeValue: 'Depósito',
        rechargeCount: 'Recarrega',
        awardText: 'Parabéns! Você ganhou um bônus de <span>{x}</span>',
        awardText1: 'Bônus <span>{x}</span>',
        myLink: 'Meu Link',
        change: 'Alterar',
        progressTextInvitedNumber:
          'Convidar efetivamente as pessoas {x}, mas também pobres {n} pessoas',
        progressTextDaMaNumber:
          'Linha descendente eficaz {x} pessoas, ainda faltam {n} pessoas',
        progressTextFirstRechargeNumber:
          'Os subordinados eficazes têm {x} primeiros depósitos, e ainda restam {n} pessoas',
        progressTextRechargeCount:
          'Número de recarga de nível inferior eficaz {x} vezes, ainda ruim {n} vezes',
        progressTextTotalRechargeValue:
          'Recarga acumulada de nível inferior eficaz {x} e pobre {n}',
        progressTextTotalWithdrawValue:
          'Subordinados eficazes Retirada cumulativa {x}, ainda pobre {n}',
        progressTextWithdrawCount:
          'Retirada subordinada eficaz {x} vezes, ainda é ruim {n} tempos',
        progressTextTotalDaMaValue:
          'Os subordinados efetivos acumularam {x} apostas e ainda restam {n}.',
        detailInfoText1: 'Apostando durante o ciclo',
        detailInfoText2: 'Complete a primeira recarga dentro do ciclo',
        detailInfoText3: 'Recarga cumulativa {n} vezes durante o ciclo',
        detailInfoText4: 'Recarga cumulativa durante o ciclo {x}',
        detailInfoText5: 'Retirada cumulativa durante o ciclo {x}',
        detailInfoText6: 'Retirada cumulativa durante o ciclo {n} Times',
        detailInfoText7: 'Apostas acumuladas durante o período {n}',
        secondConditionInvitedNumber:
          'O progresso ao convidar amigos é de 100,00% e você pode receber o <span>{prize}</span> restante',
        completedValue: '{x}% concluído',
        cardInvitedNumber: 'Promoveu efetivamente {x} pessoas abaixo'
      },
      newCutOnce: {
        firstAward: '{0}º sorteio, obteve {1}',
        firstAward1: 'O {0}º sorteado não ganhou. Tente novamente!',
        secondAward:
          'Adicionadas {0} pessoas como promotores eficazes e o número de sorteios +1',
        finishTask: 'Parabéns, você ganhou {0} no total.',
        getAward: 'Bônus reivindicado com sucesso {0}',
        lotterytip: 'Número de sorteios restantes: 0',
        demoModeTip: 'A conta streamer não tem permissão.',
        notStartProgress:
          'Você só pode reivindicá-lo se os ganhos cumulativos forem ≥{totalAward}',
        nextTaskRechargeCountTip: 'Recarga subordinada ≥ {0}',
        nextTaskRechargeCountTip1:
          'Promover subordinados para efetuar login com sucesso é considerado válido.',
        progressingpProgress:
          'Acumule ≥{totalAward} para receber o prémio, faltam {undoneAmount}',
        cardTipsTitle:
          'Promova {0} subordinados para obter {1} oportunidades de sorteio',
        awardText1: 'Ganhou {0} (máximo {1})',
        awardText2: 'Ganhou {0}',
        tip1: 'Você sorteou prêmios e o prêmio cumulativo atual é {0}',
        gotoRecord: 'Verificar registros',
        cardTipsSubText:
          'Exigir que os subordinados recarreguem ≥{amount}, atualmente válido para {people}',
        cardTipsSubText1:
          'O login bem-sucedido dos subordinados promovidos é considerado válido e as {people} atuais são válidas',
        shareText: 'Partilhar'
      }
    },
    records: {
      totalReceive: 'Valor total resgatável',
      rewardAmount: 'Recompensa',
      reward: 'Bônus',
      activeId: 'ID da promoção',
      rewardName: 'Nome da recompensa',
      rewardTime: 'Horário de recompensa',
      amount: 'Valor',
      activity: 'Nível ativo',
      remark: 'Explicação da recompensa',
      activeTypeName: 'fonte',
      receiveRecords: 'Registros de Aplicação',
      checkStatus: 'Estado',
      underReview: 'Em auditoria',
      passed: 'Aprovado',
      rejected: 'Rejeitado',
      arriveAccount: 'Processando',
      progress: 'Processando; será creditado à conta mais tarde',
      cancelled: 'Cancelado',
      operate: 'Operar',
      detail: 'Detalhes',
      info: 'Informações do pedido',
      rewardAmount2: 'Valor Da Recompensa',
      administratorReply: 'Resposta do administrador',
      noReply: 'Temporariamente sem resposta',
      arrivalTime: 'Horário de chegada',
      platformRewardDetail:
        'Aposta válida acumulada: {betCode}, Taxa de recompensa: {rate}%, Recompensa: {gold}'
    },
    cpf: {
      CPFTitle: 'Contribuir para o Fundo de Previdência',
      accumulHistory: 'Total de registros',
      betHistory: 'Requisitos de apostas',
      rulesDesc: 'Regras',
      totalRechargeAmount: 'Total de depósitos',
      recharge: 'Depósito',
      give: 'Bônus',
      maxLimitFundAmount: 'Bônus Máximo',
      maxLimitAddTimes: 'Limite Máximo',
      noCap: 'Não ser tapado',
      cpfName: 'Fundo de\nPrevidência',
      withdraw: 'Saque',
      hasWithdraw: 'Já foi retirado',
      hasSend: 'Distribuído',
      hasCancel: 'Cancelado',
      currentCPF: 'Saldo Atual do Fundo de Provisão',
      firtRechargeCPF:
        'A cada depósito, receba um bônus de Fundo de Provisão de',
      maxLimitText1: 'Bônus limitado a{num1} vezes, com valor máximo de{num2}',
      maxLimitText2:
        'O número de presentes é limitado a {num} vezes e o valor máximo não é limitado.',
      maxLimitText3:
        'Não há limite para o número de presentes e o valor máximo é {num}',
      maxLimitText4:
        'Não há limite para o número de vezes que um presente pode ser dado e não há limite para o valor.',
      needRecharge: 'Você precisa apostar',
      finishRecharge: 'Requisitos de aposta concluídos',
      rechargeCount: 'Vezes',
      maxAmount: 'Valor do limite　',
      enableWithdraw: 'sacar dinheiro',
      details: 'Detalhes',
      time: 'Horário',
      rechargeAmount: 'Depósito',
      addFundRate: 'Proporção de bônus',
      addFundAmount: 'Valor do bônus',
      totalAmount: 'acumulação total',
      addBetCodeRate: 'Número de apostas',
      addBetCodeAmount: 'Novos requerimentos\npara aposta',
      afterReset: 'Resetar após {x}'
    },
    promote: {
      title: 'Agente',
      unitPeople: '',
      empty: 'Membro direto',
      myPromote: 'Link de Convite',
      myData: 'Meus Dados',
      promoteShare: 'Link de Convite',
      myCommission: 'Comissão',
      myPerformance: 'Desempenho',
      returnCommissionProportion: 'Taxa de Comissão',
      tutorial: 'Rede do Agente',
      videoTutorial: 'Tutorial em vídeo',
      directAccountOpening: 'Cadastrar Subordinados',
      agencyTransfer: 'Transferir',
      conversionRecord: 'Registros',
      pickUpRecord: 'Histórico',
      online: 'Online',
      offline: 'Offline',
      yes: 'Sim',
      times: 'Vezes',
      no: 'Não',
      date: 'Data',
      startTime: 'Data de Início',
      endTime: 'Data de Fim',
      cancel: 'Cancelar',
      confirm: 'Confimar',
      memberID: 'ID de Membro',
      searchMemberID: 'ID de Membro',
      memberAccount: 'Conta de membro',
      searchMemberAccount: 'Conta de membro',
      memberDetail: 'Detalhes subordinados',
      subordinate: 'Subordinados de {id}',
      userStatusType: {
        normal: 'Normal',
        freezeManually: 'Congelado manualmente',
        abnormalFreezing: 'Congelamento anormal',
        prohibitionOfReceivingDiscounts: 'Proibido receber benefícios',
        blacklist: 'Lista negra',
        disabled: 'Desativado',
        withdrawalProhibited: 'Saque proibido',
        forbiddenToEnterTheGame: 'Proibido participar no jogo',
        returnThePrincipal: 'Sem incentivo para reembolsar o principal'
      },
      myDataPage: {
        coreData: 'Dados principais',
        dataPreview: 'Visão Geral dos Dados',
        newDirectMembers: 'Adicionar membros diretos',
        firstChargeUsers: 'Primeiros Depósitos',
        rechargeUsers: 'Depósitos',
        rechargeAmount: 'Depósito',
        performance: 'Desempenho',
        commission: 'Comissão',
        myTeam: 'Meu Time',
        totalUsers: 'Membros',
        directUsers: 'Membros Diretos',
        otherUsers: 'Outros Membros',
        totalPerformance: 'Desempenho Total',
        directPerformance: 'D. Direto',
        otherPerformance: 'D. dos Outros',
        totalCommission: 'Comissões Totais',
        directCommission: 'Comissão Direta',
        otherCommission: 'Outra Comissão'
      },
      directBetting: {
        memberID: 'ID de Membro',
        searchMemberID: 'Introduza o ID de Membro',
        orders: 'N.º  de apostas',
        validBet: 'Apostas Válidas',
        profit: 'Total de V/D',
        statisticalDate: 'Datas estatísticas',
        details: 'Detalhes',
        directBettingDetail: 'Detalhes da aposta',
        betTime: 'Hora da aposta',
        platform: 'Plataforma de jogo',
        category: 'Tipo de jogo',
        name: 'Nome do jogo',
        memberProfit: 'V/D dos membros',
        validOrderAmount: 'Apostas Válidas',
        profitAmount: 'Valor da V/D',
        totoalValidOrder: 'Total de apostas',
        directValidBet: 'Aposta válida direta',
        directProfit: 'V/D diretas',
        otherValidBet: 'Outras apostas eficazes',
        otherProfit: 'Outras V/D',
        totoalValidOrderAmount: 'Total de apostas válidas',
        totoalProfit: 'Total de V/D'
      },
      directData: {
        memberID: 'ID de Membro',
        searchMemberID: 'Introduza o ID de Membro',
        registrTime: 'Hora de registro',
        registrDate: 'Data de Cadastro',
        loginDate: 'Data de login',
        lastLogin: 'Último login',
        account: 'Conta',
        firstDeposit: 'Depósito Inicial',
        isFirstDeposit: 'Efetuar depósito inicial?',
        status: 'Estado',
        times: 'Contagem de logins',
        now: 'Atual',
        subordinate: 'Subordinados Dele',
        totalRegisterPerson: 'Número de inscritos',
        totalDepositPerson: 'Depósitos',
        totalFirstDepositPerson: 'Primeiros Depósitos',
        totalDepositAmount: 'Depósito',
        totalValidBet: 'Apostas Válidas'
      },
      common: {
        all: 'Todos os tipos',
        chess: 'Cartas',
        fish: 'Pescaria',
        street: 'Arcada',
        sports: 'Esporte',
        real: 'Ao Vivo',
        gameing: 'Slots',
        lottery: 'Loteria',
        other: 'Outros',
        cockfighting: 'Brigas Galos',
        game: 'Jogos',
        blockchain: 'Blockchain',
        gaming: 'Esports'
      },
      commission: {
        parentAgentID: 'ID superior',
        memberID: 'ID de Membro',
        searchMemberID: 'Introduza o ID de Membro',
        addTime: 'Recompensa {reward}',
        settleTime: 'Liquidado às',
        settleDay: 'Data Liquidação',
        type: 'Tipos',
        performance: 'Desempenho',
        lowerLevelPeople: 'Subordinados',
        count: 'Comissão',
        details: 'Detalhes',
        contributionCommission: 'Contribuição da Comissão',
        account: 'Conta',
        commissionReceived: 'Comissão resgatada',
        searchAccount: 'Conta',
        commissionDetail: 'Detalhes da Comissão',
        contributebetUsername: 'Conta de contribuição',
        contributePerformance: 'Desempenho',
        totalPerformance: 'Desempenho Total',
        totalCount: 'Comissões Totais',
        directly: 'Diretos',
        lowerLevel: 'Subordinados',
        parentAgent: 'Superior',
        deposit: 'Depósito Total',
        netProfix: 'Lucro líquido',
        unReached: 'Ainda não está qualificado',
        directPerformance: 'D. Direto',
        directCommission: 'Comissão Direta',
        otherAchievements: 'D. dos Outros',
        otherCommissions: 'Outra Comissão',
        validmembers: 'Colaboradores',
        memberProfitLoss: 'Lucro e perda de membro',
        discount: 'Resgatar desconto'
      },
      promote: {
        searchMemberID: 'Introduza o ID de Membro',
        account: 'Conta',
        agentMode: 'Modo de Agente',
        infinite: 'Diferença de nível ilimitada',
        firstLevel: 'Agente de nível 1',
        netProfit: 'Lucro de agente de nível 1',
        threeNetProfit: 'Lucro de agente de nível 3',
        national: 'Agente nacional',
        settleDurationDay: 'Liquidação diária',
        settleDurationWeek: 'Liquidação semanal',
        settleDurationMonth: 'Liquidação mensal',
        memberId: 'ID do membro',
        mySuperior: 'ID do Superior',
        myParent: 'Conta Superior',
        directNum: 'Subordinados diretos',
        inviteCode: 'Código de Convite',
        available: 'Coletável',
        getCommission: 'Coletar Comissão',
        commission: 'Comissão',
        teamData: 'Todos os Dados',
        directBetting: 'Apostas dos Subordinados',
        directData: 'Dados do Subordinado',
        directFinance: 'Finanças dos Subordinados',
        directReceive: 'Resgates dos subordinados',
        totalDeposit: 'Depósito Total',
        totalDepositCount: 'Total de recargas iniciais',
        totalDepositDirect: 'Recarga Direta',
        totalDepositOthers: 'Outro Depósito',
        totalValidBet: 'Total de apostas válidas',
        totalNetProfit: 'Total de V/D',
        betTimes: 'Total de apostas',
        firstDeposit: 'Primeiros Depósitos',
        firstDepositDirect: 'Primeiro depósito direto',
        firstDepositOthers: 'Outros depósitos iniciais',
        more: 'Mais',
        totalCommission: 'Comissão total',
        availableCommission: 'Comissão Coletada',
        shareSite: 'Informações da indicação',
        totalNumberOfTeams: 'Total',
        directMember: 'Subordinados diretos',
        totalNetProfix: 'Lucro líquido total',
        directNetProfix: 'Lucro líquido direto',
        otherNetProfix: 'Outros lucros líquidos',
        directValidNum: 'Subordinados diretos válidos',
        otherValidNum: 'Outros subordinados válidos',
        otherMembers: 'Outros',
        totalPerformance: 'Desempenho Total',
        directPerformance: 'D. Direto',
        directCommission: 'Comissão Direta',
        otherPerformance: 'D. dos Outros',
        otherCommission: 'Outra Comissão',
        lastCommission: 'Última Comissão',
        validMember: 'Válidos',
        performance: 'Desempenho',
        clickSave: 'Clique para Salvar',
        myLink: 'Meu Link',
        myLinkChange: 'Alterar',
        copy: 'Copiar',
        proxyLevel: 'Nível do Agente',
        receiveSussessTip: 'Comissão recebida com sucesso',
        noCommonssionTip:
          'Você ainda não é elegível para comissão. Continue convidando seus amigos!',
        proxyLevelTable: {
          proxyLevel: 'Nível do Agente',
          promotionConditions: 'Condições da promoção (resultados acumulados)'
        },
        publicityIntruduction:
          'O primeiro jogo de cartas de alta definição 2.000 do mundo\n Ler código para download',
        downloadSuccessTips:
          'Caro jogador, as imagens foram salvas com sucesso!',
        downloadImageName: 'Partilhar',
        shareText: 'Link promocional de {Account}',
        notSupportShare: 'O navegador não suporta a função de compartilhamento'
      },
      directFinance: {
        memberID: 'ID de Membro',
        searchMemberID: 'Introduza o ID de Membro',
        deposit: 'Depósito',
        withdrawal: 'Saque',
        difference: 'Diferença',
        balance: 'Saldo',
        totalDeposit: 'Depósito Total',
        totalWithdrawal: 'Total de Saques',
        totalNetDiff: 'Diferença total entre depósito e saque',
        depositCount: 'Depósitos',
        firstDepositPerson: 'Primeiros Depósitos',
        withdrawPerson: 'Número de Saques',
        regCount: 'Número de inscritos',
        timesCount: 'Vezes',
        statisticalDate: 'Datas estatísticas',
        rechargeAmount: 'Depósito',
        withdrawalAmount: 'Valor do Saque',
        netDiff: 'Diferença entre depósito e saque',
        currentBalance: 'Saldo atual'
      },
      directReceive: {
        searchMemberID: 'Introduza o ID de Membro',
        statisticalDate: 'Datas estatísticas',
        totalClaimed: 'Total Recebido',
        activityClaimed: 'Evento Recebido',
        taskClaimed: 'Missão Recebida',
        cashbackClaimed: 'Cashback Recebido',
        vipClaimed: 'VIP Recebido',
        agentCommission: 'Comissão do Agente',
        balanceTreasureInterest: 'Juros da Poupança'
      },
      pickUpRecordRoot: {
        pickUpTime: 'Hora da coleta',
        contributors: 'Contribuidores',
        amount: 'Valor',
        commissionReceived: 'Comissão coletada'
      },
      transferRecord: {
        transferTime: 'Hora da transferência',
        transferInAccount: 'Conta de coleta',
        transferAmount: 'Transferir',
        remark: 'Observação',
        totalTransferAmount: 'Transferência acumulada'
      },
      proportion: {
        level: 'Nível',
        validBet: 'Apostas Válidas',
        rebateAmount: 'Comissão',
        validNum: 'Válidos',
        netProfix: 'Lucro líquido',
        profitRate: 'Taxa de\nComissão',
        unitSuffix: '(Unid: 10,000)',
        perRebateAmount: 'Valor do desconto por 10,000',
        perProfitRate: 'Comissão por 10,000',
        footer:
          'Condições válidas: O valor da recarga do nível inferior é <em> ≥ {0}</em> e a aposta é válida <em> ≥ {1}</em>'
      },
      createAccount: {
        username:
          'Por favor, insira {range} caracteres, incluindo letras/números/símbolos',
        usernameValid: 'Erro na conta, introduza novamente',
        passwordLabel: 'Senha de Login',
        repeatPasswordLabel: 'Confirme a senha',
        password:
          'Por favor, insira {range} caracteres, incluindo pelo menos dois tipos: letras/números/símbolos',
        repeatPassword: 'Introduza novamente a senha de login',
        passwordValid: 'Senha errada, introduza novamente',
        passwordRepeat: 'Senha incorreta, digite novamente',
        verifyCodeLabel: 'Código',
        verifyCode: 'Insira o código de verificação',
        verifyCodeValid: 'Código de verificação errado. Introduza-o novamente',
        submit: 'Envie o Cadastro',
        model: {
          title: 'Registro Bem-sucedido',
          account: 'Conta',
          password: 'Senha',
          userAccount: 'Nome de Usuário',
          userPassword: 'Senha de Login',
          importTips:
            'Por favor, guarde essa informação com segurança. Você não poderá recuperá-la após sair desta página.',
          button: 'Copiar e fechar'
        }
      },
      agentTransfer: {
        usernamePlaceholder: 'Inserir nome de usuário',
        password: 'Senha',
        passwordPlaceholder: 'Introduza a senha',
        transferAmount: 'Valor da Transferência',
        transferAmountPlaceholder: 'Insira o valor da transferência',
        availableBalance: 'Saldo',
        remark: 'Observação',
        remarkPlaceholder: 'Insira um comentário com até {length} caracteres',
        button: 'Enviar transação',
        selectPlaceholder: 'Selecionar',
        settingPwdTitle: 'Defina sua senha de saque',
        settingPwdContent: 'Defina primeiro a senha para saque',
        transferSuccess: 'Transferido com sucesso!'
      },
      tutorialContent: {
        national: {
          bigAgent: {
            '0': 'Comissões Totais <em>{0}</em>',
            '1': 'Desempenho direto {0}, Comissão Direta <em>{1}</em>',
            '2': 'Outras comissões <em>{0}</em>'
          },
          direct: {
            validBet: 'Apostas válidas {0}',
            b1Text: 'B1 contribui comissão <em>{0}</em>',
            b2Text: 'B2 contribui comissão <em>{0}</em>',
            b3Text: 'B3 contribui comissão <em>{0}</em>'
          },
          other: {
            validBet: 'Apostas válidas {0}',
            c1_1Text: 'C1 contribui {0} para A de outros {1}%',
            c1_2Text: 'C1 Contribui Comissão <em>{0}</em>',
            c2_1Text: 'C2 Contribui Comissão <em>{0}</em>',
            c2_2Text: 'C2 Contribui {0} para A de outros {1}%',
            c3_1Text: 'C3 Contribui Comissão <em>{0}</em>',
            c3_2Text: 'C3 contribui {0} para A de outros {1}%'
          },
          tutorialDetail: {
            content:
              '<h1 id="example"><strong>Exemplo:</strong></h1><p>Supondo que a taxa de comissão atual para apostas válidas seja de 1% (direta) e a taxa de comissão do subordinado para o seu subordinado seja de 30% (outras). A foi a primeira pessoa que descobriu a oportunidade e imediatamente recrutou B1, B2 e B3; B1 recrutou posteriormente C1 e C2; B2 não tinha subordinados; B3 recrutou posteriormente C3. No segundo dia, as apostas válidas de B1 são 500, as apostas válidas de B2 são 3.000, as apostas válidas de B3 são 2.000, as apostas válidas de C1 são 1.000, as apostas válidas de C2 são 2.000 e as apostas válidas de C3 são 20.000.</p><span>O cálculo do lucro entre eles é o seguinte:</span><ul><li><strong>1. Comissão de B1</strong> (contribuições diretas de C1 e C2) = (1000+2000) * 1% = <em>30</em></li>\n<li><strong>2. Comissão de B2</strong> (sem subordinados) = (0+0) * 1% = <em>0</em></li>\n<li><strong>3. Comissão de B3</strong> (contribuição direta de C3) = 20000 * 1% = <em>200</em></li>\n<li><strong>4. Comissão de A</strong> (contribuições de subordinados diretos B1, B2 e B3, e outros subordinados C1, C2 e C3) são as seguintes:\n<ul><li><strong>(1) Comissão Direta de A</strong> (contribuições diretas de B1, B2 e B3) = (500+3000+2000) * 1% = <em>55</em></li>\n<li><strong>(2) Outra Comissão de A</strong> (outras contribuições de C1, C2 e C3) = (1.000+2.000+20.000)*1%*30% = <em>69</em></li>\n<li><strong>(3) Comissão Total de A</strong> (direta + outras) = 55+69 = <em>124</em></li> </ul> </li> <li><strong>5. Resumo:</strong> <ul> <li><strong>(1) Explicação de A:</strong> A é o primeiro a descobrir a oportunidade, então ele sempre pode extrair 30% dos subordinados dos outros, por exemplo: C1 pode contribuir 1% * 30% para A, D1 pode contribuir 1% * 30% 30%, E1 pode contribuir 1% * 30% * 30% * 30%, subordinados infinitos e assim por diante.</li> <li><strong>(2) Explicação de B:</strong> Embora B não seja o primeiro a descobrir a oportunidade, B ainda pode sempre extrair 30% do subordinado do subordinado, por exemplo: D1 pode contribuir 1% * 30% para B, E1 pode contribuir 1% 30% 30%, F1 pode contribuir 1% * 30% * 30% * 30%, subordinados infinitos e assim por diante.</li> <li><strong>(3) Explicação de C:</strong> Embora C seja descoberto posteriormente, C também pode sempre extrair 30% do subordinado do subordinado, por exemplo: E1 pode contribuir 1% 30% para C, F1 pode contribuir 1% * 30% *30%, G1 pode contribuir 1% * 30% * 30% * 30%, subordinados infinitos e assim por diante.</li> <li><strong>(4) Resumo da Regra:</strong> Seja A, B ou C, independentemente do nível, desde que trabalhem incansavelmente para recrutar subordinados infinitamente, eles sempre poderão extrair 30% do subordinado do subordinado. Os lucros obtidos são igualmente justos e não há fenômeno de desvantagem para quem descobre a oportunidade posteriormente.</li> </ul>'
          }
        },
        infinite: {
          bigAgent: {
            '0': 'Desempenho total {0}',
            '1': 'Comissões Totais <em>{0}</em>',
            '2': 'D. Direto {0}',
            '3': 'Retorno de Comissão {0}% Comissão Direta <em>{1}</em>',
            '4': 'D. dos Outros {0}',
            '5': 'Comissão escalonada {0}% outra comissão <em>{1}</em>'
          },
          direct: {
            validBet: 'Apostas válidas {0}',
            b1Text: 'B1 contribui comissão <em>{0}</em>',
            b2Text: 'B2 contribui comissão <em>{0}</em>',
            b3Text: 'B3 contribui comissão <em>{0}</em>'
          },
          other: {
            validBet: 'Apostas válidas {0}',
            c1_1Text:
              'C1 Contribui para A <em>{0}</em><br> De diferenciais {1}%',
            c1_2Text: 'C1 Contribui Comissão <em>{0}</em>',
            c2_1Text: 'C2 Contribui Comissão <em>{0}</em>',
            c2_2Text: 'C2 contribui para A <em>{0}</em><br> Do nível {1}%',
            c3_1Text: 'C3 Contribui Comissão <em>{0}</em>',
            c3_2Text:
              'C3 Contribui para A <em>{0}</em><br> Sem diferença de nível'
          },
          tutorialDetail: {
            content:
              '<h1><strong>Um exemplo é o seguinte:</strong></h1><p>Suponha que as apostas efetivas atuais de 0 a 10.000 receberão uma comissão de 100 (ou seja, 1%) para cada 10.000, e o apostas efetivas acima de 10.000 receberão uma comissão de 300 para cada 10.000. (ou seja, 3%), A foi o primeiro a descobrir oportunidades de negócios neste site e imediatamente desenvolveu B1, B2 e B3. B1 desenvolveu ainda mais C1 e C2. B2 desenvolveu sem subordinados, e a B3 desenvolveu o relativamente poderoso C3. No segundo dia, a aposta efetiva de B1 é 500, a aposta efetiva de B2 é 3.000, a aposta efetiva de B3 é 2.000, a aposta efetiva de C1 é 1.000, a aposta efetiva de C2 é 2.000 e a aposta efetiva de C3 é de até 20.000. </p><span>Então o método de cálculo da renda entre eles é o seguinte: </span><ul><li><strong>1. Comissão de B1</strong> (contribuições diretas de C1 e C2) = (1000 + 2000) * 1% = <em>30</em></li><li><strong>2. Comissão de B2</strong> (sem subordinados) = (0+0) * 1% = <em> 0</em></li><li><strong>3. Comissão B3</strong> (contribuição direta de C3) = 20.000 * 3% = <em>600</em></li><li> <strong>4. Além das contribuições dos subordinados diretos B1, B2 e B3, a comissão de A também advém das contribuições dos demais subordinados C1, C2 e C3, conforme segue: </strong><ul><li><strong>( 1 )Comissão direta de A</strong>(contribuições diretas de B1, B2 e B3) = (500+3000+2000) * 3% = <em>165</em></li><li><strong>( 2) Outras comissões de A</strong>(das contribuições C1, C2)=(1000+2000) * 2%= <em>60</em></li><li><strong>(3)Comissão total de A </strong>(direto + outro) = 165+60 = <em>225</em></li></ul></li><li><strong>5. Resumo: </strong> <ul ><li><strong>(1) Equipe direta</strong>: refere-se aos subordinados desenvolvidos diretamente por A, ou seja, o primeiro nível de relacionamento com A, denominados coletivamente como equipe direta. </li><li><strong>(2) Outras equipes</strong>: Refere-se àquelas que são desenvolvidas por subordinados de A. Possuem relacionamento de segundo nível com A ou superior, ou seja, subordinados de subordinados , e os subordinados dos subordinados.. etc., coletivamente referidos como outras equipes; como esse modelo de agência pode desenvolver subordinados ilimitados, para conveniência da explicação, este artigo toma apenas a estrutura de 2 níveis como exemplo. </li><li><strong>(3) Descrição de A</strong>: O desempenho direto de A é 5.500 e o outro desempenho é 20.000 (devido ao poder de C3). O desempenho total é 28.500 e a comissão correspondente a taxa é de 3%. Como B1 tem um desempenho total de 3.000 e desfruta de um desconto de apenas 1%, enquanto A tem um desempenho total de 28.500 e desfruta de uma taxa de desconto de 3%, então haverá uma diferença de desconto entre A e B1. A diferença é: 3% -1% =2%, essa diferença é a parte contribuída por C1 e C2 para A, então C1 e C2 contribuem para A: (1000+2000)* 2%=60, não há diferença extrema entre A e B3, então C3 contribui para A A comissão de contribuição é 0. </li><li><strong>(4) Descrição de B1</strong>: B1 tem subordinados C1 e C2. Como o desempenho direto é 3.000, o índice de desconto correspondente é de 1%. </li><li><strong>(5) Explicação B2 </strong>: B2 pode ser preguiçoso e não se beneficiará se não desenvolver seus subordinados. </li><li><strong>(6) Explicação B3</strong>: Embora B3 tenha aderido relativamente tarde e seja subordinado de A, seu subordinado C3 é muito poderoso e tem um desempenho direto de 20.000, permitindo que B3 diretamente desfrutar de comissões mais elevadas.A proporção é de 3%. </li><li><strong>(7) Resumo das regras</strong>: Não importa quando você ingressa, de quem você é subordinado, não importa em que nível você está, sua renda nunca será afetada e você não sofre mais as perdas dos subordinados dos outros., o desenvolvimento não é restrito. Este é um modelo de agência absolutamente justo e imparcial, e ninguém estará sempre por baixo só porque entrou tarde. </li></ul></li></ul>'
          }
        },
        netProfit: {
          bigAgent: {
            '0': 'Comissões Totais <em>{0}</em>',
            '1': 'Desempenho direto {0} Comissão direta <em> {1} </em>'
          },
          direct: { validBet: 'Lucro líquido {0}' },
          a: {},
          b1: {},
          b2: {},
          b3: {},
          tutorialDetail: {
            content:
              '<h1><strong>Exemplo:</strong></h1>\n<p>Assumindo que a proporção de comissão de retorno para lucro líquido atual seja de 1% (ou seja, direto), A é o primeiro a descobrir a oportunidade e imediatamente desenvolveu B1, B2 e B3. No segundo dia, o lucro líquido de B1 é de 500, o lucro líquido de B2 é de 3000, o lucro líquido de B3 é de -2000.</p><span>O cálculo do lucro de A é o seguinte:</span><ul><li><strong>1. Comissão de A</strong> (contribuição direta de B1, B2 e B3) = (500+3000-2000) * 1% = <em>15</em></li><li><strong>2. Resumo</strong><ul><li><strong>(1) Lucro Líquido:</strong> Por exemplo, se o usuário contribuir com 2000 durante o período de liquidação (ou seja, lucro da plataforma de 2000), e receber um desconto de 100 da plataforma durante esse período, então o lucro líquido é de 1900; se o usuário contribuir com -2000 durante o período de liquidação (ou seja, perda de 2000 pela plataforma), e receber um desconto de 100 da plataforma durante esse período, então o lucro líquido é de -2100.</li><li><strong>(2) Explicação do Método de Cálculo:</strong> Este modelo é baseado em todos os membros como exemplo, se apenas membros que tiverem lucro forem considerados, então não haverá cálculo para os membros com lucro líquido negativo.</li><li><strong>(3) Explicação de A:</strong> Como o lucro líquido de B3 é negativo, o lucro líquido total de A é de 15000, ou seja, o total de desempenho de B1, B2 e B3 é de 1500, resultando em uma comissão de 15.</li></ul></li></ul>'
          }
        },
        firstLevel: {
          bigAgent: {
            '0': 'Desempenho total {0}',
            '1': 'Taxa de retorno {0}% Comissão total <em> {1} </em>'
          },
          tutorialDetail: {
            content:
              '<h1><strong>Exemplo:</strong></h1><p>Assumindo que a taxa de comissão atual para apostas válidas entre 0-10.000 seja de 100 para cada 10.000 apostas (1%), e para apostas acima de 10.000 seja de 300 para cada 10.000 apostas (3%), A é o primeiro a descobrir a oportunidade e imediatamente desenvolveu B1, B2 e B3. No segundo dia, as apostas válidas de B1 são 3000, as apostas válidas de B2 são 5000, e as apostas válidas de B3 são 6000.</p><span>O cálculo do lucro de A é o seguinte:</span>\r\n<ul><li><strong>1. Comissão de A</strong> (contribuição de B1, B2 e B3) = (3000+5000+6000)*3% = <em>420</em></li><li><strong>2. Resumo:</strong>\r\n<ul><li><strong>(1) Explicação de A:</strong> Como o total de apostas válidas dos subordinados diretos de A, B1, B2 e B3, é 14000, a taxa de comissão correspondente é de 3%, resultando em uma comissão de 420 para A.</li><li><strong>(2) Resumo da Regra:</strong> Quanto mais subordinados diretos você desenvolver, mais comissão você receberá.</li></ul></li>\r\n</ul>'
          }
        },
        threeNetProfit: {
          bigAgent: {
            '0': 'Desempenho total {0}',
            '1': 'D. Direto {0}',
            '2': 'Comissão Direta <em>{0}</em>',
            '3': 'D. dos Outros {0}',
            '4': 'Taxa de recompensa {0}% Outras comissões <em> {1} </em>'
          },
          other: {
            c1_1Text: 'C1 contribui {0} para A de outros {1}%',
            c1_2Text: 'C1 Contribui Comissão <em>{0}</em>',
            c2_1Text: 'C2 Contribui Comissão <em>{0}</em>',
            c2_2Text: 'C2 contribui {0} para A de outros {1}%',
            c3_1Text: 'C3 Contribui Comissão <em>{0}</em>',
            c3_2Text: 'C3 contribui {0} para A de outros {1}%',
            d1_1Text: 'Comissão de Contribuição D1 <em> {0} </em>',
            d2_2text: 'D1 contribui para B1 <em> {0} </em>'
          },
          level: {
            '0': 'Membros de Nível 1 <br/> (direto)',
            '1': 'Membros de Nível 2 <br/> (outros)',
            '2': 'Membros de Nível 3 <br/> (outros)'
          },
          tutorialDetail: {
            content:
              '<h1><strong>Exemplo:</strong></h1><p>Supondo que a proporção de comissão para o lucro líquido atual seja de 1% (direto), e para os subordinados dos subordinados seja de 30% (outros), A é o primeiro a descobrir a oportunidade e imediatamente desenvolveu B1, B2 e B3; B1 então desenvolveu C1 e C2; B2 não tem subordinados; B3 desenvolveu C3, e C1 desenvolveu D1. No segundo dia, o lucro líquido de B1 é de 500, o lucro líquido de B2 é de 3000, o lucro líquido de B3 é de -2000, o lucro líquido de C1 é de 1000, o lucro líquido de C2 é de 2000, o lucro líquido de C3 é de 20000, e o lucro líquido de D1 é de -3000.</p>\n<span>O cálculo do lucro entre eles é o seguinte: /span>\n<ul><li><strong>1. Comissão de C1</strong> (contribuição direta de D1) = 0 * 1% = 0</li>\n<li><strong>2. Comissão de B1</strong> além das contribuições diretas de C1 e C2, também inclui a contribuição de D1, como segue: <ul><li><strong>(1) Comissão direta de B1</strong> (contribuições diretas de C1 e C2) = (1000+2000) * 1% = <em>30</em></li><li><strong>(2) Outras comissões de B1</strong> (contribuição de D1) = 0 * 0.1% * 30% = <em>0</em></li><li><strong>(3) Comissão total de B1</strong> (direta + outras) = 30 + 0 = <em>30</em></li></ul></li><li><strong>3. Comissão de B2</strong> (sem subordinados) = (0+0) * 1% = <em>0</em></li><li><strong>4. Comissão de B3</strong> (contribuição direta de C3) = 20000 * 1% = <em>200</em></li><li><strong>5. Comissão de A</strong> além das contribuições diretas de B1, B2 e B3, também inclui as contribuições de outros subordinados C1, C2, C3 e D1, como segue:<ul><li><strong>(1) Comissão direta de A</strong> (contribuições diretas de B1, B2 e B3) = (500+3000-2000) * 1% = <em>15</em></li><li><strong>(2) Outras comissões de A</strong> (contribuições de C1, C2, C3 e D1) = (1000+2000+20000+0) * 1% * 30% = <em>69</em></li>    <li><strong>(3) Comissão total de A</strong> (direta + outras) = 15 + 69 = <em>84</em></li></ul> </li><li><strong>6. Resumo:</strong><ul><li><strong>(1) Lucro líquido:</strong> Por exemplo, se um usuário contribuir com 2000 durante o período de liquidação (ou seja, lucro da plataforma de 2000), e receber um desconto de 100 da plataforma durante esse período, então o lucro líquido é de 1900; se um usuário contribuir com -2000 durante o período de liquidação (ou seja, perda de 2000 pela plataforma), e receber um desconto de 100 da plataforma durante esse período, então o lucro líquido é de -2100.</li>    <li><strong>(2) Explicação do Método de Cálculo:</strong> Este modelo é baseado em todos os membros como exemplo, se apenas membros com prejuízo forem considerados, então membros com lucro líquido negativo não serão incluídos no cálculo.</li><li><strong>(3) Explicação de A:</strong> A é o primeiro a descobrir a oportunidade, então ele sempre pode extrair 30% da próxima camada de subordinados e assim por diante. Nas outras comissões, como o lucro líquido de D1 é negativo, então a contribuição de D1 para A é 0. As contribuições de C1, C2 e C3 totalizam 69. Na comissão direta, como o lucro líquido de B3 é negativo, então é necessário subtrair o lucro líquido negativo correspondente, ou seja, a comissão total direta contribuída é 15.</li><li><strong>(4) Explicação de B1:</strong> Embora D1 seja um subordinado de B1, como não gera comissão, B1 não tem outras comissões. Apenas C1 e C2 geram comissões diretas para B1, ou seja, 30.</li><li><strong>(5) Explicação de B2:</strong> Como B2 não tem subordinados, ele não tem comissões.</li><li><strong>(6) Explicação de B3:</strong> Como C3 não tem subordinados, B3 não tem outras comissões, apenas comissões diretas e são fortes, então apenas comissão direta de 200.</li><li><strong>(7) Explicação de C1:</strong> Embora D1 seja subordinado de C1, como o lucro líquido de D1 é negativo, ele não contribui com comissão para C1, ou seja, a comissão de C1 é 0.</li><li><strong>(8) Resumo da Regra:</strong> Não importa se é A, B, C, ou D, em que nível eles estão, desde que a plataforma tenha lucro, o lucro não será afetado. Os lucros obtidos são igualmente justos e não há desvantagem para aqueles que descobrem a oportunidade mais'
          }
        }
      }
    },
    reward: {
      base: {
        topVip: 'Parabéns! VIP de nível mais alto!',
        unReceive: 'Resgatar',
        noReceive: 'Não recolhido',
        notReceive: 'Não Alcançado',
        allReceive: 'Resgatar Tudo',
        distance: 'Restantes',
        needBet: 'Você precisa apostar',
        other: 'Outro',
        expired: 'Expirará em {0} dias',
        expiredTime: '{x} anulado',
        resetTime: 'Resetar após {x}',
        expiredHour: 'Expira em {0}h',
        available: 'Pode ser reivindicado após {0} dia(s)',
        availableHouur: 'Pode ser reivindicado após {0} hora(s)',
        canReceive: 'Resgatar',
        hasReceive: 'Resgatado',
        awardAmount: 'Bônus',
        otherAward: 'Outras recompensas',
        hasExpired: 'Tempo Esgotado',
        hasSend: 'Distribuído',
        toBeCollected: 'Pendente',
        CPF: '',
        current: 'Nível Atual',
        rewardProgress: 'Progresso do resgate',
        receiving: 'Resgatando',
        rewardSuccess: 'Parabéns por obter as seguintes recompensas!',
        gotoHome: 'Voltar à página inicial',
        activity: 'Nível ativo',
        award: 'Bônus',
        tip1: 'Total de {X} itens, <span>{y} itens resgatados com sucesso</span>',
        tip2: 'Recebeu: bônus {0}',
        tip3: 'Nível ativo {0}',
        tip4: 'Falhou <span>{x}</span> vezes',
        templateTitle: 'Fonte de recompensa',
        isTopVip: 'Parabéns! VIP de nível mais alto!',
        receivedErrorAll: '',
        receivedError: '',
        availableCollection: 'Disponível para resgate após {x}',
        claimedBonus: 'Recebeu: <span> bônus {x} </span>',
        activeLevel: 'Nível ativo {x}'
      },
      vip: {
        rewardMap: {
          vipPromote: 'Benefícios VIP {0}',
          power: 'Privilégio VIP',
          dailyWithdrawalLimit: 'Limite total diário de saque',
          numberWithdrawals: 'Limite diário de contagem de saques',
          freeTimes: 'Número de transições sem taxa por dia',
          promotion: 'Bônus De Aumento De Nível',
          day: 'Bônus Diário',
          week: 'Bônus Semanal',
          month: 'Bônus Mensal',
          relegation: 'Requisitos de requalificação',
          needBets: 'Ainda precisa apostar {0} para resgatar',
          vipProgressTips1: 'Restantes',
          vipProgressTips2: 'deposite mais <strong>{0}</strong>',
          vipProgressTips3: 'aposte mais <strong>{0}</strong>',
          vipProgressTips4:
            'Aposta válida de <strong>{0}</strong> ainda é necessária',
          needRecharge: 'Depósito para  promoção',
          needBet: 'Aposta para promoção',
          validNeedBet: 'Aposta para promoção',
          monthRelegation: 'Requisitos de requalificação',
          needLack: 'Falta <strong>{0}</strong> para ser promovido',
          retainLack: 'Precisa de <strong>{0}</strong> para não ser rebaixado',
          rewardTips0: 'Contagem regressiva para a coleta {x}',
          rewardTips5: 'Contagem regressiva para resgate',
          rewardTips1: '',
          rewardTips2: '',
          rewardTips3: '',
          rewardTips4: '',
          rewardTimeTips: 'Disponível para resgate após {x}'
        },
        table: {
          vipLevelMap: 'Lista de níveis VIP',
          level: 'Nível',
          validBet: 'Total de Apostas Válidas',
          vipGift: 'Bônus De Aumento De Nível',
          dayBonus: 'Bônus diário',
          weekBonus: 'Bônus Semanais',
          monthBonus: 'Bônus Mensais',
          depositChannel: 'Depósito acelerado',
          personalServer: 'Suporte Exclusivo',
          totalDeposit: 'Depósito Total',
          totalBet: 'Apostas',
          lastWeekDeposit: 'Depósitos da semana passada',
          lastWeekBet: 'Apostas semana passada',
          lastMonthDeposit: 'Depósitos do último mês',
          unmetTips: 'Diminui um nível se não for cumprido',
          lastMonthBet: 'Aposta do Mês Passado',
          dayDeposit: 'Depósito diário',
          dayBet: 'Apostas diárias',
          validDayBet: 'Apostas válidas diárias',
          dayBonusLimit: 'Bônus',
          weekDeposit: 'Depósito semanal',
          weekBet: 'Aposta semanal',
          validWeekBe: 'Apostas válidas semanais',
          weekBonusLimit: 'Bônus',
          monthDeposit: 'Depósito mensal',
          monthBet: 'Apostado nesse mês',
          validMonthBet: 'Apostas do mês',
          monthBonusLimit: 'Bônus',
          needRechargeTips:
            'Para ser promovido para o próximo nível, você precisa depositar um valor adicional com base no depósito acumulado. Por exemplo: para atualizar de VIP1 com um requisito de recarga de 1000 para VIP2 com um requisito de 2000, o membro precisa acumular 1000 + 2000 = 3000 para ser promovido para VIP2, e assim por diante.',
          needBetTips:
            'Para ser promovido para o próximo nível, você precisa apostar um valor adicional com base no requisito de apostas acumuladas. Por exemplo: para atualizar de VIP1 com um requisito de apostas de 1000 para VIP2 com um requisito de 2000, o membro precisa acumular 1000 + 2000 = 3000 para ser promovido para VIP2, e assim por diante.',
          validNeedBetTips:
            'Para avançar para o próximo nível, com base nas apostas válidas cumulativas existentes, são necessárias apostas adicionais. Por exemplo, para ser promovido para VIP 1, você precisa de 1.000 apostas válidas acumulativas, e para ser promovido para VIP 2, precisa de 2.000 apostas válidas acumulativas. Portanto, para atingir o VIP 2, um jogador precisa de um total de 3.000 apostas válidas acumulativas (1.000 + 2.000), e assim por diante. '
        },
        rules: 'Instruções sobre regras VIP',
        lack: 'Necessita de <strong>{0}</strong>'
      },
      award: {
        table: {
          time: 'Horário',
          name: 'Nomes',
          reward: 'Bônus',
          operate: 'Operar'
        }
      }
    },
    customersQuestionDetail: { title: 'Detalhes do problema' },
    service: {
      customerLiteral: '\nSuporte',
      commonQuestion: 'FAQ',
      hotQuestion: 'Perguntas Freqüentes',
      contact: 'Método de contato',
      copy: 'Copiar',
      copyAndOpen: 'Copiar e abrir',
      immediateContract: 'Entre em contato agora',
      search: 'Pesquisar',
      weChatLiteral: 'Atendimento ao cliente da WeChat',
      customer: 'Outros Suporte',
      questionRem:
        'Não encontrou uma solução? Entre em contato com o Atendimento ao Cliente',
      online: {
        title: 'Apoio online 24/7',
        describe:
          'Converse com o serviço profissional de apoio ao cliente online para resolver os seus problemas',
        consult: 'Consulta em tempo real'
      }
    },
    feedback: {
      demoModeNotReceived: 'Contas streamer não podem resgatar bônus',
      toBeCollected: 'Pendente',
      toBeCollectedAll: 'Resgatar Tudo',
      empty: 'Sem Mensagem',
      createFeedback: 'Criar feedback',
      mineFeedback: 'Meu Feedback',
      feedbackContent: 'Conteúdo do Feedback',
      feedbackReply: 'Resposta oficial',
      feedbackSubtitle: 'Faça sugestões para melhorias',
      feedbackContentMessage: 'O feedback não pode estar em branco',
      feedbackPlaceholder:
        'Suas opiniões são valiosas para nós. Qualquer sugestão valiosa será considerada, e uma vez adotada, o nível de importância determinará a recompensa em dinheiro. Sinta-se à vontade para fazer sugestões! ',
      feedbackUpload: 'As imagens não mentem',
      feedbackUploadSubtitle: 'Mais fácil de ser aceito',
      feedbackUploadPlaceholder:
        'O envio de imagens e vídeos é suportado (com até 50MB)',
      feedbackRuleTitle: 'Regras para recompensas',
      feedbackRule:
        'Estabelecemos bônus substanciais especificamente para coletar feedback, a fim de otimizar o sistema e recursos para proporcionar uma melhor experiência a você! Uma vez aceitas, as recompensas serão concedidas com base na utilidade (exceto aquelas não aceitas).',
      submit: 'Enviar feedback',
      feedbackTips: 'Agradecemos o seu valioso feedback',
      geetest: 'Clique para verificar',
      feedbackID: 'ID de feedback',
      replyContent: 'Resposta oficial',
      award: 'Bônus',
      pendding: 'Pendente',
      adopted: 'Adotado',
      ignored: 'Não adotado',
      deleted: 'Eliminado'
    },
    yuebao: {
      currentTransferIn: 'Saldo',
      currentProfix: 'Lucro Atual',
      yuebaoProfix: 'Renda do Juros',
      yearRate: 'Taxa de Juros Anual(%)',
      totalIncome: 'Renda Acumulada',
      allType: 'Todos os tipos',
      transferIn: 'Depósito',
      transferOut: 'Transferir',
      receive: 'Resgatar',
      profix: 'Renda',
      receiveProfix: 'Resgatar lucro',
      manualPull: 'Recuperação manual',
      profixRecord: 'Detalhes da Renda',
      changeRecord: 'Declaração dos Juros',
      rule: 'Regras de Juros',
      receiveSussessTip: 'Resgatado com sucesso!',
      hourProfixTips: '(Lucro a cada hora)',
      table: {
        time: 'Horário',
        type: 'Tipo',
        changeAmount: 'Ajuste',
        incomeAmount: 'Valor do lucro'
      },
      ruleContent: {
        desc: {
          '0': 'Regras de Juros',
          '1': '1. O valor depositado em Juros irá gerar ganhos após uma hora.',
          '2': '2. Os lucros são calculados e liquidados a cada hora, no início de cada hora.',
          '3': '3. Cada depósito deve ser de pelo menos {0}, e os saques estão limitados ao saldo de juros. Os ganhos devem primeiro ser resgatados na conta de juros antes do saque.',
          '4': '4. Os lucros resgatados podem ser sacados assim que atingirem {0} vezes o valor das apostas válidas.'
        },
        plan: {
          '0': 'Cálculo de Renda',
          '1': 'Rendimento por hora=Valor da Juros x Porcentagem Anual\nTaxa (APR)÷365 dias÷24 horas.',
          '2': 'Por exemplo:',
          '3': 'Com uma taxa anual de {gold1}%, se o Jogador A inicialmente tiver 0 no saldo de juros e depositar 10.000 às 12:30, os ganhos são calculados a partir das 14:00 a cada hora:',
          '4': '10000 × {gold2}% ÷ 365 dias ÷ 24h = <em>{gold3}</em>'
        }
      },
      modal: {
        all: 'Tudo',
        balance: 'Saldo da Conta',
        transferInAmount: 'Valor do Depósito',
        transferInAmountTips: 'Insira o valor da transferência',
        transferInPlaceholder: 'Mínimo de {amount} por depósito',
        transferOutAmount: 'Valor do Saque',
        transferOutAmountTips: 'Insira o valor da transferência',
        transferOutPlaceholder: 'Máximo {amount} por transação',
        receiveTime: 'Tempo estimado de chegada da receita {time}',
        withdrawPassword: 'Verificar Senha de Saque',
        confirmIn: 'Transferir de',
        confirmOut: 'Confirmar saque',
        transferSuccess: 'Depositado com Sucesso',
        transferOutSuccess: 'Saque Bem-sucedido',
        transferOutErrorTips: 'Introduza o valor correto'
      }
    },
    interest: {
      deposited: 'Depositado',
      yearRate: 'Taxa de Juros Anual {rate}%',
      billingCycle: 'Período de liquidação',
      minute: '{minute} minuto',
      hour: '{hour} horas',
      day: '{day} Dias',
      collectedTotal: 'Total resgatado',
      interestCap: 'Máximo de juros',
      cycle: '{number} ciclos',
      toCollected: 'Pendente',
      countdownReceive: 'Contagem Regressiva para Resgate',
      firstDepositReceive: 'Recompensa pelo primeiro depósito {amount}',
      rule: 'Regras de juros',
      recordDetails: 'Detalhes do registro',
      NotLimited: 'Ilimitado',
      transferInPlaceholder:
        'Valor mínimo de transferência única {amount}; apenas números inteiro',
      accountBalance: 'Saldo da Conta',
      transferTips:
        'Transferências não serão verificadas; somente os juros recebidos serão auditados',
      countdownSettlement: 'A contagem regressiva desta liquidação {time}s',
      transferOutTips: 'Você perderá os juros dessa rodada após sacar!',
      currentTime: 'Horário atual {time}',
      transferInTips:
        'Após esse depósito, os primeiros juros vão ocorrer as:{time}',
      receiveTips: '',
      currentInterest: 'Juros atual',
      transferOutPlaceholder: 'Valor máximo de saque {amount}',
      anchorAccountNoPermissions: 'A conta streamer não tem permissão.',
      notOpen: 'Os juros ainda não estão disponívels',
      ruleContent: {
        desc: {
          '0': '',
          '1': '',
          '2': '',
          '3': '',
          '4': '',
          '5': '',
          '6': '',
          '7': '',
          '8': ''
        },
        plan: {}
      }
    },
    receiveModal: {
      kindTips: 'Lembrete',
      eventContent:
        'Eventos diferentes têm requisitos de aposta diferentes. Por favor, leia atentamente as regras antes de resgatar. Confirmar o recebimento é equivalente a aceitar automaticamente todas as regras do evento. ',
      ok: 'Confirmar reivindicação',
      gotIt: 'Compreendi. Não mostrar mais avisos.'
    },
    browser: {
      openMethod1: 'Método um',
      openMethod1Step1: 'Clicar',
      openMethod1Step1End: 'Abra a barra de menus',
      openMethod1Step2: 'Selecionar',
      openMethod1Step2End: 'Abrir no navegador',
      or: 'ou',
      openMethod2: 'Método dois',
      openMethod2Step1: 'Copiar',
      openMethod2Step2: 'Cole no navegador para abrir'
    },
    theme16_dz: {
      playNow: 'Jogar agora',
      jackpotTitle: 'Jogue de graça, o prêmio está esperando por você',
      downloadTitle: 'Muito rápido, estável, tentáculos e alcance',
      downloadSubTitle:
        'Obtenha as informações mais recentes a qualquer hora, em qualquer lugar',
      downloadTips: 'Baixar software',
      featuredGames: 'Jogo único',
      asideList: {
        games: 'Jogos',
        promotions: 'Promoção',
        help: 'ajuda',
        functions: 'Função',
        member: 'membro'
      },
      freeGet: 'Liberta-te',
      selven$: 'R $ 7,00',
      entertainmentGalore: 'Festa de entretenimento',
      entertainmentFeast: 'Festa de entretenimento',
      entertainmentFeastTips:
        'Reunir a plataforma de videogame líder do mundo, milhares de jogos de caça -níqueis estão esperando que você jogue!',
      CategoriesGamePCTips: '',
      famousProvider: 'Fornecedor bem conhecido',
      categoriesGameTip_CHESS:
        'Reunindo os jogos de xadrez e cartas mais populares do mundo, 10.000 pessoas jogam on -line, Fiery PK!',
      categoriesGameTip_FISH:
        'O campo de pesca mais enorme da história convida você a ir a pescar juntos.',
      categoriesGameTip_ELECTRONIC:
        'Reúna as melhores plataformas de jogos eletrônicos do mundo, milhares de jogos de caça-níqueis esperando por você!',
      categoriesGameTip_REAL:
        'O revendedor mais bonito interage online, leva você para jogar bacará e outros jogos ao vivo',
      categoriesGameTip_SPORTS:
        'As maiores probabilidades do mundo, fornecendo múltiplos questionários na bola, tamanho, campo semi -cheio, ondas e duplas, objetivos totais, séries de níveis, etc.',
      categoriesGameTip_COCKFIGHTING: '',
      categoriesGameTip_GAMING:
        'Todas as grandes, médias e pequenas ligas de eSports do mundo, tudo em um só lugar!',
      categoriesGameTip_LOTTERY:
        'Focando na indústria de jogos de loteria por muitos anos, com espécies de cores e jogabilidade clássicas',
      categoriesGameTip_BLOCK_CHAIN:
        'A emocionante e inovadora experiência de entretenimento.'
    },
    theme26_dz: {
      more: 'Mais',
      home: {
        ty: 'Jogos de desporto',
        tydesc:
          'Aproveite os principais eventos populares e aproveite a tempestade no campo',
        hgty: 'Coroa Esportiva',
        dz: 'Jogos eletrónicos',
        dzdesc:
          'Reúna as melhores plataformas de jogos eletrônicos do mundo, milhares de jogos de caça-níqueis esperando por você!',
        pgdz: 'PG Slot',
        zr: 'Câmara em direto',
        zrdesc:
          'As mais belas dealers online interagem com você, te levando para jogar bacará e vários outros jogos ao vivo!',
        agzr: 'AG Live',
        qp: 'Jogos de cartas',
        qpdesc:
          'Reúna os jogos de tabuleiro e cartas mais populares do mundo, batalhe online com milhares de pessoas e tenha um PK emocionante!',
        wgqp: 'WG Cartas',
        by: 'Jogos de pesca',
        bydesc:
          'O maior campo de pesca da história convida você para se divertir! Peixes enormes enchem a tela e explodem com um único tiro!',
        wgby: 'WG Pesca',
        cp: 'Jogos de lotaria',
        cpdesc:
          'Dedicado à indústria de jogos de loteria há muitos anos, com variedades clássicas de loteria e métodos de jogo',
        sycp: 'Loteria Win-Win',
        dj: 'Esports',
        djdesc:
          'Todas as grandes, médias e pequenas ligas de eSports do mundo, tudo em um só lugar!',
        sbdj: 'Esportes Saba',
        qkl: 'Blockchain',
        qkldesc:
          'A blockchain usa tecnologia de criptografia e validação para criar uma plataforma justa e transparente.',
        jdbqkl: 'Blockchain JDB',
        douji: 'Briga de galo',
        doujidesc:
          'Exclusivo em toda a rede, altas taxas de retorno, interface simples e eficiente, ajudando você a começar facilmente!',
        svdouji: 'SV Briga de Galo',
        zq: 'Futebol',
        lq: 'Blueball',
        wq: 'Tênis',
        snk: 'Sinuca',
        pq: 'Voleibol',
        f1: 'Carro de corrida F1',
        bq: 'Beisebol',
        glq: 'Rugby',
        more: 'Mais',
        moreGame: 'mais jogos'
      },
      header: {
        recharge: 'depósito',
        withDraw: 'Saque',
        membershipCenter: 'Associação',
        helpCenter: 'Central de Ajuda',
        serviceCenter: 'Centro de serviço'
      },
      download: {
        minTitle:
          'Plataforma de apostas móveis para jogadores de rede completos',
        textTitle:
          'Jogue a qualquer hora, em qualquer lugar • Diversão sem limites • Seja como você quiser',
        description:
          'O principal aplicativo nativo de entretenimento do setor é suave e estável, conveniente e rápido. Forneça projetos de entretenimento, como eventos esportivos, entretenimento ao vivo, eventos de eletricidade, jogos de xadrez, apostas na loteria, entretenimento eletrônico e outro entretenimento. Sweep the Code Download, imediatamente possui!'
      },
      footer: { activeTitle: 'Associação' },
      vip: 'VIP Royal Club'
    },
    theme24_dz: {
      header: { download: '' },
      home: {
        downloadAppTxt1: '',
        downloadAppTxt2: '',
        downloadAppTxt3: '',
        description: {
          title0: '',
          description0: '',
          title1: '',
          description1: '',
          description2: '',
          title2: '',
          description3: '',
          description4: ''
        },
        midContent: { leftTitle: '' },
        footer: {
          bigTitle1: '',
          bigTitle2: '',
          bigTitle3: '',
          bigTitle4: '',
          bigTitle5: '',
          bigTitle6: '',
          bigTitle7: '',
          bigTitle8: '',
          bigTitle9: '',
          bigTitle10: '',
          minTitle1: '',
          minTitle2: '',
          minTitle3: '',
          minTitle4: '',
          minTitle5: '',
          minTitle6: '',
          minTitle7: '',
          minTitle8: '',
          bigTitle11: '',
          bigTitle12: '',
          platformTitle: '',
          tel: '',
          tg: ''
        }
      },
      aside: { yuebao: '' },
      tabbar: { service: '' }
    },
    theme21_dz: {
      footer: {
        hundredMillion: '100 milhões',
        seconds: 'Segundo',
        many: 'Lar',
        totalUser: 'Número cumulativo de usuários',
        saveTime: 'Tempo médio de depósito',
        withdrawTime: 'Tempo médio de retirada',
        partnerPlatform: 'Plataforma de jogo cooperativa',
        onlineServie: 'Serviço de atendimento ao cliente online',
        safeTitle: 'Segurança',
        safeDesc:
          'Usando canais de segurança criptografados (padrões de criptografia SSL de 256 bits) e sistema de gerenciamento de segurança rigoroso, os fundos de informações do cliente são a garantia mais completa.',
        gameTitle: 'Jogo maciço',
        gameDesc:
          'A plataforma de jogo mais completa do mundo, a equipe profissional protege você, 10.000 eletrônicos jogam com você, para que você tenha a experiência de jogo perfeita',
        fastTitle: 'Velocidade e conveniente',
        fastDesc:
          'A plataforma adota o mais recente sistema técnico de processamento financeiro desenvolvido independentemente para fornecer uma experiência de jogo de primeira classe e maximizar a latência da rede.',
        extrmTitle: 'Aproveite o extremo',
        extrmDesc:
          'O desenvolvimento autônomo de aplicativos completos permite que você aproveite a Web e o H5 e permita que você entregue apostas a qualquer hora, em qualquer lugar e apostas de entretenimento!',
        slogan:
          'Diferentes diferenças são conquistas extraordinárias extraordinárias',
        changeLang: 'Switch de idioma'
      },
      header: { searchHotGame: 'Pesquisa de jogo quente' }
    },
    theme20_dz: {
      licenseTitle: 'Licença qualificada',
      payMethods: 'Forma de pagamento',
      followUs: '',
      event: 'Eventos',
      waitingCollect: 'Pendente'
    },
    theme18_dz: {
      account: {
        myAccount: 'Número da minha conta',
        confirmLogin: 'Faça login na sua conta </br> primeiro'
      },
      mid: {
        task: 'Ganhe 1 milhão por mês',
        activityTitle: 'Recomendar amigos'
      },
      game: { noGame: 'Sem jogos disponíveis', searchHotGame: '', about: '' }
    },
    theme25_dz: {
      footer: {
        step1: 'Primeiro passo',
        step2: 'Passo 2',
        step3: 'Terceiro passo',
        context1: 'Registro',
        context2: 'Depósito',
        context3: 'Jogos eletronicos'
      }
    },
    theme35_dz: {
      game: { nav: { hello: 'Olá' } },
      download: {
        helpAndSupport: '',
        responsibleGaming: '',
        userAgient: '',
        bookName: '',
        project: '',
        payType: '',
        videoConcern: '',
        play: '',
        conditions: ''
      }
    },
    theme31_dz: {
      download: {
        title:
          'Baixe o APP e faça login para ganhar <span>R$100,00<span> grátis'
      },
      promote: {
        title: 'Convidar amigos',
        promoteShare: 'Link de Convite',
        myMoney: 'Comissão',
        myPerformance: 'Desempenho',
        myData: 'Meus Dados',
        linkTitle: 'Meu link',
        promoteTitle:
          'Promova clientes para se tornarem agentes, ganhe até 2,5% de comissão da agência e ganhe facilmente R$1.000.000,00 renda mensal',
        unloginTips: 'Faça login para obter o link do agente'
      }
    },
    officialChannel: {
      title: 'Canal Oficial',
      thirdPartyLogin: {
        facebook: 'Login do Facebook',
        google: 'Login do Google',
        line: 'Login do linha',
        wechat: 'Login do WeChat',
        qq: 'Login do QQ'
      }
    }
  }
}
